webpackJsonp([3],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export byId */
/* unused harmony export byClassName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return qs; });
/* unused harmony export qsa */
/* unused harmony export data */
/* unused harmony export toggleClass */
/* unused harmony export addClass */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasClass; });
/* unused harmony export toNodeList */
/* unused harmony export handleEvent */
/* unused harmony export createconfig */
/* unused harmony export stringToDOM */
/* unused harmony export index */
/* unused harmony export eq */
/* unused harmony export inViewport */
/* unused harmony export getDevice */
/* harmony export (immutable) */ __webpack_exports__["c"] = isMobile;
/* unused harmony export calculateRatio */
/* harmony export (immutable) */ __webpack_exports__["d"] = lerp;
/* harmony export (immutable) */ __webpack_exports__["h"] = viewportSize;
/* harmony export (immutable) */ __webpack_exports__["g"] = roundDec;
/* unused harmony export NodeList */
/* unused harmony export degrees */
/* unused harmony export radians */
/* harmony export (immutable) */ __webpack_exports__["f"] = revertSplit;
/* harmony export (immutable) */ __webpack_exports__["a"] = getRandom;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classie__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classie__);






var camelCaseRegExp = /-([a-z])/ig;
var toCamelCase = function toCamelCase(str) {
    return str.replace(camelCaseRegExp, function (match) {
        return match[1].toUpperCase();
    });
};

var byId = function byId(id) {
    return document.getElementById(id);
};

var byClassName = function byClassName(selector) {
    var ctx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

    Array.toArray(ctx.getElementsByClassName(selector));
};

var qs = function qs(selector) {
    var ctx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
    return ctx.querySelector(selector);
};

var qsa = function qsa(selector) {
    var ctx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default()(ctx.querySelectorAll(selector));
};

var data = function data(attr, ctx) {
    return ctx.hasAttribute('data-' + attr) ? ctx.getAttribute('data-' + attr) : '';
};

var toggleClass = function toggleClass(el, className, toggle) {
    var fn = toggle === undefined ? 'toggle' : toggle ? 'add' : 'remove'; //eslint-disable-line no-nested-ternary
    __WEBPACK_IMPORTED_MODULE_4_classie___default.a[fn](el, className);
};

var addClass = function addClass(el, className) {
    __WEBPACK_IMPORTED_MODULE_4_classie___default.a.add(el, className);
};

var hasClass = function hasClass(el, className) {
    return __WEBPACK_IMPORTED_MODULE_4_classie___default.a['has'](el, className);
};

var toNodeList = function toNodeList(elements) {
    return new NodeList(elements);
};

function handleEvent(eventName) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        onElement = _ref.onElement,
        withCallback = _ref.withCallback,
        _ref$useCapture = _ref.useCapture,
        useCapture = _ref$useCapture === undefined ? false : _ref$useCapture;

    var thisArg = arguments[2];

    var element = onElement || document.documentElement;

    function handler(event) {
        if (typeof withCallback === 'function') {
            withCallback.call(thisArg, event);
        }
    }

    handler.destroy = function destroy() {
        return element.removeEventListener(eventName, handler, useCapture);
    };

    element.addEventListener(eventName, handler, useCapture);
    return handler;
}

function createconfig() {
    var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var config = arguments[1];

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, config, o);
}

var stringToDOM = function stringToDOM() {
    var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var fragment = document.createDocumentFragment();
    var wrapper = fragment.appendChild(document.createElement('div'));

    wrapper.innerHTML = string.trim();
    return wrapper.children[0];
};

function index(element) {
    var sib = element.parentNode.childNodes;
    var n = 0;

    for (var i = 0; i < sib.length; i += 1) {
        if (sib[i] === element) return n;
        if (sib[i].nodeType === 1) n += 1;
    }

    return -1;
}

function eq(parent, i) {
    return i >= 0 && i < parent.length ? parent[i] : -1;
}

function inViewport(element) {
    var rect = element.getBoundingClientRect();
    var html = document.documentElement;

    return rect.top >= 0 && rect.top < html.clientHeight || rect.bottom >= 0 && rect.bottom < html.clientHeight;
}

function getDevice() {
    var device = window.getComputedStyle(document.body, '::after').getPropertyValue('content');
    device = device.replace(/('|")/g, '');

    return device;
}

function isMobile() {
    return !(getDevice() !== 'xs' && getDevice() !== 'sm');
}

function calculateRatio(width, height) {
    return width / height;
}

function lerp(a, b, n) {
    return (1 - n) * a + n * b;
}

function viewportSize() {
    var coords = {
        x: window.innerWidth,
        y: window.innerHeight,
        ratio: window.innerWidth / window.innerHeight
    };

    window.addEventListener('resize', function () {
        coords = {
            x: window.innerWidth,
            y: window.innerHeight,
            ratio: window.innerWidth / window.innerHeight
        };
    });

    return coords;
}

function roundDec(n) {
    return Math.round(n * 100) / 100;
}

var NodeList = function () {
    function NodeList(elements) {
        var ctx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NodeList);

        this.els = typeof elements === 'string' ? qsa(elements, ctx) : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default()(elements);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NodeList, [{
        key: 'toArray',
        value: function toArray() {
            return this.els;
        }
    }, {
        key: 'eq',
        value: function eq(index) {
            return this.els[index];
        }
    }, {
        key: 'indexOf',
        value: function indexOf(target) {
            return this.els.indexOf(target);
        }
    }, {
        key: 'attr',
        value: function attr(_attr, value) {
            var els = this.els;

            var attrStr = toCamelCase(_attr);
            if (value) {
                this.els.forEach(function (el) {
                    return el[attrStr] = value;
                });
                return this;
            }
            var el = els.length > 0 ? els[0] : undefined;
            var hook = NodeList.attrHooks[attrStr];
            if (!el) {
                return undefined;
            }
            return hook ? hook(el) : el[attrStr];
        }
    }, {
        key: 'addClass',
        value: function addClass(className) {
            this.els.forEach(function (el) {
                return __WEBPACK_IMPORTED_MODULE_4_classie___default.a.add(el, className);
            });
            return this;
        }
    }, {
        key: 'removeClass',
        value: function removeClass(className) {
            this.els.forEach(function (el) {
                return __WEBPACK_IMPORTED_MODULE_4_classie___default.a.remove(el, className);
            });
            return this;
        }
    }, {
        key: 'toggleClass',
        value: function toggleClass(className, toggle) {
            var fn = toggle === undefined ? 'toggle' : toggle ? 'add' : 'remove'; //eslint-disable-line no-nested-ternary
            this.els.forEach(function (el) {
                return __WEBPACK_IMPORTED_MODULE_4_classie___default.a[fn](el, className);
            });
            return this;
        }
    }]);

    return NodeList;
}();




NodeList.attrHooks = {
    'for': function _for(el) {
        return el.htmlFor;
    },
    'class': function _class(el) {
        return el.className;
    }
};

function degrees(radians) {
    return radians * 180 / Math.PI;
};

function radians(degrees) {
    return degrees * Math.PI / 180;
};

function revertSplit(el, content) {
    el.innerHTML = content;
};

function getRandom(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * VERSION: 0.5.7
 * DATE: 2017-06-19
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2017, GreenSock. All rights reserved.
 * SplitText is a Club GreenSock membership benefit; You must have a valid membership to use
 * this code without violating the terms of use. Visit http://greensock.com/club/ to sign up or get more details.
 * This work is subject to the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 */
var _gsScope = typeof module !== "undefined" && module.exports && typeof global !== "undefined" ? global : this || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node
(function (window) {

	"use strict";

	var _globals = window.GreenSockGlobals || window,
	    _namespace = function _namespace(ns) {
		var a = ns.split("."),
		    p = _globals,
		    i;
		for (i = 0; i < a.length; i++) {
			p[a[i]] = p = p[a[i]] || {};
		}
		return p;
	},
	    pkg = _namespace("com.greensock.utils"),
	    _getText = function _getText(e) {
		var type = e.nodeType,
		    result = "";
		if (type === 1 || type === 9 || type === 11) {
			if (typeof e.textContent === "string") {
				return e.textContent;
			} else {
				for (e = e.firstChild; e; e = e.nextSibling) {
					result += _getText(e);
				}
			}
		} else if (type === 3 || type === 4) {
			return e.nodeValue;
		}
		return result;
	},
	    _doc = document,
	    _getComputedStyle = _doc.defaultView ? _doc.defaultView.getComputedStyle : function () {},
	    _capsExp = /([A-Z])/g,
	    _getStyle = function _getStyle(t, p, cs, str) {
		var result;
		if (cs = cs || _getComputedStyle(t, null)) {
			t = cs.getPropertyValue(p.replace(_capsExp, "-$1").toLowerCase());
			result = t || cs.length ? t : cs[p]; //Opera behaves VERY strangely - length is usually 0 and cs[p] is the only way to get accurate results EXCEPT when checking for -o-transform which only works with cs.getPropertyValue()!
		} else if (t.currentStyle) {
			cs = t.currentStyle;
			result = cs[p];
		}
		return str ? result : parseInt(result, 10) || 0;
	},
	    _isArrayLike = function _isArrayLike(e) {
		return e.length && e[0] && (e[0].nodeType && e[0].style && !e.nodeType || e[0].length && e[0][0]) ? true : false; //could be an array of jQuery objects too, so accommodate that.
	},
	    _flattenArray = function _flattenArray(a) {
		var result = [],
		    l = a.length,
		    i,
		    e,
		    j;
		for (i = 0; i < l; i++) {
			e = a[i];
			if (_isArrayLike(e)) {
				j = e.length;
				for (j = 0; j < e.length; j++) {
					result.push(e[j]);
				}
			} else {
				result.push(e);
			}
		}
		return result;
	},
	    _stripExp = /(?:\r|\n|\t\t)/g,
	    //find carriage returns, new line feeds and double-tabs.
	_multipleSpacesExp = /(?:\s\s+)/g,
	    _emojiStart = 0xD800,
	    _emojiEnd = 0xDBFF,
	    _emojiLowStart = 0xDC00,
	    _emojiRegionStart = 0x1F1E6,
	    _emojiRegionEnd = 0x1F1FF,
	    _emojiModStart = 0x1f3fb,
	    _emojiModEnd = 0x1f3ff,
	    _emojiPairCode = function _emojiPairCode(s) {
		return (s.charCodeAt(0) - _emojiStart << 10) + (s.charCodeAt(1) - _emojiLowStart) + 0x10000;
	},
	    _isOldIE = _doc.all && !_doc.addEventListener,
	    _divStart = " style='position:relative;display:inline-block;" + (_isOldIE ? "*display:inline;*zoom:1;'" : "'"),
	    //note: we must use both display:inline-block and *display:inline for IE8 and earlier, otherwise it won't flow correctly (and if we only use display:inline, IE won't render most of the property tweens - very odd).
	_cssClassFunc = function _cssClassFunc(cssClass, tag) {
		cssClass = cssClass || "";
		var iterate = cssClass.indexOf("++") !== -1,
		    num = 1;
		if (iterate) {
			cssClass = cssClass.split("++").join("");
		}
		return function () {
			return "<" + tag + _divStart + (cssClass ? " class='" + cssClass + (iterate ? num++ : "") + "'>" : ">");
		};
	},
	    SplitText = pkg.SplitText = _globals.SplitText = function (element, vars) {
		if (typeof element === "string") {
			element = SplitText.selector(element);
		}
		if (!element) {
			throw "cannot split a null element.";
		}
		this.elements = _isArrayLike(element) ? _flattenArray(element) : [element];
		this.chars = [];
		this.words = [];
		this.lines = [];
		this._originals = [];
		this.vars = vars || {};
		this.split(vars);
	},
	    _swapText = function _swapText(element, oldText, newText) {
		var type = element.nodeType;
		if (type === 1 || type === 9 || type === 11) {
			for (element = element.firstChild; element; element = element.nextSibling) {
				_swapText(element, oldText, newText);
			}
		} else if (type === 3 || type === 4) {
			element.nodeValue = element.nodeValue.split(oldText).join(newText);
		}
	},
	    _pushReversed = function _pushReversed(a, merge) {
		var i = merge.length;
		while (--i > -1) {
			a.push(merge[i]);
		}
	},
	    _slice = function _slice(a) {
		//don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
		var b = [],
		    l = a.length,
		    i;
		for (i = 0; i !== l; b.push(a[i++])) {}
		return b;
	},
	    _isBeforeWordDelimiter = function _isBeforeWordDelimiter(e, root, wordDelimiter) {
		var next;
		while (e && e !== root) {
			next = e._next || e.nextSibling;
			if (next) {
				return next.textContent.charAt(0) === wordDelimiter;
			}
			e = e.parentNode || e._parent;
		}
		return false;
	},
	    _deWordify = function _deWordify(e) {
		var children = _slice(e.childNodes),
		    l = children.length,
		    i,
		    child;
		for (i = 0; i < l; i++) {
			child = children[i];
			if (child._isSplit) {
				_deWordify(child);
			} else {
				if (i && child.previousSibling.nodeType === 3) {
					child.previousSibling.nodeValue += child.nodeType === 3 ? child.nodeValue : child.firstChild.nodeValue;
				} else if (child.nodeType !== 3) {
					e.insertBefore(child.firstChild, child);
				}
				e.removeChild(child);
			}
		}
	},
	    _setPositionsAfterSplit = function _setPositionsAfterSplit(element, vars, allChars, allWords, allLines, origWidth, origHeight) {
		var cs = _getComputedStyle(element),
		    paddingLeft = _getStyle(element, "paddingLeft", cs),
		    lineOffsetY = -999,
		    borderTopAndBottom = _getStyle(element, "borderBottomWidth", cs) + _getStyle(element, "borderTopWidth", cs),
		    borderLeftAndRight = _getStyle(element, "borderLeftWidth", cs) + _getStyle(element, "borderRightWidth", cs),
		    padTopAndBottom = _getStyle(element, "paddingTop", cs) + _getStyle(element, "paddingBottom", cs),
		    padLeftAndRight = _getStyle(element, "paddingLeft", cs) + _getStyle(element, "paddingRight", cs),
		    lineThreshold = _getStyle(element, "fontSize") * 0.2,
		    textAlign = _getStyle(element, "textAlign", cs, true),
		    charArray = [],
		    wordArray = [],
		    lineArray = [],
		    wordDelimiter = vars.wordDelimiter || " ",
		    tag = vars.span ? "span" : "div",
		    types = vars.type || vars.split || "chars,words,lines",
		    lines = allLines && types.indexOf("lines") !== -1 ? [] : null,
		    words = types.indexOf("words") !== -1,
		    chars = types.indexOf("chars") !== -1,
		    absolute = vars.position === "absolute" || vars.absolute === true,
		    linesClass = vars.linesClass,
		    iterateLine = (linesClass || "").indexOf("++") !== -1,
		    spaceNodesToRemove = [],
		    i,
		    j,
		    l,
		    node,
		    nodes,
		    isChild,
		    curLine,
		    addWordSpaces,
		    style,
		    lineNode,
		    lineWidth,
		    offset;
		if (lines && element.children.length === 1 && element.children[0]._isSplit) {
			//lines are always split on the main element (not inside nested elements), so if there's only one child, bust apart lines inside that rather than forcing it all into one big line. Like <div><div>lots of stuff</div></div> - if they split the outer one, it'd all be in one line.
			element = element.children[0];
		}
		if (iterateLine) {
			linesClass = linesClass.split("++").join("");
		}

		//copy all the descendant nodes into an array (we can't use a regular nodeList because it's live and we may need to renest things)
		j = element.getElementsByTagName("*");
		l = j.length;
		nodes = [];
		for (i = 0; i < l; i++) {
			nodes[i] = j[i];
		}

		//for absolute positioning, we need to record the x/y offsets and width/height for every <div>. And even if we're not positioning things absolutely, in order to accommodate lines, we must figure out where the y offset changes so that we can sense where the lines break, and we populate the lines array.
		if (lines || absolute) {
			for (i = 0; i < l; i++) {
				node = nodes[i];
				isChild = node.parentNode === element;
				if (isChild || absolute || chars && !words) {
					offset = node.offsetTop;
					if (lines && isChild && Math.abs(offset - lineOffsetY) > lineThreshold && node.nodeName !== "BR") {
						//we found some rare occasions where a certain character like &#8209; could cause the offsetTop to be off by 1 pixel, so we build in a threshold.
						curLine = [];
						lines.push(curLine);
						lineOffsetY = offset;
					}
					if (absolute) {
						//record offset x and y, as well as width and height so that we can access them later for positioning. Grabbing them at once ensures we don't trigger a browser paint & we maximize performance.
						node._x = node.offsetLeft;
						node._y = offset;
						node._w = node.offsetWidth;
						node._h = node.offsetHeight;
					}
					if (lines) {
						if (node._isSplit && isChild || !chars && isChild || words && isChild || !words && node.parentNode.parentNode === element && !node.parentNode._isSplit) {
							curLine.push(node);
							node._x -= paddingLeft;
							if (_isBeforeWordDelimiter(node, element, wordDelimiter)) {
								node._wordEnd = true;
							}
						}
						if (node.nodeName === "BR" && node.nextSibling && node.nextSibling.nodeName === "BR") {
							//two consecutive <br> tags signify a new [empty] line.
							lines.push([]);
						}
					}
				}
			}
		}

		for (i = 0; i < l; i++) {
			node = nodes[i];
			isChild = node.parentNode === element;
			if (node.nodeName === "BR") {
				if (lines || absolute) {
					if (node.parentNode) {
						node.parentNode.removeChild(node);
					}
					nodes.splice(i--, 1);
					l--;
				} else if (!words) {
					element.appendChild(node);
				}
				continue;
			}

			if (absolute) {
				style = node.style;
				if (!words && !isChild) {
					node._x += node.parentNode._x;
					node._y += node.parentNode._y;
				}
				style.left = node._x + "px";
				style.top = node._y + "px";
				style.position = "absolute";
				style.display = "block";
				//if we don't set the width/height, things collapse in older versions of IE and the origin for transforms is thrown off in all browsers.
				style.width = node._w + 1 + "px"; //IE is 1px short sometimes. Avoid wrapping
				style.height = node._h + "px";
			}

			if (!words && chars) {
				//we always start out wrapping words in their own <div> so that line breaks happen correctly, but here we'll remove those <div> tags if necessary and renest the characters directly into the element rather than inside the word <div>
				if (node._isSplit) {
					node._next = node.nextSibling;
					node.parentNode.appendChild(node); //put it at the end to keep the order correct.
				} else if (node.parentNode._isSplit) {
					node._parent = node.parentNode;
					if (!node.previousSibling && node.firstChild) {
						node.firstChild._isFirst = true;
					}
					if (node.nextSibling && node.nextSibling.textContent === " " && !node.nextSibling.nextSibling) {
						//if the last node inside a nested element is just a space (like T<span>nested </span>), remove it otherwise it'll get placed in the wrong order. Don't remove it right away, though, because we need to sense when words/characters are before a space like _isBeforeWordDelimiter(). Removing it now would make that a false negative.
						spaceNodesToRemove.push(node.nextSibling);
					}
					node._next = node.nextSibling && node.nextSibling._isFirst ? null : node.nextSibling;
					node.parentNode.removeChild(node);
					nodes.splice(i--, 1);
					l--;
				} else if (!isChild) {
					offset = !node.nextSibling && _isBeforeWordDelimiter(node.parentNode, element, wordDelimiter); //if this is the last letter in the word (and we're not breaking by lines and not positioning things absolutely), we need to add a space afterwards so that the characters don't just mash together
					if (node.parentNode._parent) {
						node.parentNode._parent.appendChild(node);
					}
					if (offset) {
						node.parentNode.appendChild(_doc.createTextNode(" "));
					}
					if (vars.span) {
						node.style.display = "inline"; //so that word breaks are honored properly.
					}
					charArray.push(node);
				}
			} else if (node.parentNode._isSplit && !node._isSplit && node.innerHTML !== "") {
				wordArray.push(node);
			} else if (chars && !node._isSplit) {
				if (vars.span) {
					node.style.display = "inline";
				}
				charArray.push(node);
			}
		}

		i = spaceNodesToRemove.length;
		while (--i > -1) {
			spaceNodesToRemove[i].parentNode.removeChild(spaceNodesToRemove[i]);
		}

		if (lines) {
			//the next 7 lines just give us the line width in the most reliable way and figure out the left offset (if position isn't relative or absolute). We must set the width along with text-align to ensure everything works properly for various alignments.
			if (absolute) {
				lineNode = _doc.createElement(tag);
				element.appendChild(lineNode);
				lineWidth = lineNode.offsetWidth + "px";
				offset = lineNode.offsetParent === element ? 0 : element.offsetLeft;
				element.removeChild(lineNode);
			}
			style = element.style.cssText;
			element.style.cssText = "display:none;"; //to improve performance, set display:none on the element so that the browser doesn't have to worry about reflowing or rendering while we're renesting things. We'll revert the cssText later.
			//we can't use element.innerHTML = "" because that causes IE to literally delete all the nodes and their content even though we've stored them in an array! So we must loop through the children and remove them.
			while (element.firstChild) {
				element.removeChild(element.firstChild);
			}
			addWordSpaces = wordDelimiter === " " && (!absolute || !words && !chars);
			for (i = 0; i < lines.length; i++) {
				curLine = lines[i];
				lineNode = _doc.createElement(tag);
				lineNode.style.cssText = "display:block;text-align:" + textAlign + ";position:" + (absolute ? "absolute;" : "relative;");
				if (linesClass) {
					lineNode.className = linesClass + (iterateLine ? i + 1 : "");
				}
				lineArray.push(lineNode);
				l = curLine.length;
				for (j = 0; j < l; j++) {
					if (curLine[j].nodeName !== "BR") {
						node = curLine[j];
						lineNode.appendChild(node);
						if (addWordSpaces && node._wordEnd) {
							lineNode.appendChild(_doc.createTextNode(" "));
						}
						if (absolute) {
							if (j === 0) {
								lineNode.style.top = node._y + "px";
								lineNode.style.left = paddingLeft + offset + "px";
							}
							node.style.top = "0px";
							if (offset) {
								node.style.left = node._x - offset + "px";
							}
						}
					}
				}
				if (l === 0) {
					//if there are no nodes in the line (typically meaning there were two consecutive <br> tags, just add a non-breaking space so that things display properly.
					lineNode.innerHTML = "&nbsp;";
				} else if (!words && !chars) {
					_deWordify(lineNode);
					_swapText(lineNode, String.fromCharCode(160), " ");
				}
				if (absolute) {
					lineNode.style.width = lineWidth;
					lineNode.style.height = node._h + "px";
				}
				element.appendChild(lineNode);
			}
			element.style.cssText = style;
		}

		//if everything shifts to being position:absolute, the container can collapse in terms of height or width, so fix that here.
		if (absolute) {
			if (origHeight > element.clientHeight) {
				element.style.height = origHeight - padTopAndBottom + "px";
				if (element.clientHeight < origHeight) {
					//IE8 and earlier use a different box model - we must include padding and borders
					element.style.height = origHeight + borderTopAndBottom + "px";
				}
			}
			if (origWidth > element.clientWidth) {
				element.style.width = origWidth - padLeftAndRight + "px";
				if (element.clientWidth < origWidth) {
					//IE8 and earlier use a different box model - we must include padding and borders
					element.style.width = origWidth + borderLeftAndRight + "px";
				}
			}
		}
		_pushReversed(allChars, charArray);
		_pushReversed(allWords, wordArray);
		_pushReversed(allLines, lineArray);
	},
	    _splitRawText = function _splitRawText(element, vars, wordStart, charStart) {
		var tag = vars.span ? "span" : "div",
		    types = vars.type || vars.split || "chars,words,lines",
		    words = types.indexOf("words") !== -1,
		    chars = types.indexOf("chars") !== -1,
		    absolute = vars.position === "absolute" || vars.absolute === true,
		    wordDelimiter = vars.wordDelimiter || " ",
		    space = wordDelimiter !== " " ? "" : absolute ? "&#173; " : " ",
		    wordEnd = vars.span ? "</span>" : "</div>",
		    wordIsOpen = true,
		    text,
		    splitText,
		    i,
		    j,
		    l,
		    character,
		    hasTagStart,
		    emojiPair1,
		    emojiPair2,
		    container = _doc.createElement("div"),
		    parent = element.parentNode;

		parent.insertBefore(container, element);
		container.textContent = element.nodeValue;
		parent.removeChild(element);
		element = container;
		text = _getText(element);
		hasTagStart = text.indexOf("<") !== -1;

		if (vars.reduceWhiteSpace !== false) {
			text = text.replace(_multipleSpacesExp, " ").replace(_stripExp, "");
		}
		if (hasTagStart) {
			text = text.split("<").join("{{LT}}"); //we can't leave "<" in the string, or when we set the innerHTML, it can be interpreted as a node
		}
		l = text.length;
		splitText = (text.charAt(0) === " " ? space : "") + wordStart();
		for (i = 0; i < l; i++) {
			character = text.charAt(i);
			if (character === wordDelimiter && text.charAt(i - 1) !== wordDelimiter && i) {
				splitText += wordIsOpen ? wordEnd : "";
				wordIsOpen = false;
				while (text.charAt(i + 1) === wordDelimiter) {
					//skip over empty spaces (to avoid making them words)
					splitText += space;
					i++;
				}
				if (i === l - 1) {
					splitText += space;
				} else if (text.charAt(i + 1) !== ")") {
					splitText += space + wordStart();
					wordIsOpen = true;
				}
			} else if (character === "{" && text.substr(i, 6) === "{{LT}}") {
				splitText += chars ? charStart() + "{{LT}}" + "</" + tag + ">" : "{{LT}}";
				i += 5;
			} else if (character.charCodeAt(0) >= _emojiStart && character.charCodeAt(0) <= _emojiEnd || text.charCodeAt(i + 1) >= 0xFE00 && text.charCodeAt(i + 1) <= 0xFE0F) {
				//special emoji characters use 2 or 4 unicode characters that we must keep together.
				emojiPair1 = _emojiPairCode(text.substr(i, 2));
				emojiPair2 = _emojiPairCode(text.substr(i + 2, 2));
				j = emojiPair1 >= _emojiRegionStart && emojiPair1 <= _emojiRegionEnd && emojiPair2 >= _emojiRegionStart && emojiPair2 <= _emojiRegionEnd || emojiPair2 >= _emojiModStart && emojiPair2 <= _emojiModEnd ? 4 : 2;
				splitText += chars && character !== " " ? charStart() + text.substr(i, j) + "</" + tag + ">" : text.substr(i, j);
				i += j - 1;
			} else {
				splitText += chars && character !== " " ? charStart() + character + "</" + tag + ">" : character;
			}
		}
		element.outerHTML = splitText + (wordIsOpen ? wordEnd : "");
		if (hasTagStart) {
			_swapText(parent, "{{LT}}", "<"); //note: don't perform this on "element" because that gets replaced with all new elements when we set element.outerHTML.
		}
	},
	    _split = function _split(element, vars, wordStart, charStart) {
		var children = _slice(element.childNodes),
		    l = children.length,
		    absolute = vars.position === "absolute" || vars.absolute === true,
		    i,
		    child;

		if (element.nodeType !== 3 || l > 1) {
			vars.absolute = false;
			for (i = 0; i < l; i++) {
				child = children[i];
				if (child.nodeType !== 3 || /\S+/.test(child.nodeValue)) {
					if (absolute && child.nodeType !== 3 && _getStyle(child, "display", null, true) === "inline") {
						//if there's a child node that's display:inline, switch it to inline-block so that absolute positioning works properly (most browsers don't report offsetTop/offsetLeft properly inside a <span> for example)
						child.style.display = "inline-block";
						child.style.position = "relative";
					}
					child._isSplit = true;
					_split(child, vars, wordStart, charStart); //don't split lines on child elements
				}
			}
			vars.absolute = absolute;
			element._isSplit = true;
			return;
		}

		_splitRawText(element, vars, wordStart, charStart);
	},
	    p = SplitText.prototype;

	p.split = function (vars) {
		if (this.isSplit) {
			this.revert();
		}
		this.vars = vars = vars || this.vars;
		this._originals.length = this.chars.length = this.words.length = this.lines.length = 0;
		var i = this.elements.length,
		    tag = vars.span ? "span" : "div",
		    absolute = vars.position === "absolute" || vars.absolute === true,
		    wordStart = _cssClassFunc(vars.wordsClass, tag),
		    charStart = _cssClassFunc(vars.charsClass, tag),
		    origHeight,
		    origWidth,
		    e;
		//we split in reversed order so that if/when we position:absolute elements, they don't affect the position of the ones after them in the document flow (shifting them up as they're taken out of the document flow).
		while (--i > -1) {
			e = this.elements[i];
			this._originals[i] = e.innerHTML;
			origHeight = e.clientHeight;
			origWidth = e.clientWidth;
			_split(e, vars, wordStart, charStart);
			_setPositionsAfterSplit(e, vars, this.chars, this.words, this.lines, origWidth, origHeight);
		}
		this.chars.reverse();
		this.words.reverse();
		this.lines.reverse();
		this.isSplit = true;
		return this;
	};

	p.revert = function () {
		if (!this._originals) {
			throw "revert() call wasn't scoped properly.";
		}
		var i = this._originals.length;
		while (--i > -1) {
			this.elements[i].innerHTML = this._originals[i];
		}
		this.chars = [];
		this.words = [];
		this.lines = [];
		this.isSplit = false;
		return this;
	};

	SplitText.selector = window.$ || window.jQuery || function (e) {
		var selector = window.$ || window.jQuery;
		if (selector) {
			SplitText.selector = selector;
			return selector(e);
		}
		return typeof document === "undefined" ? e : document.querySelectorAll ? document.querySelectorAll(e) : document.getElementById(e.charAt(0) === "#" ? e.substr(1) : e);
	};
	SplitText.version = "0.5.7";
})(_gsScope);

//export to AMD/RequireJS and CommonJS/Node (precursor to full modular build system coming at a later date)
(function (name) {
	"use strict";

	var getGlobal = function getGlobal() {
		return (_gsScope.GreenSockGlobals || _gsScope)[name];
	};
	if (typeof module !== "undefined" && module.exports) {
		//node
		module.exports = getGlobal();
	} else if (true) {
		//AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (getGlobal),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
})("SplitText");
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Index__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_World__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_City__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_About__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_404__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_AddFace__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_LoadingError__ = __webpack_require__(633);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Index__["a" /* default */]
  }, {
    path: '/about',
    name: 'about',
    component: __WEBPACK_IMPORTED_MODULE_5__views_About__["a" /* default */]
  }, {
    path: '/add-your-face',
    name: 'addFace',
    component: __WEBPACK_IMPORTED_MODULE_7__views_AddFace__["a" /* default */]
  }, {
    path: '/world',
    name: 'world',
    component: __WEBPACK_IMPORTED_MODULE_3__views_World__["a" /* default */]
  }, {
    path: '/:city(tokyo|porto|berlin|milan|copenhagen)',
    name: 'city',
    component: __WEBPACK_IMPORTED_MODULE_4__views_City__["a" /* default */]
  }, {
    path: '/loading-error',
    name: 'loading-error',
    component: __WEBPACK_IMPORTED_MODULE_8__views_LoadingError__["a" /* default */]
  }, {
    path: '/*',
    name: 'ErrorPage',
    component: __WEBPACK_IMPORTED_MODULE_6__views_404__["a" /* default */]
  }]
}));

/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raf_loop__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raf_loop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_raf_loop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_events_mixin__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_events_mixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_events_mixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scripts_utils__ = __webpack_require__(5);



// import {
//   TextureLoader,
//   WebGLRenderer,
//   PerspectiveCamera,
//   Scene,
//   PlaneBufferGeometry,
//   Mesh,
//   MeshBasicMaterial,
// } from 'three';



// import round from 'lodash.round';



var Faces = function () {
  function Faces(options) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Faces);

    this.isEntered = false;
    this.$canvas = document.querySelector('#canvas');
    this.callback = options.callback;

    this.canvasH = this.$canvas.clientHeight;
    this.canvasW = this.$canvas.clientWidth;
    this.windowHalfX = window.innerWidth / 2;
    this.windowHalfY = window.innerHeight / 2;
    this.ctx = null;
    this.isMobile = Object(__WEBPACK_IMPORTED_MODULE_6__scripts_utils__["c" /* isMobile */])();

    // Load all the options
    this.columns = options.cols || 4;
    this.elements = options.elements || 1;
    this.perspective = options.perspective || 500;
    this.urlImg = options.urlImg;
    this.bgTexture = null;
    // Update to handle mouse movment scale
    this.mouseXScale = options.mouseXScale || 0.005;
    this.mouseYScale = options.mouseYScale || 0.008;
    this.mouseZScale = options.mouseZScale || 0.001;
    this.deviceMoveScaleX = options.deviceMoveScaleX || 4;
    this.deviceMoveScaleY = options.deviceMoveScaleY || 7;
    this.facesIteration = options.facesIteration + 1 || 4;
    this.sceneScale = options.sceneScale || 1;
    if (this.isMobile) this.sceneScale = options.mobileSceneScale || 1;

    // Internal properties for calculation
    this.mouseY = 0;
    this.mouseX = 0;
    this.isStarting = true;
    this.orientation = {
      x: 0,
      y: 0
    };
    this.parameters = [];
    this.alphas = [];
    this.zs = [];
    this.meshes = [];
    this.scales = {
      initial: 0,
      final: 0
    };
    this.three = null;

    __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 636)).then(function (three) {
      _this.three = three;

      _this.textureLoader = new _this.three.TextureLoader();
      _this.init();
    });
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Faces, [{
    key: 'init',
    value: function init() {
      var _this2 = this;

      var ratio = this.$canvas.clientWidth / this.$canvas.clientHeight;
      var FOV = 2 * Math.atan(window.innerHeight / (2 * this.perspective)) * (180 / Math.PI);
      this.camera = new this.three.PerspectiveCamera(FOV, ratio, 0.1, 5000);
      this.camera.position.z = this.perspective;

      // SCENE
      this.scene = new this.three.Scene();

      this.textureLoader.load("/static/img/faces/faceoftheworld_bg.png", function (bgTexture) {
        _this2.bgTexture = bgTexture;
        _this2.textureLoader.load(_this2.urlImg, function (texture) {
          _this2.loadMeshes(texture, _this2.facesIteration).then(function () {
            _this2.engine = __WEBPACK_IMPORTED_MODULE_4_raf_loop___default()(_this2.animate.bind(_this2));
            _this2.play();
            _this2.onEnter();
          });
        });
      });

      // RENDERER
      this.renderer = new this.three.WebGLRenderer({ alpha: true });
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.setSize(this.canvasW, this.canvasH);
      this.ctx = this.renderer.domElement;

      this.$canvas.appendChild(this.ctx);
      this.ctx.style.pointerEvents = 'none';

      this.callback();

      this.bindEvents();
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      this.onResize = this.onWindowResize.bind(this);
      window.addEventListener('resize', this.onResize);

      this.events = __WEBPACK_IMPORTED_MODULE_5_events_mixin___default()(window, this);
      var desktopEvents = {
        mousemove: 'onDocumentMouseMove'
        // touchstart: 'onDocumentTouchStart',
        // touchmove: 'onDocumentTouchMove',
      };

      window.addEventListener('deviceorientation', this.onOrientation.bind(this));
      // const deviceEvent = this.isMobile ? mobileEvents : desktopEvents;
      var deviceEvent = desktopEvents;
      // EVENTS
      if (!this.isMobile) this.events.bind(deviceEvent);
    }
  }, {
    key: 'onOrientation',
    value: function onOrientation(event) {
      if (this.isStarting) {
        this.isStarting = false;
        this.orientation = {
          x: Math.round(event.gamma),
          y: Math.round(event.beta)
        };
      }

      var xValue = (this.orientation.x - Math.round(event.gamma)) * this.deviceMoveScaleX;
      var yValue = (this.orientation.y - Math.round(event.beta)) * this.deviceMoveScaleY;

      this.mouseX = xValue;
      this.mouseY = -yValue;
    }
  }, {
    key: 'loadMeshes',
    value: function loadMeshes(texture, amount) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var size = 200;
        var baseDistance = _this3.isMobile ? -300 : 0;
        var step = size / amount;

        _this3.naturalSizes = {
          w: texture.image.naturalWidth,
          h: texture.image.naturalHeight
        };

        _this3.scales.initial = _this3.canvasH / _this3.naturalSizes.h * _this3.sceneScale;
        _this3.scales.final = _this3.scales.initial;
        _this3.realSizes = {
          w: _this3.naturalSizes.w * _this3.scales.final,
          h: _this3.naturalSizes.h * _this3.scales.final
        };

        for (var i = 0; i < amount; i += 1) {
          // const revertedIndex = Math.abs(i - textures.length);
          var geo = new _this3.three.PlaneBufferGeometry(texture.image.naturalWidth, texture.image.naturalHeight);

          // const alphaDelta = (0.8 - 0.3) / amount;
          var alphaDelta = 0.9 / amount;
          var alpha = 0.9 - alphaDelta * i;
          var z = Math.round(step * (i + 1) - step * (amount / 2)) + baseDistance;

          var materialOpts = {
            map: i != 0 ? texture : _this3.bgTexture,
            transparent: true
          };
          var material = new _this3.three.MeshBasicMaterial(materialOpts);
          var mesh = new _this3.three.Mesh(geo, material);

          _this3.alphas.unshift(i != 0 ? alpha : 1);
          _this3.zs.unshift(z);
          _this3.parameters.unshift({
            x: 0,
            y: 0,
            alpha: 0,
            z: z
          });

          _this3.scene.add(mesh);

          resolve();
        }
      });
    }
  }, {
    key: 'onEnter',
    value: function onEnter() {
      var _this4 = this;

      var tl = new __WEBPACK_IMPORTED_MODULE_3_gsap___default.a.TimelineMax({
        onComplete: function onComplete() {
          setTimeout(function () {
            _this4.isEntered = true;
          }, 500);
        }
      });

      var count = -1;
      tl.staggerTo(this.parameters, 0.5, {
        alpha: function alpha() {
          count += 1;
          return _this4.alphas[count];
        }
      }, 0.1);
    }
  }, {
    key: 'onWindowResize',
    value: function onWindowResize() {
      var SCREEN_WIDTH = this.$canvas.clientWidth;
      var SCREEN_HEIGHT = this.$canvas.clientHeight;
      this.renderer.setSize(SCREEN_WIDTH, SCREEN_HEIGHT);
      this.camera.aspect = SCREEN_WIDTH / SCREEN_HEIGHT;
      this.camera.updateProjectionMatrix();
    }
  }, {
    key: 'onDeviceRotation',
    value: function onDeviceRotation(e) {
      this.mouseX = 0;
      this.mouseY = 0;
    }
  }, {
    key: 'onDocumentMouseMove',
    value: function onDocumentMouseMove(e) {
      this.mouseX = e.clientX - this.windowHalfX;
      this.mouseY = e.clientY - this.windowHalfY;
    }
  }, {
    key: 'onDocumentTouchStart',
    value: function onDocumentTouchStart(e) {
      if (e.touches.length === 1) {
        e.preventDefault();
        this.mouseX = e.touches[0].pageX - this.windowHalfX;
        this.mouseY = e.touches[0].pageY - this.windowHalfY;
      }
    }
  }, {
    key: 'onDocumentTouchMove',
    value: function onDocumentTouchMove(e) {
      if (e.touches.length === 1) {
        e.preventDefault();
        this.mouseX = e.touches[0].pageX - this.windowHalfX;
        this.mouseY = e.touches[0].pageY - this.windowHalfY;
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      if (this.isEntered) {
        this.stop();
        this.engine = null;

        window.removeEventListener('resize', this.onResize);
        this.events.unbind();

        this.renderer.dispose();
        delete this.renderer;
        this.ctx.remove();
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (this.isEntered) this.engine.stop();
    }
  }, {
    key: 'play',
    value: function play() {
      this.engine.start();
    }
  }, {
    key: 'animate',
    value: function animate() {
      var _this5 = this;

      var deltaY = (this.mouseY / 4 - this.camera.position.y) * this.mouseYScale;
      var deltaX = (this.mouseX + this.camera.position.x) * this.mouseXScale;
      var normMouseX = this.mouseX / (window.innerWidth / 2);
      var deltaZ = (Math.cos(Math.PI * normMouseX) * 200 + 1000 - this.camera.position.z) * this.mouseZScale;
      // console.log('deltaZ: ', deltaZ, ' ', this.camera.position.z);

      // if (this.isEntered) {
      this.camera.position.x -= deltaX;
      this.camera.position.y += deltaY;
      // this.camera.position.z += deltaZ;

      // console.log('this.camera.position.x : ', this.camera.rotation.x);
      var rotationY = this.mouseX / (window.innerWidth / 2 / 0.05) * this.mouseYScale;
      var rotationX = this.mouseY / (window.innerWidth / 2 / 5) * this.mouseXScale;

      this.scene.children.forEach(function (el, i) {
        var element = el;
        // element.position.set(this.parameters[i].x, this.parameters[i].y, this.parameters[i].z);
        element.position.set(_this5.parameters[i].x -= deltaX / 10, _this5.parameters[i].y += deltaY / 4, _this5.parameters[i].z);
        element.scale.set(_this5.scales.final, _this5.scales.final, _this5.scales.final);
        element.material.opacity = _this5.parameters[i].alpha;
        element.rotation.set(rotationX, rotationY, 0);
      });

      this.camera.lookAt(this.scene.position);
      this.renderer.render(this.scene, this.camera);
    }
  }]);

  return Faces;
}();

/* harmony default export */ __webpack_exports__["a"] = (Faces);

/***/ }),
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state__ = __webpack_require__(547);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_5__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_lib_gsap_uncompressed_utils_SplitText__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_lib_gsap_uncompressed_utils_SplitText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_lib_gsap_uncompressed_utils_SplitText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_utils__ = __webpack_require__(5);






var lerp = function lerp(a, b, n) {
  return (1 - n) * a + n * b;
};
var animations = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();

animations.set('parallax', function (el) {
  var elH = el.parentElement.clientHeight;

  var offsetTopFromCenter = el.parentElement.getBoundingClientRect().top - (window.innerHeight - elH) / 2;
  var final = 1;

  var coefficent = el.getAttribute('data-parallax') !== null ? el.getAttribute('data-parallax') : 1;

  var maxY = Math.max(-window.innerHeight, offsetTopFromCenter);
  var baseTransform = Math.floor(Math.min(window.innerHeight, maxY), 2);

  var translateY = baseTransform * coefficent;

  final = lerp(final, translateY, 1);

  // el.style.transform = `translateY(${final}px)`;

  __WEBPACK_IMPORTED_MODULE_1_gsap___default.a.set(el, { y: final });
});

var offsets = [];
animations.set('parallaxIn', function (el, i) {
  // const elH = el.parentElement.clientHeight;

  // const offsetTopFromCenter = (el.parentElement.getBoundingClientRect().top -
  // ((window.innerHeight - elH) / 2));
  // let final = 1;

  // const coefficent = el.getAttribute('data-parallaxIn') !== null ? el.getAttribute('data-parallaxIn') : 1;

  // const maxY = Math.max(-window.innerHeight, offsetTopFromCenter);
  // const baseTransform = Math.floor(Math.min(window.innerHeight, maxY), 2);

  // const translateY = baseTransform * coefficent;

  // // final = lerp(final, translateY, 1);

  // // el.style.transform = `translateY(${final}px)`;

  // gsap.to(el, 0.3, { y: translateY, ease: gsap.Expo.easeOut });
  var bound = el.parentElement.getBoundingClientRect().top;
  var final = 1;

  if (!el.getAttribute('data-animated')) {
    el.setAttribute('data-animated', true);
    offsets[i] = bound;
  }

  var parallaxAttr = el.getAttribute('data-parallax');
  var elH = el.parentElement.clientHeight;
  var relativity = parallaxAttr === 'relative' ? offsets[i] : (window.innerHeight - elH) / 2;
  var offsetTop = bound - relativity;
  var coefficent = parallaxAttr !== null && parallaxAttr !== 'relative' ? parallaxAttr : 0.2;
  var maxY = Math.max(-window.innerHeight, offsetTop);
  var baseTransform = Math.floor(Math.min(window.innerHeight, maxY), 2);
  var translateY = baseTransform * parseFloat(coefficent);

  final = lerp(final, translateY, 1);
  __WEBPACK_IMPORTED_MODULE_1_gsap___default.a.set(el, { y: final });
});

animations.set('title', function (el) {
  var split = new __WEBPACK_IMPORTED_MODULE_2__assets_lib_gsap_uncompressed_utils_SplitText___default.a(el, { type: 'lines', linesClass: 'js-splittedlines' });

  var tl = new __WEBPACK_IMPORTED_MODULE_1_gsap___default.a.TimelineLite({ onComplete: function onComplete() {
      Object(__WEBPACK_IMPORTED_MODULE_3__scripts_utils__["f" /* revertSplit */])(el, split._originals[0]);
    } });

  tl.set(split.lines, {
    y: 50,
    skewX: -10,
    rotationZ: 5,
    autoAlpha: 0
  }).set(el, { autoAlpha: 1 }).staggerTo(split.lines, 1, {
    y: 0,
    skewX: 0,
    rotationZ: 0,
    autoAlpha: 1,
    ease: __WEBPACK_IMPORTED_MODULE_1_gsap___default.a.Expo.easeOut,
    clearProps: 'all'
  }, 0.1);
});

animations.set('text', function (el) {
  __WEBPACK_IMPORTED_MODULE_1_gsap___default.a.fromTo(el, 1.5, {
    yPercent: 10,
    skewY: 5,
    autoAlpha: 0,
    transformOrigin: '0 0'
  }, {
    yPercent: 0,
    skewY: 0,
    autoAlpha: 1,
    ease: __WEBPACK_IMPORTED_MODULE_1_gsap___default.a.Expo.easeOut,
    clearProps: 'all'
  });
});

animations.set('line', function (el) {
  var tl = new __WEBPACK_IMPORTED_MODULE_1_gsap___default.a.TimelineLite();

  tl.fromTo(el, 1.5, {
    scaleX: 0,
    autoAlpha: 0,
    transformOrigin: 0
  }, {
    scaleX: 1,
    autoAlpha: 1,
    ease: __WEBPACK_IMPORTED_MODULE_1_gsap___default.a.Expo.easeOut,
    clearProps: 'all'
  }, 0.1, '+=0');
});

animations.set('fade', function (el) {
  __WEBPACK_IMPORTED_MODULE_1_gsap___default.a.fromTo(el, 1.5, {
    yPercent: 10,
    autoAlpha: 0
  }, {
    yPercent: 0,
    autoAlpha: 1,
    ease: __WEBPACK_IMPORTED_MODULE_1_gsap___default.a.Expo.easeOut,
    clearProps: 'all'
  });
});

/* harmony default export */ __webpack_exports__["a"] = (animations);

/***/ }),
/* 148 */,
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cookie_law__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cookie_law___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cookie_law__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderComp__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Cursor__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ScreenSaver__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Favicon__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scripts_transitions__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scripts_utils__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',

  components: {
    HeaderComp: __WEBPACK_IMPORTED_MODULE_1__components_HeaderComp__["a" /* default */],
    Pointer: __WEBPACK_IMPORTED_MODULE_2__components_Cursor__["a" /* default */],
    ScreenSaver: __WEBPACK_IMPORTED_MODULE_3__components_ScreenSaver__["a" /* default */],
    Favicon: __WEBPACK_IMPORTED_MODULE_4__components_Favicon__["a" /* default */],
    CookieLaw: __WEBPACK_IMPORTED_MODULE_0_vue_cookie_law___default.a
  },

  data: function data() {
    return {
      isAnimating: false,
      isLoading: this.$route.name !== 'ErrorPage',
      loaderIsOut: this.$route.name === 'ErrorPage',
      windowH: window.innerHeight,
      isMobile: __WEBPACK_IMPORTED_MODULE_6__scripts_utils__["c" /* isMobile */]
    };
  },
  mounted: function mounted() {
    this.bindKeyboard();
  },


  methods: {
    hideLoader: function hideLoader() {
      this.isLoading = false;
      document.removeEventListener('keydown', this.handleKey);
    },
    bindKeyboard: function bindKeyboard() {
      var _this = this;

      this.handleKey = function (event) {
        return _this.clickKey(event);
      };
      document.addEventListener('keydown', this.handleKey);
    },
    clickKey: function clickKey(event) {
      if (event.which === 13) {
        this.hideLoader();
      }
    },
    enterLoader: function enterLoader(el, done) {
      var _this2 = this;

      this.isAnimating = true;

      var callback = function callback() {
        _this2.isAnimating = false;
        done();
      };

      __WEBPACK_IMPORTED_MODULE_5__scripts_transitions__["a" /* default */].get('loaderTransitionIn')(el, callback);
    },
    leaveLoader: function leaveLoader(el, done) {
      var _this3 = this;

      this.isAnimating = true;

      var callback = function callback() {
        _this3.loaderIsOut = true;
        _this3.isAnimating = false;
        done();
      };

      __WEBPACK_IMPORTED_MODULE_5__scripts_transitions__["a" /* default */].get('loaderTransitionOut')(el, callback);
    },
    transitionEnter: function transitionEnter(el, done) {
      __WEBPACK_IMPORTED_MODULE_5__scripts_transitions__["a" /* default */].get('pageTransition')(el, 'in', done);
    },
    transitionLeave: function transitionLeave(el, done) {
      __WEBPACK_IMPORTED_MODULE_5__scripts_transitions__["a" /* default */].get('pageTransition')(el, 'out', done);
    }
  }
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Logo__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ToggleAudio__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_HeaderVoice__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterAddFace__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scripts_utils__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HeaderComp',

  props: ['loaderIsOut'],

  watch: {
    loaderIsOut: function loaderIsOut(newVal) {
      if (newVal) this.enterHeader();
    }
  },

  data: function data() {
    return {
      voices: [{
        link: 'about',
        namespace: 'about',
        voice: 'About'
      }],

      isMobile: __WEBPACK_IMPORTED_MODULE_5__scripts_utils__["c" /* isMobile */]
    };
  },


  components: {
    Logo: __WEBPACK_IMPORTED_MODULE_1__components_Logo__["a" /* default */],
    ToggleAudio: __WEBPACK_IMPORTED_MODULE_2__components_ToggleAudio__["a" /* default */],
    HeaderVoice: __WEBPACK_IMPORTED_MODULE_3__components_HeaderVoice__["a" /* default */],
    FooterAddFace: __WEBPACK_IMPORTED_MODULE_4__components_FooterAddFace__["a" /* default */]
  },

  created: function created() {
    // if (isMobile()) {
    //   this.voices = [
    //     {
    //       link: 'about',
    //       namespace: 'about',
    //       voice: 'About',
    //     },
    //   ];
    // }
  },


  methods: {
    enterHeader: function enterHeader() {
      __WEBPACK_IMPORTED_MODULE_0_gsap___default.a.set(this.$refs.header, {
        autoAlpha: 1
      });
      __WEBPACK_IMPORTED_MODULE_0_gsap___default.a.fromTo('.header__item--logo', 0.5, {
        autoAlpha: 0
      }, {
        autoAlpha: 1,
        delay: 0.6
      });
    }
  }
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raf_loop__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raf_loop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raf_loop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_utils__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Logo',

  data: function data() {
    return {
      isMobile: __WEBPACK_IMPORTED_MODULE_1__scripts_utils__["c" /* isMobile */],
      image: null
    };
  },
  mounted: function mounted() {
    if (!this.isMobile()) this.inizializeSprite();
  },


  methods: {
    inizializeSprite: function inizializeSprite() {
      var _this = this;

      // Get canvas
      this.canvas = document.getElementById('sprite');
      this.canvas1 = document.getElementById('sprite-blue');

      this.index = 0;
      this.frameIndex = 0;
      this.tickCount = 0;

      this.ctx = this.canvas.getContext('2d');
      this.ctx1 = this.canvas1.getContext('2d');

      this.loop = __WEBPACK_IMPORTED_MODULE_0_raf_loop___default()(this.render.bind(this));
      this.ticksPerFrame = 0;
      this.numberOfFrames = 0;

      this.sprite = new Image();
      this.sprite.src = './static/img/logo/sprite-w.png';
      this.sprite1 = new Image();
      this.sprite1.src = './static/img/logo/sprite-b.png';

      this.image = new Image();
      this.image.src = './static/img/logo/single-img.png';

      this.image.onload = function () {
        _this.setDim();
        _this.render();
      };

      this.isAnimateIn = true;
      this.isAnimateOut = false;
    },
    setDim: function setDim() {
      this.col = 15;
      this.line = 15;

      var w = this.sprite.width / this.col === 0 ? 128 : this.sprite.width / this.col;
      var h = this.sprite.height / this.line === 0 ? 126 : this.sprite.height / this.line;

      this.canvas.width = w;
      this.canvas.height = h;
      this.canvas1.width = w;
      this.canvas1.height = h;

      this.numberOfFrames = this.col * this.line;

      this.frameWidth = w;
      this.frameHeight = h;

      this.scale = this.sprite.width / (this.canvas.width * this.col);
    },
    startRender: function startRender() {
      this.loop.start();
    },
    animateIn: function animateIn() {
      this.tickCount += 1;

      if (this.tickCount > this.ticksPerFrame) {
        this.tickCount = 0;

        // If the current frame index is in range
        if (this.frameIndex < this.numberOfFrames - 2) {
          this.frameIndex += 1;

          // Draw the animation
          this.sx = Math.floor(this.frameIndex % this.col) * this.frameWidth;
          this.sy = Math.floor(this.frameIndex / this.col) * this.frameHeight;

          // this.yPosition = (this.frameIndex * this.widths[this.index]) / this.numberOfFrames;
        } else {
          this.frameIndex = 0;
        }
      }
    },
    render: function render() {
      if (this.isAnimateIn) {
        this.animateIn();
      } else if (this.isAnimateOut) {
        this.animateOut();
      }

      // // Clear the canvas
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

      this.ctx1.clearRect(0, 0, this.canvas.width, this.canvas.height);

      this.ctx.drawImage(this.sprite, this.sx, this.sy, this.frameWidth, this.frameHeight, 0, 0, this.frameWidth, this.frameHeight);

      this.ctx1.drawImage(this.sprite1, this.sx, this.sy, this.frameWidth, this.frameHeight, 0, 0, this.frameWidth, this.frameHeight);
    },
    destroy: function destroy() {
      this.loop.stop();
    }
  }
});

/***/ }),
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_howler__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_howler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_howler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scripts_konami__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scripts_utils__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ToggleAudio',

  props: ['loaderIsOut'],

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
    videoIsPlaying: 'getStateVideo'
  })),

  watch: {
    loaderIsOut: function loaderIsOut(newVal) {
      if (newVal) this.enterAnimation();
    },
    videoIsPlaying: function videoIsPlaying(newVal) {
      if (this.$store.state.userStopAudio) return;

      if (newVal && this.played) {
        this.videoPlay();
      } else if (!newVal && !this.played) {
        this.videoPlay();
      }
    }
  },

  data: function data() {
    return {
      played: true,
      scales: [0.4, 0.3, 0.4, 0.3],
      lines: [],
      isMobile: __WEBPACK_IMPORTED_MODULE_6__scripts_utils__["c" /* isMobile */]
    };
  },
  mounted: function mounted() {
    if (!this.isMobile()) {
      var konami = new __WEBPACK_IMPORTED_MODULE_5__scripts_konami__["a" /* default */]();
      konami.init();

      window.addEventListener('konamiChange', this.konamiCode.bind(this));

      this.sound = new __WEBPACK_IMPORTED_MODULE_4_howler__["Howl"]({
        src: ['/static/audio/loop.webm', '/static/audio/loop.mp3'],
        autoplay: true,
        loop: true,
        volume: 0.1
      });
    }
  },


  methods: {
    buttonClick: function buttonClick() {
      this.played = !this.played;

      if (!this.played) {
        this.$store.commit('SET_STATEAUDIO', true);

        this.sound.pause();

        __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.to(this.lines, 0.5, {
          scaleY: 0.3,
          ease: __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.Power1.easeInOut
        });
      } else {
        this.$store.commit('SET_STATEAUDIO', false);

        this.sound.play();
        this.sound.fade(0, 0.1, 1000);

        __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.staggerTo(this.lines, 0.9, {
          scaleY: 1,
          repeat: -1,
          ease: __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.Power1.easeInOut,
          yoyo: true
        }, 0.3);
      }
    },
    videoPlay: function videoPlay() {
      this.played = !this.played;

      if (!this.played) {
        this.sound.fade(0.1, 0, 1000);

        __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.to(this.lines, 0.5, {
          scaleY: 0.3,
          ease: __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.Power1.easeInOut
        });
      } else {
        this.sound.fade(0, 0.1, 1000);

        __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.staggerTo(this.lines, 0.9, {
          scaleY: 1,
          repeat: -1,
          ease: __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.Power1.easeInOut,
          yoyo: true
        }, 0.3);
      }
    },
    enterAnimation: function enterAnimation() {
      var _this = this;

      this.lines = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.$el.querySelectorAll('[data-tline]'));

      __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.staggerFromTo(this.lines, 0.9, {
        scaleY: 0
      }, {
        scaleY: 1,
        ease: __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.Power1.easeInOut
      }, 0.3);
      __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.staggerTo(this.lines, 0.9, {
        scaleY: function scaleY(i) {
          return _this.scales[i];
        },
        repeat: -1,
        ease: __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.Power1.easeInOut,
        yoyo: true,
        delay: 0.9
      }, 0.3);
    },
    konamiCode: function konamiCode() {
      var _this2 = this;

      window.removeEventListener('konamiChange', this.konamiCode);
      this.gif = new Image();
      this.gif.src = '/static/img/extra/konami.gif';
      // this.gif.onload = (response) => {
      // };

      this.$parent.$parent.$el.appendChild(this.gif);

      __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.set(this.gif, {
        position: 'fixed',
        zIndex: 30,
        bottom: 0,
        left: '50%',
        marginLeft: '-83px',
        yPercent: 100,
        autoAlpha: 0
      });
      __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.to(this.gif, 1.2, {
        autoAlpha: 1,
        yPercent: 0,
        ease: __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.Power2.easeOut
      });

      this.yodeling = new __WEBPACK_IMPORTED_MODULE_4_howler__["Howl"]({
        src: ['/static/audio/yodeling.webm', '/static/audio/yodeling.mp3'],
        volume: 0.1,
        autoplay: true,
        onload: function onload() {
          _this2.sound.fade(0.1, 0, 2000);
          _this2.sound.pause();
          _this2.yodeling.fade(0, 0.1, 2000);
        },
        onend: function onend() {
          _this2.sound.play();
          _this2.sound.fade(0, 0.1, 2000);
          _this2.yodeling.unload();

          __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.to(_this2.gif, 0.6, {
            autoAlpha: 0,
            yPercent: 100,
            ease: __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.Power2.easeOut,
            onComplete: function onComplete() {
              _this2.$parent.$parent.$el.removeChild(_this2.gif);
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var SplitText = __webpack_require__(78); // eslint-disable-line


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HeaderVoice',

  props: ['data', 'loaderIsOut'],

  watch: {
    loaderIsOut: function loaderIsOut(newVal) {
      if (newVal) this.enterHeader();
    }
  },

  methods: {
    enterHeader: function enterHeader() {
      var text = this.$refs.voice.querySelector('[data-text]');
      var split = new SplitText(text, { type: 'chars' });
      var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap___default.a.TimelineMax({
        delay: 0.6,
        onComplete: function onComplete() {
          split.revert();
        }
      });

      tl.add('start').staggerFrom(split.chars, 0.8, {
        yPercent: 20,
        autoAlpha: 0,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap___default.a.Power2.easeInOut
      }, 0.01, 'start');
    },
    transitionEnter: function transitionEnter(el, done) {
      __WEBPACK_IMPORTED_MODULE_0_gsap___default.a.fromTo(el, 0.6, {
        autoAlpha: 0,
        yPercent: 20
      }, {
        autoAlpha: 1,
        yPercent: 0,
        clearProps: 'all',
        delay: 1,
        onComplete: done
      });
    },
    transitionLeave: function transitionLeave(el, done) {
      __WEBPACK_IMPORTED_MODULE_0_gsap___default.a.to(el, 0.6, {
        autoAlpha: 0,
        yPercent: 20,
        clearProps: 'all',
        onComplete: done
      });
    }
  }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var SplitText = __webpack_require__(78); // eslint-disable-line


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddFace',

  props: ['loaderIsOut'],

  watch: {
    loaderIsOut: function loaderIsOut(newVal) {
      if (newVal) this.enterHeader();
    }
  },

  methods: {
    enterHeader: function enterHeader() {
      var text = this.$el.querySelector('[data-text]');
      var split = new SplitText(text, { type: 'chars' });
      var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap___default.a.TimelineMax({
        delay: 0.6,
        onComplete: function onComplete() {
          split.revert();
        }
      });

      tl.add('start').staggerFrom(split.chars, 0.8, {
        yPercent: 20,
        autoAlpha: 0,
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap___default.a.Power2.easeInOut
      }, 0.01, 'start').from(this.$refs.plus, 1, {
        autoAlpha: 0
      }, 'start');
    }
  }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raf_loop__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raf_loop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_raf_loop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_eventer_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_eventer_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_eventer_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scripts_utils__ = __webpack_require__(5);


//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Pointer',

  props: ['isCursorReady'],

  data: function data() {
    return {
      buttons: null,

      mouse: { x: 0, y: 0 },
      interMouse: { x: 0, y: 0 },
      norm: { x: 0, y: 0 },

      magnetism: 5,
      attraction: 30,

      isLerp: true,
      lerp: __WEBPACK_IMPORTED_MODULE_6__scripts_utils__["d" /* lerp */],
      roundDec: __WEBPACK_IMPORTED_MODULE_6__scripts_utils__["g" /* roundDec */],
      isMobile: __WEBPACK_IMPORTED_MODULE_6__scripts_utils__["c" /* isMobile */],

      oldCtx: null,
      newCtx: null,

      visible: true
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])({
    stateCtx: 'getCtxButtons'
  })),

  watch: {
    stateCtx: function stateCtx(newCtx, oldCtx) {
      if (oldCtx !== null && !this.isMobile()) {
        var els = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(oldCtx.querySelectorAll('[data-mouse]'));
        this.removeButtonsEvents(els);
      }
      if (!this.isMobile()) {
        var _els = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(newCtx.querySelectorAll('[data-mouse]'));
        this.addButtonsEvents(_els);
      }
    }
  },

  mounted: function mounted() {
    if (!this.isMobile()) this.eventer = new __WEBPACK_IMPORTED_MODULE_4_eventer_js___default.a(true);

    if (!this.isMobile()) this.buttons = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(document.querySelectorAll('[data-mouse]'));

    if (!this.isMobile()) this.init();
  },


  methods: {
    init: function init() {
      this.bindEvents();

      this.engine = __WEBPACK_IMPORTED_MODULE_3_raf_loop___default()(this.renderer.bind(this)).start();
    },
    mousePosition: function mousePosition(event) {
      this.mouse = {
        x: event.clientX,
        y: event.clientY
      };
    },
    bindEvents: function bindEvents() {
      var _this = this;

      window.addEventListener('mousemove', this.mousePosition.bind(this));
      // this.eventer.bindEvent('mousemove', window, this.mousePosition.bind(this));

      this.addButtonsEvents(this.buttons);

      // battery works only chrome
      if (window.chrome && window.chrome.webstore && !Object(__WEBPACK_IMPORTED_MODULE_6__scripts_utils__["c" /* isMobile */])() || window.opr && window.opr.addons && !Object(__WEBPACK_IMPORTED_MODULE_6__scripts_utils__["c" /* isMobile */])()) {
        // eslint-disable-line
        navigator.getBattery().then(function (battery) {
          battery.addEventListener('chargingchange', function (status) {
            var power = true;
            if (!status.target.charging) power = false;
            _this.animateBattery(_this.$el, power);
          });
        });
      }
    },
    addButtonsEvents: function addButtonsEvents(btns) {
      var _this2 = this;

      btns.forEach(function (btn) {
        var state = btn.getAttribute('data-mouse-attractionState');
        var attraction = btn.getAttribute('data-mouse-attractionVal');

        _this2.handleMouseMove = _this2.setButtonPosition.bind(_this2);

        if (state === 'active' || state === true) _this2.eventer.bindEvent('mousemove', btn, function (event) {
          return _this2.handleMouseMove(event, btn, attraction);
        });
        _this2.eventer.bindEvent('mouseenter', btn, _this2.setHoverMouse.bind(_this2, btn));
        _this2.eventer.bindEvent('mouseleave', btn, _this2.resetButton.bind(_this2, btn, state));
      });
    },
    removeButtonsEvents: function removeButtonsEvents(btns) {
      var _this3 = this;

      btns.forEach(function (btn) {
        return _this3.eventer.clearAll(btn);
      });
    },
    renderer: function renderer() {
      this.setPos();
    },
    setPos: function setPos() {
      var lerpedX = Object(__WEBPACK_IMPORTED_MODULE_6__scripts_utils__["d" /* lerp */])(this.mouse.x, this.interMouse.x, 0.75);
      var lerpedY = Object(__WEBPACK_IMPORTED_MODULE_6__scripts_utils__["d" /* lerp */])(this.mouse.y, this.interMouse.y, 0.75);

      this.interMouse.x = this.isLerp ? lerpedX - this.norm.x / this.magnetism : this.mouse.x;
      this.interMouse.y = this.isLerp ? lerpedY - this.norm.y / this.magnetism : this.mouse.y;

      __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.set(this.$el, {
        x: this.interMouse.x,
        y: this.interMouse.y
      });
    },
    setHoverMouse: function setHoverMouse(el) {
      this.$el.setAttribute('data-hover', el.getAttribute('data-hover-type'));
    },
    setButtonPosition: function setButtonPosition(event, el, attraction) {
      this.dim = {
        x: el.clientWidth / 2,
        y: el.clientHeight / 2
      };

      this.norm = {
        x: Object(__WEBPACK_IMPORTED_MODULE_6__scripts_utils__["g" /* roundDec */])((event.offsetX - this.dim.x) / this.dim.x) * attraction,
        y: Object(__WEBPACK_IMPORTED_MODULE_6__scripts_utils__["g" /* roundDec */])((event.offsetY - this.dim.y) / this.dim.y) * attraction
      };

      this.animateButton(el);
    },
    animateButton: function animateButton(el) {
      __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.to(el, 0.5, {
        xPercent: this.norm.x,
        yPercent: this.norm.y
      });
    },
    animateBattery: function animateBattery(el, power) {
      var bounce = 3;

      if (!power) bounce = 0.2;

      __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.fromTo(el, 3, {
        scale: 1
      }, {
        scale: bounce,
        ease: __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.Bounce.easeOut,
        onComplete: function onComplete() {
          __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.to(el, 1, {
            scale: 1,
            clearPros: 'all',
            ease: __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.Bounce.easeOut
          });
        }
      });
    },
    resetButton: function resetButton(el, state) {
      this.$el.setAttribute('data-hover', '');

      if (state === 'active' || state) {
        this.norm = { x: 0, y: 0 };
        this.animateButton(el);
      }
    }
  }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scripts_marquee__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_utils__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ScreenSaver',
  data: function data() {
    return {
      timeoutID: null,
      marquee: null,

      screensaverStatus: false,

      screensaverTime: 120000,

      textColor: ['#fddfab', '#f2c699', '#d6b081', '#d0a972', '#d29b62', '#c18c60', '#b98458', '#ad784e', '#a26d41', '#955f39', '#8a5536', '#8a5536', '#804e35', '#6c472d', '#63432c', '#573728', '#402c23'],

      isMobile: __WEBPACK_IMPORTED_MODULE_1__scripts_utils__["c" /* isMobile */]
    };
  },
  mounted: function mounted() {
    this.screensaver();
  },


  methods: {
    screensaver: function screensaver() {
      document.body.addEventListener('mousemove', this.resetTimer, false);
      document.body.addEventListener('mousedown', this.resetTimer, false);
      document.body.addEventListener('keypress', this.resetTimer, false);
      document.body.addEventListener('DOMMouseScroll', this.resetTimer, false);
      document.body.addEventListener('touchmove', this.resetTimer, { passive: true });
      document.body.addEventListener('MSPointerMove', this.resetTimer, false);
      this.startTimer();
    },
    startTimer: function startTimer() {
      this.timeoutID = window.setTimeout(this.goInactive, this.screensaverTime);
    },
    resetTimer: function resetTimer() {
      window.clearTimeout(this.timeoutID);
      if (this.screensaverStatus) this.goActive();
      this.startTimer();
    },
    goInactive: function goInactive() {
      var _this = this;

      this.screensaverStatus = true;

      this.marquee = new __WEBPACK_IMPORTED_MODULE_0__scripts_marquee__["a" /* default */](Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["e" /* qs */])('.marquee', this.$el), this.textColor);
      this.marquee.init();

      Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["e" /* qs */])('video', this.$el).play();

      if (Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["c" /* isMobile */])()) {
        window.addEventListener('deviceorientation', function (event) {
          if (event.gamma || event.beta) {
            var xGamma = event.gamma * 0.5 || 0;
            var yBeta = event.beta * 0.5 || 0;

            Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["e" /* qs */])('video', _this.$el).style.transform = 'translate3d(' + xGamma + 'px, -' + yBeta + 'px, 0)';
            Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["e" /* qs */])('video', _this.$el).style.webkitTransform = 'translate3d(' + xGamma + 'px, -' + yBeta + 'px, 0)';
          }
        });
      }
    },
    goActive: function goActive() {
      this.$el.classList.remove('active');
      this.marquee.destroy();
      this.screensaverStatus = false;
      Object(__WEBPACK_IMPORTED_MODULE_1__scripts_utils__["e" /* qs */])('video', this.$el).pause(0);
    }
  },

  beforeDestroy: function beforeDestroy() {
    document.body.removeEventListener('mousemove', this.resetTimer);
    document.body.removeEventListener('mousedown', this.resetTimer);
    document.body.removeEventListener('keypress', this.resetTimer);
    document.body.removeEventListener('DOMMouseScroll', this.resetTimer);
    document.body.removeEventListener('touchmove', this.resetTimer);
    document.body.removeEventListener('MSPointerMove', this.resetTimer);
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);

//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Favicon',

  data: function data() {
    return {
      index: 0,
      speed: 300
    };
  },
  mounted: function mounted() {
    var canvas = this.$el;

    canvas.width = 32;
    canvas.height = 32;
    canvas.style.width = '16px';
    canvas.style.height = '16px';

    var ctx = canvas.getContext('2d');
    ctx.scale(2, 2);
    ctx.globalCompositeOperation = 'source-over';
    ctx.imageSmoothingQuality = 'high';

    var sprite = new Image();
    sprite.src = '/static/img/logo/sprite-favicon.png';

    this.init(ctx, sprite);
  },


  methods: {
    init: function init(ctx, sprite) {
      var _this = this;

      if (this.index > 1) {
        // smile
        this.speed = 9000;
        this.index = 0;
      } else {
        // blink
        this.speed = 300;
      }

      ctx.clearRect(0, 0, 32, 32);
      ctx.drawImage(sprite, 32 * this.index++, 0, 32, 32, 0, 0, 16, 16); // eslint-disable-line

      var favOrig = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(document.querySelectorAll('.favicon'));
      favOrig.forEach(function (favicon) {
        var favClone = favicon.cloneNode(true);
        favClone.setAttribute('href', ctx.canvas.toDataURL('image/png', 1));
        favicon.parentNode.replaceChild(favClone, favicon);
      });

      setTimeout(function () {
        _this.init(ctx, sprite);
      }, this.speed);
    }
  }
});

/***/ }),
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SliderTest__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_IndexFace__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FooterLegend__ = __webpack_require__(369);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',

  components: {
    SliderTest: __WEBPACK_IMPORTED_MODULE_3__components_SliderTest__["a" /* default */],
    IndexFace: __WEBPACK_IMPORTED_MODULE_4__components_IndexFace__["a" /* default */],
    FooterLegend: __WEBPACK_IMPORTED_MODULE_5__components_FooterLegend__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getCities'])),

  data: function data() {
    return {
      cities: [],
      entered: false
    };
  },
  mounted: function mounted() {
    this.entered = true;
    this.emptyFunction = function () {};
    document.addEventListener('keydown', this.emptyFunction);
  },
  created: function created() {
    var _this = this;

    if (this.$store.getters.getCities.length < 1) {
      this.$store.dispatch('FETCH_CITIES').then(function () {
        _this.cities = _this.getCities;
      });
    } else {
      this.cities = this.getCities;
    }
  },


  methods: {
    enter: function enter(el, done) {
      __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.fromTo(el, 1, {
        yPercent: -20,
        autoAlpha: 0
      }, {
        yPercent: 0,
        autoAlpha: 1,
        ease: __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.Expo.easeOut,
        clearProps: 'all',
        delay: 1,
        onComplete: done
      });
    },
    clickArrow: function clickArrow() {
      var e = new KeyboardEvent('keydown', { keyCode: 39, which: 39 });
      document.dispatchEvent(e);
    }
  },

  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.emptyFunction);
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raf_loop__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raf_loop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_raf_loop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_virtual_scroll__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_virtual_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_virtual_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hammerjs__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hammerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hammerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fontfaceobserver__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fontfaceobserver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_fontfaceobserver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scripts_utils__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Slider',

  props: ['cities'],

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getCity'])),

  data: function data() {
    return {
      scrollTarget: null,
      direction: 'left',
      scale: 0,
      scrollValue: 0,
      paddingRight: 45,
      oldScrollValue: 0,
      totalWidth: 0,
      windowH: 0,
      rotation: {
        val: -6
      },
      texts: [],
      lerp: 0.08,
      isMobile: __WEBPACK_IMPORTED_MODULE_7__scripts_utils__["c" /* isMobile */],
      handleKey: null
    };
  },
  created: function created() {
    var _this = this;

    this.cities.forEach(function (city) {
      _this.texts.push({
        title: city.title,
        id: city.id,
        state: city.state,
        scrollValue: 0,
        top: 0,
        left: 0,
        width: 0
      });
    });

    this.paddingRight = this.isMobile() ? 30 : 60;

    this.mobileFirstCheck = this.isMobile();
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$store.commit('ADD_BUTTONS', this.$el);

    var font = new __WEBPACK_IMPORTED_MODULE_6_fontfaceobserver___default.a('Neutral', {
      weight: 500
    });

    this.vs = new __WEBPACK_IMPORTED_MODULE_4_virtual_scroll___default.a({
      keyStep: -300,
      limitInertia: false,
      passive: true
    });

    this.hammer = new __WEBPACK_IMPORTED_MODULE_5_hammerjs___default.a(this.$el);
    this.arrow = document.querySelector('.arrow-scroll');
    this.hammerArrow = new __WEBPACK_IMPORTED_MODULE_5_hammerjs___default.a(this.arrow);

    this.setSlider();

    font.load().then(function () {
      _this2.resize();
      _this2.addEvents();

      _this2.animateInSlider();
    }, function () {
      _this2.resize();
      _this2.addEvents();

      _this2.animateInSlider();
    });
  },


  methods: {
    resize: function resize() {
      this.contW = this.$el.clientWidth;

      this.scrollTarget = null;
      this.oldScrollValue = 0;
      this.scrollValue = 0;

      this.setTop();
      this.setPos();

      this.update();
    },
    addEvents: function addEvents() {
      var _this3 = this;

      if (!this.isMobile()) {
        this.vs.on(this.onScroll, this);
      } else {
        this.hammer.on('swipe', this.onScroll.bind(this));
        this.hammer.get('pinch').set({ enable: true });

        this.handleScroll = function () {
          var a = {
            direction: 2,
            deltaX: -10,
            velocity: 5
          };

          _this3.onScroll(a);
        };
        this.hammerArrow.on('tap', this.handleScroll);
      }
      this.engine = __WEBPACK_IMPORTED_MODULE_3_raf_loop___default()(this.update.bind(this));
      this.engine.start();

      window.addEventListener('resize', this.resize.bind(this));
    },
    removeEvents: function removeEvents() {
      if (!this.isMobile()) {
        this.vs.off(this.onScroll);
      } else {
        this.hammer.off('swipe', this.onScroll.bind(this));
        this.hammer.get('pinch').set({ enable: false });
        this.hammerArrow.off('tap', this.handleScroll);
      }
      this.engine.stop();
      this.engine = null;

      window.removeEventListener('resize', this.resize.bind(this));
    },
    setTop: function setTop() {
      var _this4 = this;

      this.windowH = window.innerHeight;

      this.texts.forEach(function (el) {
        var text = el;

        text.el = _this4.$el.querySelector('[data-hover="' + text.title + '"]').parentElement;
        var textH = text.el.clientHeight;
        var top = Math.round(_this4.windowH / 2 - textH / 1.5);

        text.top = top;
      });
    },
    setPos: function setPos() {
      var _this5 = this;

      var left = 0;
      this.totalWidth = 0;

      this.texts.forEach(function (el) {
        var text = el;

        text.left = left;
        text.width = text.el.clientWidth;

        left += text.width;

        _this5.totalWidth += text.width;
      });
    },
    onScroll: function onScroll(e) {
      if (!this.mobileFirstCheck) {
        this.direction = this.oldScrollValue > this.scrollValue ? 'left' : 'right';
      } else {
        this.direction = e.direction === 2 ? 'left' : 'right';
      }

      if (!this.mobileFirstCheck) this.scrollTarget += -e.deltaY || e.deltaX * 5;
      if (this.mobileFirstCheck) this.scrollTarget += e.deltaX * Math.abs(e.velocity * 4);
    },
    update: function update() {
      var _this6 = this;

      this.oldScrollValue = this.scrollValue;
      this.scrollValue += (this.scrollTarget - this.scrollValue) * this.lerp;

      if (this.oldScrollValue === this.scrollValue) return;

      var sign = this.direction === 'left' ? -1 : 1;
      this.scale = sign * Math.min(Math.abs(Math.round((this.scrollValue - this.oldScrollValue) / 2)), 80);

      this.texts.forEach(function (el) {
        var text = el;
        _this6.checkInfinite(text);
      });
    },
    checkInfinite: function checkInfinite(el) {
      var text = el;

      var condition = this.direction === 'left' ? text.left + this.scrollValue + text.width < 0 : text.left + this.scrollValue > this.contW;

      var calc = this.direction === 'left' ? text.left + this.totalWidth : text.left - this.totalWidth;

      text.left = condition ? calc : text.left;
    },
    setSlider: function setSlider() {
      __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.set(this.$el, { autoAlpha: 0 });
    },
    animateInSlider: function animateInSlider() {
      var _this7 = this;

      var tl = new __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.TimelineLite();

      tl.to(this, 0.1, {
        scrollValue: '+=300',
        ease: __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.Expo.easeOut
      }).add(function () {
        _this7.setPos();
      }).to(this.$el, 0.5, { autoAlpha: 1 });
    },
    clickVoice: function clickVoice() {
      this.$el.classList.add('no-pointer');
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.removeEvents();
  }
});

/***/ }),
/* 175 */,
/* 176 */,
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scripts_faces__ = __webpack_require__(112);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IndexFace',

  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    var _this = this;

    setTimeout(function () {
      _this.faces.destroy();
    }, 1400);
  },


  methods: {
    init: function init() {
      this.faces = new __WEBPACK_IMPORTED_MODULE_0__scripts_faces__["a" /* default */]({
        cols: 4,
        elements: 12,
        urlImg: '/static/img/faces/faceoftheworld_load.jpg',
        perspective: 1000,
        callback: this.setScale
      });
    },
    setScale: function setScale() {
      var el = this.faces.ctx;

      el.style.transform = 'scale(6)';
    }
  }
});

/***/ }),
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Legend'
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf_loop__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf_loop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raf_loop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WorldFace__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scripts_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_data_world_json__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_data_world_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_data_world_json__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'World',

  components: {
    WorldFace: __WEBPACK_IMPORTED_MODULE_3__components_WorldFace__["a" /* default */]
  },

  data: function data() {
    return {
      list: __WEBPACK_IMPORTED_MODULE_5__assets_data_world_json___default.a,
      texts: [],
      isMobile: __WEBPACK_IMPORTED_MODULE_4__scripts_utils__["c" /* isMobile */],
      scrollValue: 0,
      totalWidth: 0
    };
  },
  created: function created() {
    var _this = this;

    this.list.forEach(function (el) {
      _this.texts.push({
        title: el,
        left: 0,
        width: 0
      });
    });
  },
  mounted: function mounted() {
    this.$store.commit('ADD_BUTTONS', this.$el);
    __WEBPACK_IMPORTED_MODULE_1_gsap___default.a.set('.slider__list', { opacity: 0 });
    __WEBPACK_IMPORTED_MODULE_1_gsap___default.a.to('.slider__list', 0.5, {
      opacity: 1,
      delay: 0.8,
      clearProps: 'all'
    });

    // const font = new FontFaceObserver('Neutral', {
    //   weight: 500,
    // });

    this.setEls();
    this.engine = __WEBPACK_IMPORTED_MODULE_2_raf_loop___default()(this.renderer).start();

    // font.load().then(() => {
    //   this.resize();
    //   this.addEvents();

    //   this.animateInSlider();
    // }, () => {
    //   this.resize();
    //   this.addEvents();

    //   this.animateInSlider();
    // });
  },


  methods: {
    renderer: function renderer() {
      var _this2 = this;

      this.scrollValue += 2;

      this.texts.forEach(function (el) {
        if (_this2.scrollValue - el.left > el.width) {
          el.left = _this2.totalWidth;
          _this2.totalWidth = _this2.totalWidth + el.width;
        }
      });
    },
    setEls: function setEls() {
      var _this3 = this;

      var nodes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.$el.querySelectorAll('.list__item'));
      var left = 0;
      this.totalWidth = 0;

      this.texts.forEach(function (el) {
        el.node = nodes.find(function (node) {
          return node.innerText === el.title;
        });
        el.left = left;
        el.width = el.node.clientWidth;

        el.node.style.left = left + 'px';

        left += el.width;
        _this3.totalWidth += el.width;
      });
    },
    resize: function resize() {
      this.contW = this.$el.clientWidth;

      this.scrollTarget = null;
      this.oldScrollValue = 0;
      this.scrollValue = 0;

      this.setPos();

      this.update();
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.engine.stop();
    this.engine = null;
  }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scripts_faces__ = __webpack_require__(112);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cityFace',

  data: function data() {
    return {
      entered: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.intersectionObserver = new IntersectionObserver(function (entries) {
      if (_this.entered) _this.faces.stop();
      if (entries[0].intersectionRatio <= 0) return;
      if (!_this.entered) {
        _this.init();
        _this.entered = true;
      } else {
        _this.faces.play();
      }
    });

    this.intersectionObserver.observe(this.$el);
  },
  beforeDestroy: function beforeDestroy() {
    var _this2 = this;

    setTimeout(function () {
      _this2.faces.destroy();
    }, 1400);
  },


  methods: {
    init: function init() {
      this.faces = new __WEBPACK_IMPORTED_MODULE_0__scripts_faces__["a" /* default */]({
        cols: 4,
        elements: 12,
        urlImg: '/static/img/faces/faceoftheworld.png',
        callback: this.setScale,
        mouseXScale: 0.005,
        mouseYScale: 0.008,
        mouseZScale: 0, // Don't move the face on the z axis
        facesIteration: 2,
        perspective: 1000,
        sceneScale: 1.3,
        mobileSceneScale: 1.5
      });
    },
    setScale: function setScale() {
      var el = this.faces.ctx;

      el.style.transform = 'scale(1)';
    }
  }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gsap__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_smooth_scrollbar__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Hero__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ProgressBar__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Intro__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Quote__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Description__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Map__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_CityFace__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Diary__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_PhotoSlider__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Closing__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Video__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_CityFooter__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__scripts_animations__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__scripts_utils__ = __webpack_require__(5);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//























/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'city',

  components: {
    Hero: __WEBPACK_IMPORTED_MODULE_11__components_Hero__["a" /* default */],
    ProgressBar: __WEBPACK_IMPORTED_MODULE_12__components_ProgressBar__["a" /* default */],
    Intro: __WEBPACK_IMPORTED_MODULE_13__components_Intro__["a" /* default */],
    Quote: __WEBPACK_IMPORTED_MODULE_14__components_Quote__["a" /* default */],
    Description: __WEBPACK_IMPORTED_MODULE_15__components_Description__["a" /* default */],
    Map: __WEBPACK_IMPORTED_MODULE_16__components_Map__["a" /* default */],
    CityFace: __WEBPACK_IMPORTED_MODULE_17__components_CityFace__["a" /* default */],
    Diary: __WEBPACK_IMPORTED_MODULE_18__components_Diary__["a" /* default */],
    PhotoSlider: __WEBPACK_IMPORTED_MODULE_19__components_PhotoSlider__["a" /* default */],
    Closing: __WEBPACK_IMPORTED_MODULE_20__components_Closing__["a" /* default */],
    Video: __WEBPACK_IMPORTED_MODULE_21__components_Video__["a" /* default */],
    CityFooter: __WEBPACK_IMPORTED_MODULE_22__components_CityFooter__["a" /* default */]
  },

  data: function data() {
    return {
      page: null,
      dataPage: false,
      parallaxEls: null,
      heroIn: false,
      lengthBar: 0,
      skewBar: 0,
      prevDir: 'up',
      prevValDir: 0,
      lastTime: Date.now(),
      lastOffset: 0,
      reduceAmount: 0
    };
  },
  created: function created() {
    this.page = this.$route.params.city;
  },


  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapGetters */])(['getDataCity']), {
    reorderComponent: function reorderComponent() {
      this.dataPage = this.$store.getters.getDataCity(this.page).data;
      return this.dataPage.composition.sort(function (a, b) {
        return a.order - b.order;
      });
    }
  }),

  mounted: function mounted() {
    this.menu = document.querySelector('header');
    if (Object(__WEBPACK_IMPORTED_MODULE_24__scripts_utils__["b" /* hasClass */])(this.menu, 'hide')) this.menu.classList.remove('hide');
    if (Object(__WEBPACK_IMPORTED_MODULE_24__scripts_utils__["b" /* hasClass */])(this.menu, 'theme-dark')) this.menu.classList.remove('theme-dark');

    this.$store.commit('ADD_BUTTONS', this.$el);

    var DisableScrollPlugin = function (_ScrollbarPlugin) {
      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(DisableScrollPlugin, _ScrollbarPlugin);

      function DisableScrollPlugin() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, DisableScrollPlugin);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DisableScrollPlugin.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(DisableScrollPlugin)).apply(this, arguments));
      }

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(DisableScrollPlugin, [{
        key: 'transformDelta',
        value: function transformDelta(delta) {
          if (this.options.direction) {
            delta[this.options.direction] = 0;
          }
          return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, delta);
        }
      }]);

      return DisableScrollPlugin;
    }(__WEBPACK_IMPORTED_MODULE_9_smooth_scrollbar__["a" /* ScrollbarPlugin */]);

    DisableScrollPlugin.pluginName = 'disableScroll';
    DisableScrollPlugin.defaultOptions = {
      direction: 'x'
    };

    __WEBPACK_IMPORTED_MODULE_9_smooth_scrollbar__["b" /* default */].use(DisableScrollPlugin);

    var scrollbar = this.$el.querySelector('.scrollbar');
    this.scrollbar = new __WEBPACK_IMPORTED_MODULE_9_smooth_scrollbar__["b" /* default */](scrollbar);

    this.parallaxEls = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.$el.querySelectorAll('[data-parallax]'));
    this.animEls = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.$el.querySelectorAll('[data-anim]'));
    __WEBPACK_IMPORTED_MODULE_7_gsap___default.a.set(this.animEls, { autoAlpha: 0 });

    this.scrollbar.addListener(this.scrollHandler.bind(this));

    this.setEnter();
  },


  methods: {
    setEnter: function setEnter() {
      __WEBPACK_IMPORTED_MODULE_7_gsap___default.a.set('.introduction', {
        webkitClipPath: 'polygon(0% 0%, 85% 10%, 100% 100%, 0% 100%)'
      });

      __WEBPACK_IMPORTED_MODULE_7_gsap___default.a.set('.page-city__cont', {
        scaleX: 0,
        backgroundColor: 'transparent',
        transformOrigin: '0 0'
      });
      __WEBPACK_IMPORTED_MODULE_7_gsap___default.a.set('.intro__title', {
        autoAlpha: 0
      });
    },
    heroEntered: function heroEntered() {
      this.heroIn = true;

      this.enterPage();
    },
    enterPage: function enterPage() {
      var arr1 = [75, 5, 10];
      var arr2 = [100, 0, 0];

      arr2.onUpdate = function () {
        __WEBPACK_IMPORTED_MODULE_7_gsap___default.a.set('.introduction', {
          webkitClipPath: 'polygon(0% 0%, ' + arr1[0] + '% 0%, 100% 100%, 0% 100%)'
        });
      };

      __WEBPACK_IMPORTED_MODULE_7_gsap___default.a.to(arr1, 0.7, arr2).eventCallback('onComplete', function () {
        __WEBPACK_IMPORTED_MODULE_7_gsap___default.a.set('.introduction', { clearProps: 'all' });
      });
      __WEBPACK_IMPORTED_MODULE_7_gsap___default.a.to('.page-city__cont', 1, {
        scaleX: 1,
        clearProps: 'all',
        ease: __WEBPACK_IMPORTED_MODULE_7_gsap___default.a.Expo.easeOut,
        onComplete: function onComplete() {
          var title = document.querySelector('.intro__title');
          __WEBPACK_IMPORTED_MODULE_23__scripts_animations__["a" /* default */].get('text')(title);
        }
      });
    },
    scrollHandler: function scrollHandler() {
      var _this2 = this;

      this.lengthBar = (this.scrollbar.offset.y / this.scrollbar.limit.y).toFixed(2);
      this.checkMenu();
      this.setSkewBar();

      this.parallaxEls.forEach(function (el) {
        if (_this2.scrollbar.isVisible(el)) {
          __WEBPACK_IMPORTED_MODULE_23__scripts_animations__["a" /* default */].get('parallax')(el);
        }
      });

      this.animEls.forEach(function (animEl) {
        var type = animEl.getAttribute('data-anim');

        if (_this2.scrollbar.isVisible(animEl) && !animEl.hasAttribute('data-animated')) {
          var offsetEl = animEl.getBoundingClientRect().top;

          if (offsetEl <= window.innerHeight / 1.3) {
            animEl.setAttribute('data-animated', '');

            __WEBPACK_IMPORTED_MODULE_23__scripts_animations__["a" /* default */].get(type)(animEl);
          }
        }
      });
    },
    checkMenu: function checkMenu() {
      this.direction = this.prevValDir < this.scrollbar.offset.y ? 'down' : 'up';

      this.prevValDir = this.scrollbar.offset.y;

      if (this.scrollbar.offset.y > Object(__WEBPACK_IMPORTED_MODULE_24__scripts_utils__["h" /* viewportSize */])().y - 160 && !Object(__WEBPACK_IMPORTED_MODULE_24__scripts_utils__["b" /* hasClass */])(this.menu, 'theme-dark')) {
        this.menu.classList.add('theme-dark');
      } else if (this.scrollbar.offset.y < Object(__WEBPACK_IMPORTED_MODULE_24__scripts_utils__["h" /* viewportSize */])().y - 160 && Object(__WEBPACK_IMPORTED_MODULE_24__scripts_utils__["b" /* hasClass */])(this.menu, 'theme-dark')) {
        this.menu.classList.remove('theme-dark');
      }

      if (this.direction === 'down' && !Object(__WEBPACK_IMPORTED_MODULE_24__scripts_utils__["b" /* hasClass */])(this.menu, 'hide') && this.scrollbar.offset.y > Object(__WEBPACK_IMPORTED_MODULE_24__scripts_utils__["h" /* viewportSize */])().y / 2) {
        this.menu.classList.add('hide');
      } else if (this.direction === 'up' && Object(__WEBPACK_IMPORTED_MODULE_24__scripts_utils__["b" /* hasClass */])(this.menu, 'hide')) {
        this.menu.classList.remove('hide');
      }
    },
    setSkewBar: function setSkewBar() {
      var current = Date.now();
      var offset = this.scrollbar.offset.y;
      var duration = current - this.lastTime;

      if (!duration || offset === this.lastOffset) return;

      if (duration > 100) {
        this.reduceAmount += duration - 1;
        duration -= duration - 1;
      }

      var velocity = (offset - this.lastOffset) / duration;
      this.lastTime = current;
      this.lastOffset = offset;

      var skew = Math.min(Math.abs(velocity) * 50, 60);
      this.skewBar = this.direction === 'up' ? skew : skew * -1;
    }
  },

  beforeDestroy: function beforeDestroy() {
    var _this3 = this;

    this.scrollbar.removeListener(this.scrollHandler);

    setTimeout(function () {
      if (Object(__WEBPACK_IMPORTED_MODULE_24__scripts_utils__["b" /* hasClass */])(_this3.menu, 'hide')) _this3.menu.classList.remove('hide');
      if (Object(__WEBPACK_IMPORTED_MODULE_24__scripts_utils__["b" /* hasClass */])(_this3.menu, 'theme-dark')) _this3.menu.classList.remove('theme-dark');

      _this3.scrollbar.destroy();
    }, 1400);
  },
  beforeRouteEnter: function beforeRouteEnter(from, to, next) {
    var city = !to.params.city ? from.params.city : to.params.city;
    document.querySelector('body').classList.add('wait');

    if (!__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.getDataCity(city)) {
      __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].dispatch('FETCH_DATACITY', city).then(function () {
        next(function (vm) {
          vm.dataPage = vm.getDataCity(vm.page).data;
        });
      });
    } else {
      next(function (vm) {
        vm.dataPage = vm.getDataCity(vm.page).data;
      });
    }
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var city = !to.params.city ? from.params.city : to.params.city;

    if (!__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.getDataCity(city)) {
      __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].dispatch('FETCH_DATACITY', city).then(function () {
        next(function (vm) {
          vm.dataPage = vm.getDataCity(vm.page).data;
        });
      });
    } else {
      next(function (vm) {
        vm.dataPage = vm.getDataCity(vm.page).data;
      });
    }
  }
});

/***/ }),
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_lib_video_pixirenderer__ = __webpack_require__(235);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__webpack_require__(92);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Hero',

  props: ['heroEntered'],

  data: function data() {
    return {
      canvas: null,
      hero: {},
      firstAnim: true
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getDataCityComponent']), {
    switchImg: function switchImg() {
      if (window.chrome && window.chrome.webstore || window.opr && window.opr.addons) {
        return this.hero.url + '.webp';
      }
      return this.hero.url + '.jpg';
    }
  }),

  created: function created() {
    this.hero = this.getDataCityComponent(this.$route.params.city, 'hero');

    this.canvas = document.createElement('canvas');
    this.canvas.id = 'video-canvas';
    this.canvas.style.position = 'absolute';
    // this.canvas.style.zIndex = '1';
  },
  mounted: function mounted() {
    var _this = this;

    this.enterAnimation(this.heroEntered);

    var img = this.obtainImg();

    new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      _this.PIXIRenderers = new __WEBPACK_IMPORTED_MODULE_4__assets_lib_video_pixirenderer__["a" /* default */](_this.canvas, img, resolve);
    }).then(function () {
      _this.animateInCnv();
    });
  },


  methods: {
    enterAnimation: function enterAnimation(callback) {
      var title = this.$el.querySelector('.hero__title');
      var img = this.$el.querySelector('.hero__figure');

      __WEBPACK_IMPORTED_MODULE_3_gsap___default.a.set(img, { opacity: 0 });

      __WEBPACK_IMPORTED_MODULE_3_gsap___default.a.set(title, {
        yPercent: 0,
        xPercent: -50,
        rotation: 0,
        skewY: 5,
        autoAlpha: 0,
        transformOrigin: '0 0'
      });

      __WEBPACK_IMPORTED_MODULE_3_gsap___default.a.to(img, 0.5, { opacity: 1, delay: 0.7 });

      setTimeout(function () {
        callback();
      }, 1800);

      __WEBPACK_IMPORTED_MODULE_3_gsap___default.a.to(title, 1, {
        yPercent: -50,
        skewY: 0,
        rotation: '-6deg',
        autoAlpha: 1,
        delay: 1,
        ease: __WEBPACK_IMPORTED_MODULE_3_gsap___default.a.Expo.easeOut
      });
    },
    injectCanvas: function injectCanvas(index, canvas) {
      var cont = this.$el.querySelector('.hero__figure');
      cont.appendChild(canvas);
    },
    animateInCnv: function animateInCnv() {
      var _this2 = this;

      this.PIXIRenderers.setTexture(0);

      this.injectCanvas(1, this.canvas);

      this.intersectionObserver = new IntersectionObserver(function (entries) {
        if (entries[0].intersectionRatio <= 0) {
          _this2.PIXIRenderers.stop();
        } else {
          var timing = _this2.firstAnim ? 2 : 0.1;
          _this2.PIXIRenderers.phaseIn(timing, true);
          _this2.firstAnim = false;
        }
      });

      this.intersectionObserver.observe(this.$el);
    },
    obtainImg: function obtainImg() {
      if (window.chrome && window.chrome.webstore || window.opr && window.opr.addons) {
        return this.hero.url + '.webp';
      }
      return this.hero.url + '.jpg';
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.PIXIRenderers.destroy();
    this.intersectionObserver.unobserve(this.$el);
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf_loop__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf_loop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raf_loop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_gsap__);



// import * as PIXI from 'pixi.js';


var basicPhase = 0.75;

var PIXIRender = function () {
  function PIXIRender(canvas, data, callback) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PIXIRender);

    this.canvas = canvas;
    this.isEnter = false;

    __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 637)).then(function (pixi) {
      _this.PIXI = pixi;
      _this.PIXI.utils.skipHello();

      _this.PIXI.utils.skipHello();

      _this.renderer = _this.PIXI.autoDetectRenderer({
        view: canvas,
        transparent: true,
        antialias: true
      });

      _this.stage = new _this.PIXI.Container();
      _this.textures = [];

      _this.loadTextures(data);

      _this.phase = basicPhase;

      _this.paused = true;
      _this.loopStarted = false;

      _this.uniforms = {
        video: _this.textures[0],
        time: 0,
        phase: basicPhase,
        aspectRatio: 1
      };

      var vs = __webpack_require__(550);
      var fs = __webpack_require__(551);

      _this.isEnter = true;
      _this.generateShader(vs, fs);
      _this.setTexture(0);

      document.addEventListener('resize', _this.resize.bind(_this));

      callback();
    });
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PIXIRender, [{
    key: 'reset',
    value: function reset() {
      if (this.tween) {
        __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenLite"].killTweensOf(this.tween);
        __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenLite"].killTweensOf(this.canvastween);
      }

      this.phase = basicPhase;
      __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenLite"].set(this.canvas, { autoAlpha: 1 });
    }
  }, {
    key: 'phaseOut',
    value: function phaseOut(timing) {
      var _this2 = this;

      if (this.tween) {

        __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenLite"].killTweensOf(this.tween);
        __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenLite"].killTweensOf(this.canvastween);
      }

      this.start();

      this.tween = __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenLite"].to(this, timing, { phase: -0.2 });
      this.canvastween = __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenLite"].to(this.canvas, timing, {
        autoAlpha: 0,
        onComplete: function onComplete() {
          _this2.stop();
        }
      });
    }
  }, {
    key: 'phaseIn',
    value: function phaseIn(timing, force) {
      var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      if (this.tween) {
        __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenLite"].killTweensOf(this.tween);
        __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenLite"].killTweensOf(this.canvastween);
      }

      if (force) {
        this.phase = 0;
        __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenLite"].set(this.canvas, { autoAlpha: 0 });
      }

      this.start();

      this.tween = __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenLite"].to(this, timing, {
        phase: basicPhase,
        delay: delay
      });
      this.canvastween = __WEBPACK_IMPORTED_MODULE_3_gsap__["TweenLite"].to(this.canvas, timing, {
        autoAlpha: 1,
        delay: delay
      });
    }
  }, {
    key: 'start',
    value: function start() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.loopStarted = true;

      if (this.paused == true) {
        if (this.tween) {
          this.tween.kill();
          this.canvastween.kill();
        }

        this.loop = __WEBPACK_IMPORTED_MODULE_2_raf_loop___default()(this.renderEvent = this.update.bind(this));
        this.loop.start();

        this.paused = false;
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.loopStarted = false;
      if (this.paused == false) {
        this.loop.stop();

        this.paused = true;
      }
    }
  }, {
    key: 'update',
    value: function update() {
      this.uniforms.phase = this.phase;

      this.uniforms.time += 0.032;

      this.renderer.render(this.stage);
    }
  }, {
    key: 'setTexture',
    value: function setTexture(index) {
      if (!this.isEnter) return;
      this.resize();

      this.shader.uniforms.video = this.textures[index];
    }
  }, {
    key: 'loadTextures',
    value: function loadTextures(data) {
      // let i = 0;
      // while(i < data.length) {
      //   let texture = new this.PIXI.Texture.fromImage(this.coverUrl(data[i].cover));

      //   this.textures.push(texture);

      //   i++
      // }
      var texture = new this.PIXI.Texture.fromImage(this.coverUrl(data));

      this.textures.push(texture);
    }
  }, {
    key: 'generateShader',
    value: function generateShader(vs, fs) {
      var indices = [0, 1, 2, 0, 2, 3];

      var positions = [];
      positions = positions.concat([-1, 1, 0]);
      positions = positions.concat([1, 1, 0]);
      positions = positions.concat([1, -1, 0]);
      positions = positions.concat([-1, -1, 0]);

      var geometry = new this.PIXI.mesh.Geometry();

      geometry.addAttribute('positions', positions, 3);
      geometry.addAttribute('aUV', [0, 0, 1, 0, 1, 1, 0, 1], 2);
      geometry.addIndex(indices);

      this.shader = new this.PIXI.Shader.from(vs, fs, this.uniforms);
      this.mesh = new this.PIXI.mesh.RawMesh(geometry, this.shader);

      this.stage.addChild(this.mesh);
    }
  }, {
    key: 'coverUrl',
    value: function coverUrl(cover) {
      return cover;
    }
  }, {
    key: 'resize',
    value: function resize() {
      if (this.canvas.parentElement && this.isEnter) {
        var w = this.canvas.parentElement.clientWidth;
        var h = this.canvas.parentElement.clientHeight;

        this.renderer.resize(w, h);

        this.mesh.shader.uniforms.aspectRatio = w / h;
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      if (this.loopStarted) this.loop.stop();
      document.removeEventListener('resize', this.resize);
    }
  }]);

  return PIXIRender;
}();

/* harmony default export */ __webpack_exports__["a"] = (PIXIRender);

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressBar_vue__ = __webpack_require__(237);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_576920ad_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressBar_vue__ = __webpack_require__(554);
function injectStyle (ssrContext) {
  __webpack_require__(553)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-576920ad"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_576920ad_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProgressBar',

  props: ['lengthBar', 'skewBar']
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_eventer_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_eventer_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_eventer_js__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Intro',

  data: function data() {
    return {
      intro: {}
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getDataCityComponent'])),

  created: function created() {
    this.intro = this.getDataCityComponent(this.$route.params.city, 'intro');

    this.eventer = new __WEBPACK_IMPORTED_MODULE_4_eventer_js___default.a(true);
  },
  mounted: function mounted() {
    var _this = this;

    this.links = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.$el.querySelectorAll('[data-customlink]'));

    if (this.links.length > 0) {
      this.links.forEach(function (link) {
        _this.eventer.bindEvent('click', link, _this.handleClick);
      });
    }
  },


  methods: {
    handleClick: function handleClick() {
      event.preventDefault();
      var url = event.target.getAttribute('href');

      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push(url);
    }
  },

  beforeDestroy: function beforeDestroy() {
    var _this2 = this;

    if (this.links.length > 0) {
      this.links.forEach(function (link) {
        _this2.eventer.clearAll(link);
      });
    }
  }
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quote_vue__ = __webpack_require__(240);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2a9d60e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quote_vue__ = __webpack_require__(559);
function injectStyle (ssrContext) {
  __webpack_require__(558)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a2a9d60e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quote_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2a9d60e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quote_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Quote',

  props: ['data'],

  data: function data() {
    return {
      quote: {}
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getDataCityComponent']), {
    switchImg: function switchImg() {
      if (window.chrome && window.chrome.webstore || window.opr && window.opr.addons) {
        return this.quote.url + '.webp';
      }
      return this.quote.url + '.jpg';
    }
  }),

  created: function created() {
    if (this.$store.state.route.name === 'about') {
      this.quote = this.data;
    } else {
      this.quote = this.getDataCityComponent(this.$route.params.city, 'quote');
    }
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DescriptionBox__ = __webpack_require__(562);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Description',

  components: {
    DescriptionBox: __WEBPACK_IMPORTED_MODULE_2__components_DescriptionBox__["a" /* default */]
  },

  data: function data() {
    return {
      description: {}
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getDataCityComponent'])),

  created: function created() {
    this.description = this.getDataCityComponent(this.$route.params.city, 'description');
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DescriptionBox',

  props: ['data'],

  computed: {
    getRandomInt: function getRandomInt() {
      var min = 0.02;
      var max = 0.08;
      return Math.random() * (max - min) + min;
    },
    switchImg: function switchImg() {
      if (window.chrome && window.chrome.webstore || window.opr && window.opr.addons) {
        return this.data.url + '.webp';
      }
      return this.data.url + '.jpg';
    }
  }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MapContainer__ = __webpack_require__(568);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Map',

  components: {
    MapContainer: __WEBPACK_IMPORTED_MODULE_2__components_MapContainer__["a" /* default */]
  },

  data: function data() {
    return {
      map: {}
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getDataCityComponent'])),

  created: function created() {
    this.map = this.getDataCityComponent(this.$route.params.city, 'map');
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MapContainer',

  props: ['image'],

  computed: {
    switchImg: function switchImg() {
      if (window.chrome && window.chrome.webstore || window.opr && window.opr.addons) {
        return this.image.url + '.webp';
      }
      return this.image.url + '.jpg';
    }
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scripts_faces__ = __webpack_require__(112);
//
//
//
//
//
//
//
//



__webpack_require__(92);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cityFace',

  data: function data() {
    return {
      entered: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.intersectionObserver = new IntersectionObserver(function (entries) {
      if (_this.entered) _this.faces.stop();
      if (entries[0].intersectionRatio <= 0) return;
      if (!_this.entered) {
        _this.init();
        _this.entered = true;
      } else {
        _this.faces.play();
      }
    });

    this.intersectionObserver.observe(this.$el);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      var faceUrl = this.$store.state.dataPageCities.find(function (page) {
        return page.id === _this2.$store.state.route.params.city;
      }).data.cityface.url;
      this.faces = new __WEBPACK_IMPORTED_MODULE_0__scripts_faces__["a" /* default */]({
        cols: 4,
        elements: 12,
        urlImg: faceUrl + '.jpg',
        callback: this.setScale,
        perspective: 1600,
        facesIteration: 2,
        sceneScale: 0.45,
        mobileSceneScale: 0.6
      });
    },
    setScale: function setScale() {
      var el = this.faces.ctx;

      el.style.transform = 'scale(1)';
    }
  },

  beforeDestroy: function beforeDestroy() {
    if (this.entered) {
      this.faces.destroy();
      this.intersectionObserver.unobserve(this.$el);
    }
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Diary',

  data: function data() {
    return {
      colLeft: {},
      colRight: {}
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getDataCityComponent']), {
    switchImg: function switchImg() {
      if (window.chrome && window.chrome.webstore || window.opr && window.opr.addons) {
        return this.colRight.url + '.webp';
      }
      return this.colRight.url + '.jpg';
    }
  }),

  created: function created() {
    var data = this.getDataCityComponent(this.$route.params.city, 'diary');

    this.colLeft = data.colLeft;
    this.colRight = data.colRight;
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hammerjs__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hammerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hammerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scripts_utils__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PhotoSlider',

  data: function data() {
    return {
      currentNumber: 0,
      images: [],
      extension: '.jpg',
      isFirst: true,
      direction: null,
      isMobile: __WEBPACK_IMPORTED_MODULE_4__scripts_utils__["c" /* isMobile */]
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getDataCityComponent'])),

  created: function created() {
    this.images = this.getDataCityComponent(this.$route.params.city, 'photoslider');

    this.extension = this.switchExtension();
  },
  mounted: function mounted() {
    this.hammer = new __WEBPACK_IMPORTED_MODULE_3_hammerjs___default.a(this.$el.querySelector('.slider'));

    this.bindEvents();
  },


  methods: {
    next: function next() {
      if (this.isFirst) {
        __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.set('.slider', { backgroundColor: 'black' });
        this.isFirst = false;
      }

      this.currentNumber += 1;
      this.direction = 'next';
    },
    bindEvents: function bindEvents() {
      if (this.isMobile()) this.hammer.on('swiperight', this.next.bind(this));
      if (this.isMobile()) this.hammer.on('swipeleft', this.prev.bind(this));
    },
    unbindEvents: function unbindEvents() {
      if (this.isMobile()) this.hammer.off('swiperight');
      if (this.isMobile()) this.hammer.off('swipeleft');
    },
    prev: function prev() {
      if (this.isFirst) {
        __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.set('.slider', { backgroundColor: 'black' });
        this.isFirst = false;
      }

      this.currentNumber -= 1;
      this.direction = 'prev';
    },
    enter: function enter(el, done) {
      var slide = el.querySelector('.slider__image');
      var clip = this.direction === 'next' ? 'inset(0% 100% 0.01% 0%)' : 'inset(0% 0.01% 0% 100%)';

      __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.fromTo(el, 0.5, {
        webkitClipPath: clip,
        clipPath: clip
      }, {
        webkitClipPath: 'inset(0.01% 0.02% 0.03% 0.04%)',
        clipPath: 'inset(0.01% 0.02% 0.03% 0.04%)',
        clearProps: 'all',
        delay: 0.2,
        onComplete: done
      });

      __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.from(slide, 0.5, { autoAlpha: 0, scale: 1.3, delay: 0.1 });
    },
    leave: function leave(el, done) {
      var slide = el.querySelector('.slider__image');
      var clip = this.direction === 'prev' ? 'inset(0% 100% 0% 0.01%)' : 'inset(0% 0.01% 0% 100%)';

      __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.fromTo(el, 0.5, {
        webkitClipPath: 'inset(0.01% 0.02% 0.03% 0.04%)',
        clipPath: 'inset(0.01% 0.02% 0.03% 0.04%)'
      }, {
        webkitClipPath: clip,
        clipPath: clip,
        clearProps: 'all',
        onComplete: done
      });

      __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.to(slide, 0.5, { autoAlpha: 0, scale: 0.9, delay: 0.1 });
    },
    switchExtension: function switchExtension() {
      if (window.chrome && window.chrome.webstore || window.opr && window.opr.addons) {
        return '.webp';
      }
      return '.jpg';
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.unbindEvents();
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Closing',

  data: function data() {
    return {
      closing: {}
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getDataCityComponent'])),

  created: function created() {
    this.closing = this.getDataCityComponent(this.$route.params.city, 'closing');
  }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Videoplayer__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_lib_video_pixirenderer__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scripts_utils__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









__webpack_require__(92);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Video',

  components: {
    Videoplayer: __WEBPACK_IMPORTED_MODULE_4__components_Videoplayer__["a" /* default */]
  },

  data: function data() {
    return {
      canvas: null,
      isVideoPlaying: false,
      dataVideo: {},
      entered: false,
      enter: false,
      isMobile: __WEBPACK_IMPORTED_MODULE_6__scripts_utils__["c" /* isMobile */]
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getDataCityComponent'])),

  created: function created() {
    this.dataVideo = this.getDataCityComponent(this.$route.params.city, 'video');

    this.needsUpdate = false;
    this.isVideoPlaying = false;
    this.canvas = document.createElement('canvas');
    this.canvas.id = 'video-canvas';
    this.canvas.style.position = 'absolute';
    this.canvas.style.zIndex = '1';
  },
  mounted: function mounted() {
    var _this = this;

    var animateInCnv = function animateInCnv() {
      _this.PIXIRenderers.setTexture(0);

      _this.injectCanvas(1, _this.canvas);

      _this.intersectionObserver = new IntersectionObserver(function (entries) {
        if (_this.entered) _this.PIXIRenderers.phaseOut(0.5, true);

        if (entries[0].intersectionRatio <= 0) return;

        if (_this.entered) _this.PIXIRenderers.phaseIn(0.1, true);

        if (!_this.entered) {
          _this.entered = true;

          _this.$set(_this.$el, 'pause', true);

          _this.injectCanvas(1, _this.canvas);

          _this.PIXIRenderers.phaseIn(1.5, true);

          __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.fromTo(entries[0].target, 0.5, {
            webkitClipPath: 'inset(0.01% 100% 0.03% 0.04%)',
            scale: 1.3
          }, {
            webkitClipPath: 'inset(0.01% 0.02% 0.03% 0.04%)',
            clearProps: 'webkitClipPath',
            scale: 1,
            delay: 0.5,
            onComplete: function onComplete() {
              _this.enter = true;
            }
          });
        }
      });

      _this.intersectionObserver.observe(_this.$el);
    };

    var img = this.switchImg();

    var loadLib = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      _this.PIXIRenderers = new __WEBPACK_IMPORTED_MODULE_5__assets_lib_video_pixirenderer__["a" /* default */](_this.canvas, img, resolve);
    });
    loadLib.then(animateInCnv());
  },


  methods: {
    playVideo: function playVideo() {
      this.$store.commit('SET_STATEVIDEO', true);

      this.isVideoPlaying = true;

      __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.to('.black-cover', 0.4, { autoAlpha: 0, delay: 0.3 });

      this.PIXIRenderers.phaseOut(0.5);
    },
    stopVideo: function stopVideo() {
      this.$store.commit('SET_STATEVIDEO', false);

      this.isVideoPlaying = false;

      __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.to('.black-cover', 0.4, { autoAlpha: 1 });

      this.PIXIRenderers.phaseIn(1.5, true);
    },
    injectCanvas: function injectCanvas(index, canvas) {
      var cont = this.$el.querySelector('.canvas-cont');
      cont.appendChild(canvas);
    },
    switchImg: function switchImg() {
      if (window.chrome && window.chrome.webstore || window.opr && window.opr.addons) {
        return this.dataVideo.url + '.webp';
      }
      return this.dataVideo.url + '.jpg';
    }
  },

  beforeDestroy: function beforeDestroy() {
    if (this.entered) {
      this.PIXIRenderers.destroy();
      this.intersectionObserver.unobserve(this.$el);
    }
  }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Videoplayer',

  props: ['stopVideo', 'playVideo', 'dataVideo', 'dataEnter'],

  data: function data() {
    return {
      isPaused: { type: Boolean, default: true },
      options: { type: Object, required: true },
      currentTime: 0,
      durationVideo: 0
    };
  },


  computed: {
    progress: function progress() {
      var progress = Math.round(this.currentTime) / Math.round(this.durationVideo);
      return progress;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$refs.videoplayer.addEventListener('loadedmetadata', function () {
      _this.durationVideo = _this.$refs.videoplayer.duration;
    });

    this.$refs.videoplayer.addEventListener('timeupdate', function () {
      _this.currentTime = _this.$refs.videoplayer.currentTime;

      if (_this.currentTime === _this.durationVideo) {
        _this.isPaused = true;

        _this.stopVideo();
        _this.$refs.videoplayer.currentTime = 0;
      }
    });
  },


  methods: {
    pausedVideo: function pausedVideo() {
      this.isPaused = true;

      this.stopVideo();
      this.$refs.videoplayer.pause();
    },
    toggleVideo: function toggleVideo() {
      if (this.isPaused) {
        this.isPaused = false;

        this.playVideo();
        this.$refs.videoplayer.play();
      } else {
        this.isPaused = true;

        this.stopVideo();
        this.$refs.videoplayer.pause();
      }
    }
  }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CityFooterImage__ = __webpack_require__(592);

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CityFooter',

  components: {
    CityFooterImage: __WEBPACK_IMPORTED_MODULE_2__components_CityFooterImage__["a" /* default */]
  },

  data: function data() {
    return {
      cityfooter: {}
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getDataCityComponent'])),

  created: function created() {
    this.cityfooter = this.getDataCityComponent(this.$route.params.city, 'cityfooter');
  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__webpack_require__(92);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CityFooterImage',

  props: ['data'],

  computed: {
    switchImg: function switchImg() {
      if (window.chrome && window.chrome.webstore || window.opr && window.opr.addons) {
        return this.data.url + '.webp';
      }
      return this.data.url + '.jpg';
    }
  },

  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_gsap___default.a.set('.image__cut', { webkitClipPath: 'inset(0.01% 100% 0.03% 0.04%)' });
    __WEBPACK_IMPORTED_MODULE_0_gsap___default.a.set('.image__img', { scale: 1.3 });

    var intersectionObserver = new IntersectionObserver(function (entries) {
      if (entries[0].intersectionRatio <= 0) return;
      _this.enter(_this.$el);

      intersectionObserver.disconnect();
    });

    intersectionObserver.observe(this.$el);
  },


  methods: {
    enter: function enter(el) {
      var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap___default.a.TimelineMax({ onComplete: function onComplete() {
          el.setAttribute('data-state', 'entered');
        } });

      tl.add('start').staggerFromTo('.image__cut', 0.8, {
        webkitClipPath: 'inset(0.01% 100% 0.03% 0.04%)'
      }, {
        webkitClipPath: 'inset(0.01% 0.02% 0.03% 0.04%)',
        clearProps: 'all',
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap___default.a.Expo.easeOut,
        delay: 0.5
      }, 0.03, 'start').staggerFromTo('.image__img', 1.6, {
        scale: 1.3
      }, {
        scale: 1,
        clearProps: 'all',
        ease: __WEBPACK_IMPORTED_MODULE_0_gsap___default.a.Expo.easeOut,
        delay: 0.5
      }, 0.03, 'start');
    }
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gsap__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_smooth_scrollbar__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ProgressBar__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_InfoIntro__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_InfoSteps__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_InfoHost__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_InfoDescription__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_InfoTeam__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Quote__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_InfoClosing__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Social__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__scripts_animations__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__scripts_utils__ = __webpack_require__(5);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'About',

  data: function data() {
    return {
      dataPage: __WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].getters.getDataAbout.about[0],
      lengthBar: 0,
      skewBar: 0,
      prevDir: 'up',
      prevValDir: 0,
      lastTime: Date.now(),
      lastOffset: 0,
      reduceAmount: 0
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapGetters */])(['getDataAbout'])),

  components: {
    ProgressBar: __WEBPACK_IMPORTED_MODULE_10__components_ProgressBar__["a" /* default */],
    InfoIntro: __WEBPACK_IMPORTED_MODULE_11__components_InfoIntro__["a" /* default */],
    InfoSteps: __WEBPACK_IMPORTED_MODULE_12__components_InfoSteps__["a" /* default */],
    InfoHost: __WEBPACK_IMPORTED_MODULE_13__components_InfoHost__["a" /* default */],
    InfoDescription: __WEBPACK_IMPORTED_MODULE_14__components_InfoDescription__["a" /* default */],
    InfoTeam: __WEBPACK_IMPORTED_MODULE_15__components_InfoTeam__["a" /* default */],
    Quote: __WEBPACK_IMPORTED_MODULE_16__components_Quote__["a" /* default */],
    InfoClosing: __WEBPACK_IMPORTED_MODULE_17__components_InfoClosing__["a" /* default */],
    Social: __WEBPACK_IMPORTED_MODULE_18__components_Social__["a" /* default */]
  },

  mounted: function mounted() {
    this.menu = document.querySelector('header');
    if (Object(__WEBPACK_IMPORTED_MODULE_21__scripts_utils__["b" /* hasClass */])(this.menu, 'hide')) this.menu.classList.remove('hide');
    if (Object(__WEBPACK_IMPORTED_MODULE_21__scripts_utils__["b" /* hasClass */])(this.menu, 'theme-dark')) this.menu.classList.remove('theme-dark');

    this.$store.commit('ADD_BUTTONS', this.$el);

    var DisableScrollPlugin = function (_ScrollbarPlugin) {
      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(DisableScrollPlugin, _ScrollbarPlugin);

      function DisableScrollPlugin() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, DisableScrollPlugin);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DisableScrollPlugin.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(DisableScrollPlugin)).apply(this, arguments));
      }

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(DisableScrollPlugin, [{
        key: 'transformDelta',
        value: function transformDelta(delta) {
          if (this.options.direction) {
            delta[this.options.direction] = 0;
          }
          return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, delta);
        }
      }]);

      return DisableScrollPlugin;
    }(__WEBPACK_IMPORTED_MODULE_9_smooth_scrollbar__["a" /* ScrollbarPlugin */]);

    DisableScrollPlugin.pluginName = 'disableScroll';
    DisableScrollPlugin.defaultOptions = {
      direction: 'x'
    };

    __WEBPACK_IMPORTED_MODULE_9_smooth_scrollbar__["b" /* default */].use(DisableScrollPlugin);

    var scrollbar = this.$el.querySelector('.scrollbar');
    this.scrollbar = new __WEBPACK_IMPORTED_MODULE_9_smooth_scrollbar__["b" /* default */](scrollbar);

    this.parallaxEls = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.$el.querySelectorAll('[data-parallax]'));
    this.parallaxElsIn = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.$el.querySelectorAll('[data-parallaxin]'));
    this.animEls = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.$el.querySelectorAll('[data-anim]'));
    __WEBPACK_IMPORTED_MODULE_7_gsap___default.a.set(this.animEls, { autoAlpha: 0 });

    this.scrollbar.addListener(this.scrollHandler.bind(this));
  },


  methods: {
    scrollHandler: function scrollHandler() {
      var _this2 = this;

      this.lengthBar = this.scrollbar.offset.y / this.scrollbar.limit.y;

      this.checkMenu();
      this.setSkewBar();

      this.parallaxEls.forEach(function (el) {
        if (_this2.scrollbar.isVisible(el)) {
          __WEBPACK_IMPORTED_MODULE_20__scripts_animations__["a" /* default */].get('parallax')(el);
        }
      });

      this.parallaxElsIn.forEach(function (el) {
        if (_this2.scrollbar.isVisible(el)) {
          __WEBPACK_IMPORTED_MODULE_20__scripts_animations__["a" /* default */].get('parallaxIn')(el);
        }
      });

      this.animEls.forEach(function (animEl) {
        var type = animEl.getAttribute('data-anim');

        if (_this2.scrollbar.isVisible(animEl) && !animEl.hasAttribute('data-animated')) {
          var offsetEl = animEl.getBoundingClientRect().top;

          if (offsetEl <= window.innerHeight / 1.3) {
            animEl.setAttribute('data-animated', '');

            __WEBPACK_IMPORTED_MODULE_20__scripts_animations__["a" /* default */].get(type)(animEl);
          }
        }
      });
    },
    checkMenu: function checkMenu() {
      this.direction = this.prevValDir < this.scrollbar.offset.y ? 'down' : 'up';
      this.prevValDir = this.scrollbar.offset.y;

      if (this.scrollbar.offset.y > 100 && !Object(__WEBPACK_IMPORTED_MODULE_21__scripts_utils__["b" /* hasClass */])(this.menu, 'theme-dark')) {
        this.menu.classList.add('theme-dark');
      } else if (this.scrollbar.offset.y < 100 && Object(__WEBPACK_IMPORTED_MODULE_21__scripts_utils__["b" /* hasClass */])(this.menu, 'theme-dark')) {
        this.menu.classList.remove('theme-dark');
      }

      if (this.direction === 'down' && !Object(__WEBPACK_IMPORTED_MODULE_21__scripts_utils__["b" /* hasClass */])(this.menu, 'hide') && this.scrollbar.offset.y > 0) {
        this.menu.classList.add('hide');
      } else if (this.direction === 'up' && Object(__WEBPACK_IMPORTED_MODULE_21__scripts_utils__["b" /* hasClass */])(this.menu, 'hide')) {
        this.menu.classList.remove('hide');
      }
    },
    setSkewBar: function setSkewBar() {
      var current = Date.now();
      var offset = this.scrollbar.offset.y;
      var duration = current - this.lastTime;

      if (!duration || offset === this.lastOffset) return;

      if (duration > 100) {
        this.reduceAmount += duration - 1;
        duration -= duration - 1;
      }

      var velocity = (offset - this.lastOffset) / duration;
      this.lastTime = current;
      this.lastOffset = offset;

      var skew = Math.min(Math.abs(velocity) * 50, 60);
      this.skewBar = this.direction === 'up' ? skew : skew * -1;
    }
  },

  beforeDestroy: function beforeDestroy() {
    var _this3 = this;

    this.scrollbar.removeListener(this.scrollHandler.bind(this));

    setTimeout(function () {
      if (Object(__WEBPACK_IMPORTED_MODULE_21__scripts_utils__["b" /* hasClass */])(_this3.menu, 'hide')) _this3.menu.classList.remove('hide');
      if (Object(__WEBPACK_IMPORTED_MODULE_21__scripts_utils__["b" /* hasClass */])(_this3.menu, 'theme-dark')) _this3.menu.classList.remove('theme-dark');

      _this3.scrollbar.destroy();
    }, 1400);
  },
  beforeRouteEnter: function beforeRouteEnter(from, to, next) {
    if (__WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].getters.getDataAbout.length < 1) {
      __WEBPACK_IMPORTED_MODULE_19__store__["a" /* default */].dispatch('FETCH_ABOUT').then(function () {
        next();
      });
    } else {
      next(function () {});
    }
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_eventer_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_eventer_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_eventer_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Social__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scripts_animations__ = __webpack_require__(147);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InfoIntro',

  props: ['data'],

  components: {
    Social: __WEBPACK_IMPORTED_MODULE_4__components_Social__["a" /* default */]
  },

  mounted: function mounted() {
    var _this = this;

    var animIn = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.$el.querySelectorAll('[data-anim-in]'));
    __WEBPACK_IMPORTED_MODULE_1_gsap___default.a.set(animIn, { autoAlpha: 0 });

    setTimeout(function () {
      animIn.forEach(function (element) {
        var type = element.getAttribute('data-anim-in');

        __WEBPACK_IMPORTED_MODULE_5__scripts_animations__["a" /* default */].get(type)(element);
      });
    }, 1000);

    this.eventer = new __WEBPACK_IMPORTED_MODULE_3_eventer_js___default.a(true);
    this.links = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.$el.querySelectorAll('[data-customlink]'));

    if (this.links.length > 0) {
      this.links.forEach(function (link) {
        _this.eventer.bindEvent('click', link, _this.handleClick);
      });
    }
  },


  computed: {
    switchImg: function switchImg() {
      if (window.chrome && window.chrome.webstore || window.opr && window.opr.addons) {
        return this.data.image.src + '.webp';
      }
      return this.data.image.src + '.jpg';
    }
  },

  methods: {
    handleClick: function handleClick() {
      event.preventDefault();
      var url = event.target.getAttribute('href');

      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(url);
    }
  },

  beforeDestroy: function beforeDestroy() {
    var _this2 = this;

    if (this.links.length > 0) {
      this.links.forEach(function (link) {
        _this2.eventer.clearAll(link);
      });
    }
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Social_vue__ = __webpack_require__(256);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1ca22b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Social_vue__ = __webpack_require__(602);
function injectStyle (ssrContext) {
  __webpack_require__(601)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a1ca22b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Social_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1ca22b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Social_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'social',

  data: function data() {
    return {
      socials: [{
        name: 'Instagram',
        abbr: 'In',
        url: 'https://www.instagram.com/oneworldoneface/'
      }, {
        name: 'Twitter',
        abbr: 'Tw',
        url: 'https://twitter.com/OneWorldOneFace'
      }, {
        name: 'Facebook',
        abbr: 'Fb',
        url: 'https://www.facebook.com/oneworldoneface/'
      }]
    };
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_InfoStepsList__ = __webpack_require__(606);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InfoSteps',

  props: ['data'],

  components: {
    InfoStepsList: __WEBPACK_IMPORTED_MODULE_0__components_InfoStepsList__["a" /* default */]
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InfoStepsList',

  props: ['dataList', 'title']
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'host',

  data: function data() {
    return {
      items: [['HOST', 'IN YOUR', 'CITY'], ['IN YOUR', 'CITY', 'HOST'], ['CITY', 'HOST', 'IN YOUR']]
    };
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InfoIntro',

  props: ['data'],

  computed: {
    switchImg: function switchImg() {
      if (window.chrome && window.chrome.webstore || window.opr && window.opr.addons) {
        return this.data.image.src + '.webp';
      }
      return this.data.image.src + '.jpg';
    }
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InfoTeam',

  props: ['data'],

  computed: {
    switchImg: function switchImg() {
      if (window.chrome && window.chrome.webstore || window.opr && window.opr.addons) {
        return this.data.image.src + '.webp';
      }
      return this.data.image.src + '.jpg';
    }
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raf_loop__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raf_loop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_raf_loop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fontfaceobserver__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fontfaceobserver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fontfaceobserver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_data_infoclosing_json__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_data_infoclosing_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_data_infoclosing_json__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InfoClosing',

  data: function data() {
    return {
      list: __WEBPACK_IMPORTED_MODULE_4__assets_data_infoclosing_json___default.a,
      texts: [],
      scrollValue: 0,
      totalWidth: 0
    };
  },
  created: function created() {
    var _this = this;

    this.list.forEach(function (text) {
      _this.texts.push({
        content: text,
        left: 0,
        width: 0
      });
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    var font = new __WEBPACK_IMPORTED_MODULE_2_fontfaceobserver___default.a('Neutral', {
      weight: 500
    });

    font.load().then(function () {
      _this2.setEls();
      _this2.engine = __WEBPACK_IMPORTED_MODULE_1_raf_loop___default()(_this2.renderer).start();
    }, function () {
      _this2.setEls();
      _this2.engine = __WEBPACK_IMPORTED_MODULE_1_raf_loop___default()(_this2.renderer).start();
    });

    this.handlerResize = function () {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(_this2.resize(), 300);
    };

    window.addEventListener('resize', this.handlerResize);
  },


  methods: {
    renderer: function renderer() {
      var _this3 = this;

      this.scrollValue += 2;

      this.texts.forEach(function (el) {
        if (_this3.scrollValue - el.left > el.width) {
          el.left = _this3.totalWidth;
          _this3.totalWidth = _this3.totalWidth + el.width;
        }
      });
    },
    setEls: function setEls() {
      var _this4 = this;

      var nodes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.$el.querySelectorAll('.closing__content'));
      var left = 0;
      this.totalWidth = 0;

      this.texts.forEach(function (el) {
        el.node = nodes.find(function (node) {
          return node.innerText === el.content;
        });
        el.left = left;
        el.width = el.node.clientWidth;

        el.node.style.left = left + 'px';

        left += el.width;
        _this4.totalWidth += el.width;
      });
    },
    resize: function resize() {
      this.scrollValue = 0;

      this.setEls();
    }
  },

  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handlerResize);

    this.engine.stop();
    this.engine = null;
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_timers__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scripts_error__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scripts_utils__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ErrorPage',

  data: function data() {
    return {
      cityList: ['tokyo', 'porto', 'berlin', 'milan'],
      city: 'tokyo'
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.commit('ADD_BUTTONS', this.$el);

    this.error = new __WEBPACK_IMPORTED_MODULE_1__scripts_error__["a" /* default */](this.$refs.contBg);
    this.error.init();

    Object(__WEBPACK_IMPORTED_MODULE_0_timers__["setInterval"])(function () {
      _this.city = _this.changeCity();
    }, 5000);
  },


  methods: {
    changeCity: function changeCity() {
      var number = Object(__WEBPACK_IMPORTED_MODULE_2__scripts_utils__["a" /* getRandom */])(0, this.cityList.length - 1);
      return this.cityList[number];
    }
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddFace',

  mounted: function mounted() {
    var _this = this;

    window.addEventListener('message', function () {
      if (event.data === 'loadingError') {
        _this.$router.push('/loading-error');
      }
    });

    this.$el.on('load', function () {
      _this.$el.focus();
    });
  },


  methods: {}
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(79);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LoadingError',
  methods: {
    reload: function reload() {
      __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].go(-1);
    }
  }
});

/***/ }),
/* 266 */,
/* 267 */,
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_lazyload__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modernizr__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modernizr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__modernizr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scripts_utils__ = __webpack_require__(5);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */











/* eslint-enable */

var events = [];

if ((window.chrome && window.chrome.webstore)) {
  events = ['mousewheel', 'resize', 'touchmove'];
} else {
  events = ['mousewheel', 'resize', 'touchmove', 'scroll', 'wheel'];
}

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_lazyload___default.a, {
  listenEvents: events,
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
Object(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */] },
});


var bg = [
  'background: linear-gradient(135deg, rgba(18, 23, 255, 1) 0%, rgba(30, 30, 30, 1) 100%);',
  'color: white',
  'padding: 5px 20px',
  'line-height: 25px',
].join(';');
console.log('%cOWOF | Join the treasure hunt! We placed a couple candies here and there. Can you find them?', bg);

var title = document.title;
// change title
window.addEventListener('blur', function() {
  var texts = [
    'Going already?',
    'Checking Facebook?',
    'Tweeting #owof?',
    'Who is it?',
    'Farewell!',
    'Until next time!',
    'Lets walk you out.',
  ];
  var number = Object(__WEBPACK_IMPORTED_MODULE_7__scripts_utils__["a" /* getRandom */])(0, (texts.length - 1));

  title = document.title;
  document.title = texts[number];
});

window.addEventListener('focus', function() {
  document.title = title;
});


/***/ }),
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */
/***/ (function(module, exports) {

!function(e,n,t){function o(e,n){return typeof e===n}function s(){var e,n,t,s,i,a,r;for(var f in d)if(d.hasOwnProperty(f)){if(e=[],n=d[f],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(s=o(n.fn,"function")?n.fn():n.fn,i=0;i<e.length;i++)a=e[i],r=a.split("."),1===r.length?Modernizr[r[0]]=s:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=s),l.push((s?"":"no-")+r.join("-"))}}function i(e){var n=c.className,t=Modernizr._config.classPrefix||"";if(p&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(o,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(n+=" "+t+e.join(" "+t),p?c.className.baseVal=n:c.className=n)}function a(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):p?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function r(){var e=n.body;return e||(e=a(p?"svg":"body"),e.fake=!0),e}function f(e,t,o,s){var i,f,l,d,u="modernizr",p=a("div"),v=r();if(parseInt(o,10))for(;o--;)l=a("div"),l.id=s?s[o]:u+(o+1),p.appendChild(l);return i=a("style"),i.type="text/css",i.id="s"+u,(v.fake?v:p).appendChild(i),v.appendChild(p),i.styleSheet?i.styleSheet.cssText=e:i.appendChild(n.createTextNode(e)),p.id=u,v.fake&&(v.style.background="",v.style.overflow="hidden",d=c.style.overflow,c.style.overflow="hidden",c.appendChild(v)),f=t(p,e),v.fake?(v.parentNode.removeChild(v),c.style.overflow=d,c.offsetHeight):p.parentNode.removeChild(p),!!f}var l=[],d=[],u={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){d.push({name:e,fn:n,options:t})},addAsyncTest:function(e){d.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=u,Modernizr=new Modernizr;var c=n.documentElement,p="svg"===c.nodeName.toLowerCase(),v=u._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];u._prefixes=v;var h=u.testStyles=f;Modernizr.addTest("touchevents",function(){var t;if("ontouchstart"in e||e.DocumentTouch&&n instanceof DocumentTouch)t=!0;else{var o=["@media (",v.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");h(o,function(e){t=9===e.offsetTop})}return t});var m=function(){function e(e,n){var s;return e?(n&&"string"!=typeof n||(n=a(n||"div")),e="on"+e,s=e in n,!s&&o&&(n.setAttribute||(n=a("div")),n.setAttribute(e,""),s="function"==typeof n[e],n[e]!==t&&(n[e]=t),n.removeAttribute(e)),s):!1}var o=!("onblur"in n.documentElement);return e}();u.hasEvent=m;var g="Moz O ms Webkit",w=u._config.usePrefixes?g.toLowerCase().split(" "):[];u._domPrefixes=w,Modernizr.addTest("pointerevents",function(){var e=!1,n=w.length;for(e=Modernizr.hasEvent("pointerdown");n--&&!e;)m(w[n]+"pointerdown")&&(e=!0);return e}),s(),i(l),delete u.addTest,delete u.addAsyncTest;for(var y=0;y<Modernizr._q.length;y++)Modernizr._q[y]();e.Modernizr=Modernizr}(window,document);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(149);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cda0340_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(343);
function injectStyle (ssrContext) {
  __webpack_require__(274)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cda0340_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */,
/* 276 */,
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderComp_vue__ = __webpack_require__(150);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_672c9884_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderComp_vue__ = __webpack_require__(315);
function injectStyle (ssrContext) {
  __webpack_require__(278)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-672c9884"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderComp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_672c9884_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderComp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logo_vue__ = __webpack_require__(151);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_262fa5c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logo_vue__ = __webpack_require__(303);
function injectStyle (ssrContext) {
  __webpack_require__(280)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-262fa5c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_262fa5c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"canvas-cont"},[(!_vm.isMobile())?_c('canvas',{attrs:{"id":"sprite"},on:{"mouseover":_vm.startRender,"mouseleave":_vm.destroy}}):_vm._e(),_vm._v(" "),(!_vm.isMobile())?_c('canvas',{attrs:{"id":"sprite-blue"},on:{"mouseover":_vm.startRender,"mouseleave":_vm.destroy}}):_vm._e(),_vm._v(" "),(_vm.isMobile())?_c('img',{staticClass:"image__logo",attrs:{"src":"/static/img/logo/logo.svg","alt":"Logo One world one face"}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleAudio_vue__ = __webpack_require__(162);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_320e37f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleAudio_vue__ = __webpack_require__(308);
function injectStyle (ssrContext) {
  __webpack_require__(305)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-320e37f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleAudio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_320e37f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleAudio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 306 */,
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Konami = function () {
  function Konami() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Konami);

    this.konami = '38,38,40,40,37,39,37,39,66,65';
    this.keys = [];
    this.change = new CustomEvent('konamiChange');

    this.handleKeyDown = function (event) {
      return _this.sequence(event);
    };
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Konami, [{
    key: 'init',
    value: function init() {
      window.addEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: 'sequence',
    value: function sequence(event) {
      this.keys.push(event.keyCode);
      if (this.keys.toString().indexOf(this.konami) >= 0) {
        window.dispatchEvent(this.change);
        this.destroy();
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.keys = [];
      window.removeEventListener('keydown', this.handleKeyDown);
    }
  }]);

  return Konami;
}();

/* harmony default export */ __webpack_exports__["a"] = (Konami);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-mouse":"","data-mouse-attractionState":"active","data-mouse-attraction":"high","data-mouse-attractionVal":"30","data-mouse-magnetism":"5","data-hover-type":"fadeout"},on:{"click":_vm.buttonClick}},[_c('div',{class:[_vm.played ? 'audio-button audio-button--active' : 'audio-button']},[_c('span',{staticClass:"audio-button__line",attrs:{"data-tline":""}}),_vm._v(" "),_c('span',{staticClass:"audio-button__line",attrs:{"data-tline":""}}),_vm._v(" "),_c('span',{staticClass:"audio-button__line",attrs:{"data-tline":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderVoice_vue__ = __webpack_require__(163);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60de78fd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderVoice_vue__ = __webpack_require__(311);
function injectStyle (ssrContext) {
  __webpack_require__(310)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60de78fd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderVoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60de78fd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderVoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"voice",staticClass:"header__voice",attrs:{"data-voice":_vm.data.namespace,"data-mouse":"","data-mouse-attractionState":"active","data-mouse-attractionVal":"30","data-mouse-magnetism":"5","data-hover-type":"fadeout"}},[_c('transition',{attrs:{"mode":"out-in"},on:{"enter":_vm.transitionEnter,"leave":_vm.transitionLeave}},[_c('router-link',{attrs:{"to":_vm.data.link,"data-text":""}},[_vm._v("\n      "+_vm._s(_vm.data.voice)+"\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterAddFace_vue__ = __webpack_require__(164);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fbf1376_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterAddFace_vue__ = __webpack_require__(314);
function injectStyle (ssrContext) {
  __webpack_require__(313)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fbf1376"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterAddFace_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fbf1376_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterAddFace_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"add-face",attrs:{"to":"/add-your-face"}},[_c('span',{ref:"plus",staticClass:"add-cont",attrs:{"data-mouse":"","data-mouse-attractionState":"active","data-mouse-attractionVal":"20","data-mouse-magnetism":"5","data-hover-type":"fadeout"}},[_c('span',{staticClass:"svg-cont"},[_c('svg',{attrs:{"viewBox":"-2 -2 86 86","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill-rule":"nonzero","fill":"none"}},[_c('path',{staticClass:"svg__circle",attrs:{"d":"M41 81c22.091 0 40-17.909 40-40S63.091 1 41 1 1 18.909 1 41s17.909 40 40 40z","stroke":"#fff"}}),_vm._v(" "),_c('path',{staticClass:"svg__plus",attrs:{"d":"M17 41h49v2H17z","stroke":"#fff"}}),_vm._v(" "),_c('path',{staticClass:"svg__plus",attrs:{"d":"M41 17h2v49h-2z","stroke":"#fff"}})])])]),_vm._v(" "),_c('span',{staticClass:"add__caption",attrs:{"data-text":""}},[_vm._v("Add your face")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"header",staticClass:"header__container"},[_c('h1',{staticClass:"header__item header__item--logo"},[_c('router-link',{attrs:{"to":"/","data-mouse":"","data-mouse-attractionState":"active","data-mouse-attractionVal":"30","data-mouse-magnetism":"5","data-hover-type":"fadeout"}},[_c('Logo')],1)],1),_vm._v(" "),_c('section',{staticClass:"header__item"},[_c('FooterAddFace',{attrs:{"loaderIsOut":_vm.loaderIsOut}}),_vm._v(" "),_vm._l((_vm.voices),function(voice){return _c('HeaderVoice',{key:voice.link,attrs:{"data":voice,"loaderIsOut":_vm.loaderIsOut}})}),_vm._v(" "),_c('ToggleAudio',{attrs:{"loaderIsOut":_vm.loaderIsOut}})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cursor_vue__ = __webpack_require__(165);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_627993ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cursor_vue__ = __webpack_require__(318);
function injectStyle (ssrContext) {
  __webpack_require__(317)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-627993ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cursor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_627993ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cursor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"pointer",staticClass:"cursor"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScreenSaver_vue__ = __webpack_require__(166);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15c555b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScreenSaver_vue__ = __webpack_require__(322);
function injectStyle (ssrContext) {
  __webpack_require__(320)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15c555b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScreenSaver_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15c555b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScreenSaver_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_utils__ = __webpack_require__(5);






var Marquee = function () {
  function Marquee(el, colors) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Marquee);

    this.el = el;
    this.settings = {
      horizontal: true,
      vertical: true,
      speed: 300,
      container: this.el.parentNode
    };
    this.colors = colors;
    this.tempColor = null;
    this.containerWidth = this.settings.container.offsetWidth;
    this.containerHeight = this.settings.container.offsetHeight;
    this.elWidth = this.el.offsetWidth;
    this.elHeight = this.el.offsetHeight;
    this.bumpEdge = function () {
      var rand = Object(__WEBPACK_IMPORTED_MODULE_3__scripts_utils__["a" /* getRandom */])(0, _this.colors.length - 1);
      var increment = rand === _this.colors.length - 1 ? -1 : +1;
      var newColor = _this.colors[rand];
      if (newColor === _this.tempColor) {
        newColor = _this.colors[rand + increment];
      }
      __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.to(Object(__WEBPACK_IMPORTED_MODULE_3__scripts_utils__["e" /* qs */])('.logo', _this.el), 0.5, {
        fill: newColor,
        ease: __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.Expo.easeOut
      });
      _this.tempColor = newColor;
    };
    this.bumpEdge();
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Marquee, [{
    key: 'init',
    value: function init() {
      this.getSizes();

      __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.set(this.el, {
        autoAlpha: 1,
        left: 0,
        top: 0,
        x: this.elWidth / -2,
        y: this.elHeight / -2
      });

      if (this.settings.horizontal) {
        this.right();
      }
      if (this.settings.vertical) {
        this.down();
      }

      window.addEventListener('resize', this.getSizes.bind(this));
    }
  }, {
    key: 'getSizes',
    value: function getSizes() {
      this.containerWidth = this.settings.container.offsetWidth;
      this.containerHeight = this.settings.container.offsetHeight;
      this.elWidth = this.el.offsetWidth;
      this.elHeight = this.el.offsetHeight;
    }
  }, {
    key: 'right',
    value: function right() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.to(this.el, this.containerWidth / this.settings.speed, {
        x: this.containerWidth - this.elWidth,
        ease: __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.Power0.easeNone,
        onComplete: function onComplete() {
          _this2.bumpEdge();
          _this2.left();
        }
      });
    }
  }, {
    key: 'left',
    value: function left() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.to(this.el, this.containerWidth / this.settings.speed, {
        x: 0,
        ease: __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.Power0.easeNone,
        onComplete: function onComplete() {
          _this3.bumpEdge();
          _this3.right();
        }
      });
    }
  }, {
    key: 'down',
    value: function down() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.to(this.el, this.containerHeight / this.settings.speed, {
        y: this.containerHeight - this.elHeight,
        ease: __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.Power0.easeNone,
        onComplete: function onComplete() {
          _this4.bumpEdge();
          _this4.up();
        }
      });
    }
  }, {
    key: 'up',
    value: function up() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.to(this.el, this.containerHeight / this.settings.speed, {
        y: 0,
        ease: __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.Power0.easeNone,
        onComplete: function onComplete() {
          _this5.bumpEdge();
          _this5.down();
        }
      });
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.set(this.el, { autoAlpha: 0 });

      window.removeEventListener('resize', this.getSizes.bind(this));
    }
  }]);

  return Marquee;
}();

/* harmony default export */ __webpack_exports__["a"] = (Marquee);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screensaver",class:{ active: _vm.screensaverStatus }},[_c('div',{staticClass:"screensaver__video"},[_c('video',{attrs:{"muted":"","loop":"","playsinline":"","preload":"none"},domProps:{"muted":true}},[_c('source',{attrs:{"src":"/static/video/screensaver_logo.mp4","type":"video/mp4"}})])]),_vm._v(" "),_c('div',{staticClass:"marquee"},[_c('svg',{attrs:{"id":"98daa4aa-1064-4e5a-ba10-a2e3700d0e91","data-name":"Livello 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 318.61 135.29"}},[_c('title',[_vm._v("owof")]),_c('g',{staticClass:"logo"},[_c('path',{attrs:{"d":"M10,85.59a11.6,11.6,0,0,1-5.41-2.84,13.49,13.49,0,0,1-3.38-5.39A22.75,22.75,0,0,1,0,69.71a25.92,25.92,0,0,1,1.21-8.06,20.85,20.85,0,0,1,3.48-6.57,20.11,20.11,0,0,1,5.45-4.77,20.87,20.87,0,0,1,7.19-2.62,17.75,17.75,0,0,1,7.24.05A12,12,0,0,1,30,50.57a13.18,13.18,0,0,1,3.43,5.36,22.68,22.68,0,0,1,1.18,7.68,25.92,25.92,0,0,1-1.21,8.06,21.15,21.15,0,0,1-3.48,6.6A19.51,19.51,0,0,1,24.44,83a21.37,21.37,0,0,1-7.21,2.6,17.93,17.93,0,0,1-7.26,0M21,77.81A9.77,9.77,0,0,0,24,75a13.88,13.88,0,0,0,1.91-4.27A21.66,21.66,0,0,0,26.54,65a19.23,19.23,0,0,0-.68-5.48A9,9,0,0,0,24,56,6,6,0,0,0,21,54.21a8.73,8.73,0,0,0-3.74-.09,10.62,10.62,0,0,0-3.74,1.41,9.53,9.53,0,0,0-2.92,2.83,14.19,14.19,0,0,0-1.88,4.27,21.66,21.66,0,0,0-.68,5.67,19,19,0,0,0,.68,5.43,9.42,9.42,0,0,0,1.88,3.6,5.79,5.79,0,0,0,2.92,1.8,8.72,8.72,0,0,0,3.74.09A10.61,10.61,0,0,0,21,77.81","transform":"translate(0 -0.34)","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"M49.42,42.76,62.26,61.49q.39.61.72,1.25t.58,1.13q.29.58.53,1.11l.19,0V40.13l7.09-1.25V75.32l-8.11,1.43-13.13-19q-.43-.65-.8-1.28t-.6-1.12a9.82,9.82,0,0,1-.48-1.12l-.19,0V79.43l-7.14,1.26V44.25Z","transform":"translate(0 -0.34)","fill-rule":"evenodd"}}),_c('polygon',{attrs:{"points":"103.62 32.85 103.62 39.42 86.92 42.36 86.92 50.76 101.44 48.2 101.44 54.62 86.92 57.18 86.92 65.67 104.39 62.59 104.39 69.16 79.29 73.58 79.29 37.14 103.62 32.85","fill-rule":"evenodd"}}),_c('polygon',{attrs:{"points":"135.85 63.61 126.34 65.28 117.71 30.37 125.43 29.01 131.75 55.74 138.89 26.64 146.08 25.37 153.18 51.62 159.5 23 166.64 21.74 158.05 59.69 148.64 61.35 142.22 37.39 135.85 63.61","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"M180.13,55.59a11.6,11.6,0,0,1-5.41-2.84,13.49,13.49,0,0,1-3.38-5.39,22.74,22.74,0,0,1-1.18-7.66,25.92,25.92,0,0,1,1.21-8.06,20.85,20.85,0,0,1,3.48-6.57,20.11,20.11,0,0,1,5.45-4.77,20.87,20.87,0,0,1,7.19-2.62,17.75,17.75,0,0,1,7.24.05,12,12,0,0,1,5.43,2.83,13.18,13.18,0,0,1,3.43,5.36,22.7,22.7,0,0,1,1.18,7.68,25.92,25.92,0,0,1-1.21,8.06,21.15,21.15,0,0,1-3.48,6.6A19.51,19.51,0,0,1,194.61,53a21.38,21.38,0,0,1-7.21,2.6,17.94,17.94,0,0,1-7.26,0m11.05-7.79A9.78,9.78,0,0,0,194.13,45,13.88,13.88,0,0,0,196,40.7a21.64,21.64,0,0,0,.68-5.67,19.22,19.22,0,0,0-.68-5.48A9,9,0,0,0,194.13,26a6,6,0,0,0-2.94-1.77,8.73,8.73,0,0,0-3.74-.09,10.63,10.63,0,0,0-3.74,1.41,9.53,9.53,0,0,0-2.92,2.83,14.18,14.18,0,0,0-1.88,4.27,21.65,21.65,0,0,0-.68,5.67,19,19,0,0,0,.68,5.43,9.42,9.42,0,0,0,1.88,3.6,5.79,5.79,0,0,0,2.92,1.8,8.72,8.72,0,0,0,3.74.09,10.61,10.61,0,0,0,3.74-1.41","transform":"translate(0 -0.34)","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"M218.76,36.16V49.33l-7.67,1.35V14.25l14.67-2.59q6.18-1.09,9.65,1.12t3.48,7.57a11.94,11.94,0,0,1-1.83,6.55,15.39,15.39,0,0,1-5,4.84v.1l8.25,13.7L231.84,47l-7.24-11.9Zm0-6.42,5.7-1a15.35,15.35,0,0,0,2.53-.66,6.64,6.64,0,0,0,2.08-1.19A5.54,5.54,0,0,0,230.49,25a6.5,6.5,0,0,0,.53-2.77,5.69,5.69,0,0,0-.51-2.61,3.3,3.3,0,0,0-1.4-1.44,4.72,4.72,0,0,0-2.15-.49,14.31,14.31,0,0,0-2.7.24l-5.5,1Z","transform":"translate(0 -0.34)","fill-rule":"evenodd"}}),_c('polygon',{attrs:{"points":"253.37 6.45 253.37 36.23 269.97 33.3 269.97 39.96 245.69 44.24 245.69 7.8 253.37 6.45","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"M275.42,2.91,287.24.82A28,28,0,0,1,294.7.45a13.3,13.3,0,0,1,6.11,2,11.4,11.4,0,0,1,4.1,4.88,19.52,19.52,0,0,1,1.5,8.25,24.28,24.28,0,0,1-1.33,8.27,18.84,18.84,0,0,1-3.79,6.39,20.1,20.1,0,0,1-6,4.46,29.54,29.54,0,0,1-8,2.55l-11.82,2.08Zm16.51,26.58a10.42,10.42,0,0,0,3.52-2.58,11.05,11.05,0,0,0,2.22-4.08,19.9,19.9,0,0,0,.77-5.93,16.18,16.18,0,0,0-.72-5.23,7,7,0,0,0-2.15-3.24A6.8,6.8,0,0,0,292,7a16.4,16.4,0,0,0-4.8.22L283,8V31.63l4.2-.74A19.39,19.39,0,0,0,291.93,29.48Z","transform":"translate(0 -0.34)","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"M312.92,36.28a6.91,6.91,0,0,0,1.16-3.75l-3.52.62V25.28l8.06-1.42v6.32a12.89,12.89,0,0,1-1.67,6.5,15,15,0,0,1-5.82,5.3l-1.59-2.57a13.56,13.56,0,0,0,3.38-3.13","transform":"translate(0 -0.34)","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"M10,135.24a11.6,11.6,0,0,1-5.41-2.84A13.49,13.49,0,0,1,1.18,127,22.75,22.75,0,0,1,0,119.36a25.92,25.92,0,0,1,1.21-8.06,20.85,20.85,0,0,1,3.48-6.57A20.11,20.11,0,0,1,10.14,100a20.87,20.87,0,0,1,7.19-2.62,17.76,17.76,0,0,1,7.24.05A12,12,0,0,1,30,100.22a13.18,13.18,0,0,1,3.43,5.36,22.68,22.68,0,0,1,1.18,7.68,25.92,25.92,0,0,1-1.21,8.06,21.15,21.15,0,0,1-3.48,6.6,19.51,19.51,0,0,1-5.48,4.78,21.39,21.39,0,0,1-7.21,2.6,18,18,0,0,1-7.26,0M21,127.45A9.77,9.77,0,0,0,24,124.61a13.88,13.88,0,0,0,1.91-4.27,21.66,21.66,0,0,0,.68-5.67,19.24,19.24,0,0,0-.68-5.48A9,9,0,0,0,24,105.62,6,6,0,0,0,21,103.85a8.73,8.73,0,0,0-3.74-.09,10.63,10.63,0,0,0-3.74,1.41A9.53,9.53,0,0,0,10.62,108a14.19,14.19,0,0,0-1.88,4.27,21.66,21.66,0,0,0-.68,5.67,19,19,0,0,0,.68,5.43,9.42,9.42,0,0,0,1.88,3.6,5.79,5.79,0,0,0,2.92,1.8,8.72,8.72,0,0,0,3.74.09A10.61,10.61,0,0,0,21,127.45","transform":"translate(0 -0.34)","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"M49.42,92.4l12.84,18.73q.39.61.72,1.25t.58,1.13q.29.58.53,1.11l.19,0V89.78l7.09-1.25V125l-8.11,1.43-13.13-19q-.43-.65-.8-1.28t-.6-1.12a9.82,9.82,0,0,1-.48-1.12l-.19,0v25.19l-7.14,1.26V93.9Z","transform":"translate(0 -0.34)","fill-rule":"evenodd"}}),_c('polygon',{attrs:{"points":"103.62 82.5 103.62 89.06 86.92 92.01 86.92 100.4 101.44 97.84 101.44 104.26 86.92 106.82 86.92 115.32 104.39 112.24 104.39 118.8 79.29 123.22 79.29 86.79 103.62 82.5","fill-rule":"evenodd"}}),_c('polygon',{attrs:{"points":"143.91 81.96 128.18 84.73 128.18 94.19 141.5 91.84 141.5 98.26 128.18 100.61 128.18 114.61 120.5 115.96 120.5 79.52 143.91 75.39 143.91 81.96","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"M156.85,101.45,154,110.4l-7.48,1.32L159.31,73l9.27-1.63,12.84,34.17-7.82,1.38L170.75,99Zm11.78-8.35-3.09-8.63a17.6,17.6,0,0,1-.63-1.92q-.24-.92-.48-1.7T164,79.2l-.43.08q-.24.86-.43,1.77t-.48,1.87q-.24,1.06-.58,2.18L159,94.8Z","transform":"translate(0 -0.34)","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"M194.71,102.74a11.47,11.47,0,0,1-5.43-2.71,12.75,12.75,0,0,1-3.38-5.29A23.12,23.12,0,0,1,184.74,87,25.55,25.55,0,0,1,186,79a22.1,22.1,0,0,1,3.5-6.67,20.26,20.26,0,0,1,5.45-4.89A20,20,0,0,1,202,64.77a18.73,18.73,0,0,1,5.91-.2,12.76,12.76,0,0,1,4.56,1.49,9.51,9.51,0,0,1,3.14,2.85,11.71,11.71,0,0,1,1.74,3.87L210,75.58a7.59,7.59,0,0,0-3-3.7,7,7,0,0,0-5-.68,10,10,0,0,0-6.64,4.31q-2.53,3.58-2.53,9.76a18.8,18.8,0,0,0,.7,5.5,9.42,9.42,0,0,0,1.93,3.62,6.17,6.17,0,0,0,2.9,1.83,8,8,0,0,0,3.64.13,9.86,9.86,0,0,0,5.67-3A9.83,9.83,0,0,0,209.26,91a13.29,13.29,0,0,0,1-2.58l7.63.15A20,20,0,0,1,216.16,93a16.74,16.74,0,0,1-3.09,4.19,19.28,19.28,0,0,1-4.66,3.38,21.77,21.77,0,0,1-6.44,2.1,18.94,18.94,0,0,1-7.26,0","transform":"translate(0 -0.34)","fill-rule":"evenodd"}}),_c('polygon',{attrs:{"points":"247.62 57.11 247.62 63.67 230.92 66.61 230.92 75.01 245.45 72.45 245.45 78.87 230.92 81.43 230.92 89.92 248.4 86.84 248.4 93.41 223.3 97.83 223.3 61.4 247.62 57.11","fill-rule":"evenodd"}}),_c('polygon',{attrs:{"points":"261.81 83.18 261.81 91.04 253.75 92.46 253.75 84.6 261.81 83.18","fill-rule":"evenodd"}})])])]),_vm._v(" "),(_vm.isMobile())?_c('p',{staticClass:"disclaimer"},[_vm._v("(Catch me if you can)")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Favicon_vue__ = __webpack_require__(167);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35abe032_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Favicon_vue__ = __webpack_require__(325);
function injectStyle (ssrContext) {
  __webpack_require__(324)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35abe032"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Favicon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35abe032_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Favicon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{staticClass:"canvas-fav",attrs:{"width":"16","height":"16"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_lib_gsap_uncompressed_utils_SplitText__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_lib_gsap_uncompressed_utils_SplitText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_lib_gsap_uncompressed_utils_SplitText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scripts_utils__ = __webpack_require__(5);






var lerp = function lerp(a, b, n) {
  return (1 - n) * a + n * b;
};
var transitions = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();

transitions.set('pageTransition', function (el, dir, callback) {
  var val = dir === 'in' ? { pos: 0, op: 1 } : { pos: 1, op: 0 };
  var cover = document.querySelector('.transition-cover');

  var tl = new __WEBPACK_IMPORTED_MODULE_1_gsap___default.a.TimelineMax({
    onUpdate: function onUpdate() {
      cover.style.background = 'radial-gradient(ellipse at center, rgba(0,0,0,0) 0%, rgba(0,0,0,' + val.op + ') ' + val.pos + '%)';
    },
    onComplete: callback
  });

  tl.add('start').set(el, { autoAlpha: 1 }, 'start').to(val, 1, {
    pos: dir === 'in' ? '+=100' : '-=100'
  }, 'start').to(val, 1, {
    op: dir === 'in' ? '-=1' : '+=1'
  }, '-=0.5');
});

transitions.set('loaderTransitionIn', function (el, callback) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__scripts_utils__["c" /* isMobile */])()) {
    __WEBPACK_IMPORTED_MODULE_1_gsap___default.a.fromTo(el, 0.3, {
      autoAlpha: 0
    }, {
      autoAlpha: 1,
      onComplete: callback
    });
  } else {
    var $text = el.querySelector('[data-text]');
    var split = new __WEBPACK_IMPORTED_MODULE_2__assets_lib_gsap_uncompressed_utils_SplitText___default.a($text, { type: 'lines, words', linesClass: 'loaderSplit' });

    var dir = 0;

    var tl = new __WEBPACK_IMPORTED_MODULE_1_gsap___default.a.TimelineMax({
      onComplete: callback
    });

    // tl
    //   .fromTo(el, 0.2, { autoAlpha: 0 }, { autoAlpha: 1 })
    //   .add('start')
    //   .staggerFromTo(this.split, 1.8, {
    //     y: 20,
    //     autoAlpha: 0,
    //   }, {
    //     y: 0,
    //     autoAlpha: 1,
    //     onStartParams: ['{self}'],
    //     onStart: (self) => {
    //       const chars = new SplitText(self.target, { type: 'words, chars' }).chars;

    //       dir += 1;
    //       const yo = -(Math.cos((dir % 2) * Math.PI));

    //       gsap.staggerFromTo(chars, 1, {
    //         autoAlpha: 0,
    //       }, {
    //         autoAlpha: 1,
    //         ease: gsap.Expo.easeOut,
    //       }, 0.03 * yo);
    //     },
    //   }, 0.4);

    tl.fromTo(el, 0.2, { autoAlpha: 0 }, { autoAlpha: 1 }).add('start').staggerFromTo('.loaderSplit', 1, {
      y: 50,
      skewX: -10,
      rotation: 5,
      autoAlpha: 0
    }, {
      y: 0,
      skewX: 0,
      rotation: 0,
      autoAlpha: 1,
      clearProps: 'all',
      delay: 0.2
    }, 0.1);
  }
});

transitions.set('loaderTransitionOut', function (el, callback) {
  // let split = [];
  // if (isMobile()) {
  //   const $text = el.querySelector('[data-text]');
  //   split = new SplitText($text, { type: 'lines, words', linesClass: 'loaderSplit' });
  // } else {
  //   split = Array.from(el.querySelectorAll('.loaderSplit'));
  // }
  // let dir = 0;

  // const tl = new gsap.TimelineMax({
  //   onComplete: callback,
  // });

  __WEBPACK_IMPORTED_MODULE_1_gsap___default.a.to(el, 0.5, {
    autoAlpha: 0,
    onComplete: callback
  });

  // tl
  // .add('start')
  // .staggerFromTo(split, 1.2, {
  //   y: 0,
  //   autoAlpha: 1,
  // }, {
  //   y: -20,
  //   autoAlpha: 0,
  //   onStartParams: ['{self}'],
  //   onStart: (self) => {
  //     const chars = new SplitText(self.target, { type: 'words, chars' }).chars;

  //     dir += 1;
  //     const yo = Math.cos((dir % 2) * Math.PI);

  //     gsap.staggerFromTo(chars, 0.4, {
  //       autoAlpha: 1,
  //     }, {
  //       autoAlpha: 0,
  //     }, 0.02 * yo);
  //   },
  // }, 0.2);

  // .add('start')
  // .staggerFromTo('.loaderSplit', 1, {
  //   y: 0,
  //   skewX: 0,
  //   rotation: 0,
  //   autoAlpha: 1,
  // }, {
  //   y: -50,
  //   skewX: 10,
  //   rotation: -5,
  //   autoAlpha: 0,
  // }, 0.1);
});

/* harmony default export */ __webpack_exports__["a"] = (transitions);

/***/ }),
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"appear":"","mode":"in-out"},on:{"enter":_vm.enterLoader,"leave":_vm.leaveLoader}},[(_vm.isLoading)?_c('section',{staticClass:"loader"},[_c('article',{on:{"click":_vm.hideLoader}},[_c('q',{staticClass:"loader__explanation",attrs:{"data-text":"","data-subline":!_vm.isAnimating ? 'active' : ''}},[_c('b',[_vm._v("One World One Face")]),_vm._v(" ought to "),_c('br',{staticClass:"mobile--visible"}),_vm._v("represent everyone "),_c('br',{staticClass:"mobile--hidden"}),_vm._v("without talking "),_c('br',{staticClass:"mobile--visible"}),_vm._v("about anyone in particular."),_c('br'),_vm._v(" "),_c('span',{staticClass:"text--underline"},[_c('span',{staticClass:"text__line text__line--1"}),_vm._v("Community")]),_vm._v(", \n          "),_c('span',{staticClass:"text--underline"},[_c('span',{staticClass:"text__line text__line--2"}),_vm._v("Unity")]),_vm._v(", \n          "),_c('span',{staticClass:"text--underline"},[_c('span',{staticClass:"text__line text__line--3"}),_vm._v("Equality")]),_vm._v(" \n          and "),_c('span',{staticClass:"text--underline"},[_c('span',{staticClass:"text__line text__line--4"}),_vm._v("Creativity")]),_vm._v(" \n          are the core "),_c('br',{staticClass:"mobile--hidden"}),_vm._v("values on which "),_c('br',{staticClass:"mobile--visible"}),_vm._v("the project is built.\n\n          "),_c('span',{staticClass:"loader__caption"},[_vm._v("\n            It starts from "),_c('span',{attrs:{"data-underscore":""}},[_c('span'),_vm._v("here")]),_vm._v(".\n          ")])])])]):_vm._e()]),_vm._v(" "),_c('header',[_c('HeaderComp',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaderIsOut),expression:"loaderIsOut"}],attrs:{"loaderIsOut":_vm.loaderIsOut}})],1),_vm._v(" "),_c('main',{staticClass:"content"},[_c('transition',{attrs:{"mode":"out-in"},on:{"enter":_vm.transitionEnter,"leave":_vm.transitionLeave}},[(_vm.loaderIsOut)?_c('router-view',{key:_vm.$route.path}):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"transition-cover",style:({ background: 'radial-gradient(ellipse at center, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 0%)'})}),_vm._v(" "),_c('cookie-law',{attrs:{"theme":"min","buttonText":"Ok","transitionName":"fade","buttonClass":"cookie-button"}},[_c('div',{attrs:{"slot":"message"},slot:"message"},[_vm._v("\n      This website uses cookies. "),(_vm.isMobile())?_c('br'):_vm._e(),_c('a',{attrs:{"href":"https://www.iubenda.com/privacy-policy/31537728/cookie-policy","target":"_blank","rel":"noopener"}},[_vm._v("Learn More.")])])]),_vm._v(" "),(!_vm.isLoading)?_c('Pointer',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path != '/add-your-face'),expression:"$route.path != '/add-your-face'"}]}):_vm._e(),_vm._v(" "),(_vm.loaderIsOut && _vm.$route.path != '/add-your-face')?_c('ScreenSaver'):_vm._e(),_vm._v(" "),(_vm.loaderIsOut)?_c('Favicon'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 344 */,
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(173);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ece840b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(372);
function injectStyle (ssrContext) {
  __webpack_require__(346)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ece840b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ece840b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SliderTest_vue__ = __webpack_require__(174);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e07ac76_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SliderTest_vue__ = __webpack_require__(355);
function injectStyle (ssrContext) {
  __webpack_require__(348)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9e07ac76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SliderTest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e07ac76_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SliderTest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"slider"}},[_c('ul',{ref:"silderCont",staticClass:"slider__text-cont",style:({
      height: (_vm.windowH + "px"),
      transform: ("rotate(" + (_vm.rotation.val) + "deg) translate3d(0, 0, " + _vm.scale + "px)")
    })},_vm._l((_vm.texts),function(text){return _c('li',{key:text.title,staticClass:"slider__item",style:({
        top: ((text.top) + "px"),
        left: ((text.left) + "px"),
        transform: ("translate3d(" + _vm.scrollValue + "px, 0, 0)")
      }),on:{"click":_vm.clickVoice}},[_c('router-link',{style:({
          paddingRight: (_vm.paddingRight + "px"),
        }),attrs:{"to":text.id,"data-hover":text.title,"data-state":text.state,"data-mouse":"","data-mouse-attractionState":"disactive","data-hover-type":"fadeout"}},[_vm._v("\n        "+_vm._s(text.title)+"\n      ")])],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexFace_vue__ = __webpack_require__(177);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49b22556_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexFace_vue__ = __webpack_require__(368);
function injectStyle (ssrContext) {
  __webpack_require__(357)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49b22556"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexFace_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49b22556_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexFace_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"canvas"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterLegend_vue__ = __webpack_require__(183);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_186637e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterLegend_vue__ = __webpack_require__(371);
function injectStyle (ssrContext) {
  __webpack_require__(370)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-186637e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterLegend_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_186637e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterLegend_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legend"},[_c('h3',[_vm._v("Legend")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("V ➞ visited")]),_vm._v(" "),_c('li',[_vm._v("U ➞ upcoming")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"index"},[_c('IndexFace'),_vm._v(" "),(_vm.cities.length)?_c('SliderTest',{attrs:{"cities":_vm.cities}}):_vm._e(),_vm._v(" "),_c('transition',{on:{"enter":_vm.enter}},[(_vm.entered)?_c('FooterLegend'):_vm._e()],1),_vm._v(" "),_c('transition',{on:{"enter":_vm.enter}},[_c('svg',{directives:[{name:"show",rawName:"v-show",value:(_vm.entered),expression:"entered"}],staticClass:"arrow-svg arrow-scroll",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 113"},on:{"click":_vm.clickArrow}},[_c('path',{attrs:{"d":"M50 112l-4.1-3.6L1 70l8.3-9.7 34.3 29.4V1h12.8v88.7l34.3-29.4L99 70l-44.9 38.4L50 112z","fill":"none","stroke":"#fff","stroke-dasharray":"450","stroke-dashoffset":"900"}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_World_vue__ = __webpack_require__(184);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07219562_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_World_vue__ = __webpack_require__(379);
function injectStyle (ssrContext) {
  __webpack_require__(374)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07219562"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_World_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07219562_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_World_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorldFace_vue__ = __webpack_require__(185);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7adb4b61_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorldFace_vue__ = __webpack_require__(377);
function injectStyle (ssrContext) {
  __webpack_require__(376)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7adb4b61"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorldFace_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7adb4b61_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorldFace_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cityface"},[_c('div',{attrs:{"id":"canvas"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports = ["one world, one face.","1つの世界、1つの顔。","um mundo, uma cara.","eine welt, ein gesicht.","un mondo, una faccia.","en verden, et ansigt.","一个世界，一个脸。एक दुनिया, एक चेहरा।","un mundo, una cara","один мир, одно лицо.","عالم واحد ، وجه واحد.","এক বিশ্ব, এক মুখ.","satu dunia, satu wajah.","un monde, un visage.","하나의 세계, 하나의 얼굴.","một thế giới, một khuôn mặt.","tek dünya, tek yüz.","один світ, одне обличчя."]

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"world"},[_c('ul',{staticClass:"slider__list"},_vm._l((_vm.texts),function(text){return _c('li',{key:text.title,staticClass:"list__item",style:({
        left: ((text.left) + "px"),
        transform: ("translate3d(" + (-_vm.scrollValue) + "px, -25%, 0)")
      })},[_vm._v("\n      "+_vm._s(text.title)+"\n    ")])})),_vm._v(" "),_c('div',{staticClass:"world__sticker"}),_vm._v(" "),_c('WorldFace')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_City_vue__ = __webpack_require__(186);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_762cc076_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_City_vue__ = __webpack_require__(596);
function injectStyle (ssrContext) {
  __webpack_require__(381)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-762cc076"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_City_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_762cc076_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_City_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getCities: function getCities(state) {
    return state.cities.sort(function (a, b) {
      return a.index - b.index;
    });
  },
  getCity: function getCity(state) {
    return function (city) {
      return state.cities.find(function (el) {
        return el.id === city;
      });
    };
  },
  getCurrentCity: function getCurrentCity(state) {
    return state.currentCity;
  },
  getCtxButtons: function getCtxButtons(state) {
    return state.ctxButtons;
  },
  getDataCity: function getDataCity(state) {
    return function (city) {
      return state.dataPageCities.find(function (el) {
        return el.id === city;
      });
    };
  },
  getDataAbout: function getDataAbout(state) {
    return state.pageAbout;
  },
  getDataCityComponent: function getDataCityComponent(state, getters) {
    return function (city, component) {
      return getters.getDataCity(city).data[component];
    };
  },
  getStateVideo: function getStateVideo(state) {
    return state.videoIsPlaying;
  },
  getStateAudio: function getStateAudio(state) {
    return state.userStopAudio;
  }
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_whatwg_fetch__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(484);





/* harmony default export */ __webpack_exports__["a"] = ({
  FETCH_CITIES: function FETCH_CITIES(_ref) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Object(__WEBPACK_IMPORTED_MODULE_3__api__["b" /* fetchDocs */])('cities').then(function (cities) {
                return commit('SET_CITIES', { cities: cities });
              });

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  FETCH_ABOUT: function FETCH_ABOUT(_ref2) {
    var _this2 = this;

    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return Object(__WEBPACK_IMPORTED_MODULE_3__api__["b" /* fetchDocs */])('about').then(function (about) {
                return commit('SET_ABOUT', { about: about });
              });

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  FETCH_DATACITY: function FETCH_DATACITY(_ref3, city) {
    var _this3 = this;

    var commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return Object(__WEBPACK_IMPORTED_MODULE_3__api__["a" /* fetchDoc */])(city).then(function (dataCity) {
                return commit('ADD_DATACITY', { dataCity: dataCity });
              });

            case 2:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }
});

/***/ }),
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchDoc;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchDocs; });
/* unused harmony export fetchProjects */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_whatwg_fetch__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_create_api__ = __webpack_require__(486);


// this is aliased in webpack config based on server/client build



function fetch(collection, reject) {

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_3__store_create_api__["a" /* db */].collection(collection).get().then(function (res) {
      var val = res.docs;

      if (!val.every(function (bool) {
        return bool;
      })) {
        reject();
        return;
      }

      resolve(val.map(function (v) {
        return v.data();
      }));
    });
  });
}

function fetchDoc(city) {
  var doc = 'cities/' + city + '/data/' + city;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_3__store_create_api__["a" /* db */].doc(doc).get().then(function (res) {
      var val = res;

      resolve({ id: city, doc: val.data() });
    });
  });
}

var fetchDocs = function fetchDocs(data) {
  return fetch(data);
};

function fetchProjects(ids) {
  var promises = ids.map(function (el) {
    return fetch('content/' + el);
  });

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(promises)));
}

/***/ }),
/* 485 */,
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return db; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_firestore__);



// import pageObj from '@/assets/data/portoObj';

var config = {
  apiKey: 'AIzaSyAE03PZ2ymt1J_CVa2izVSo5EIY--4-qsY',
  authDomain: 'owof-eedb8.firebaseapp.com',
  databaseURL: 'https://owof-eedb8.firebaseio.com',
  projectId: 'owof-eedb8'
};

__WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.initializeApp(config);
var db = __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.firestore();

// db.collection('cities').doc('porto').collection('data').doc('porto')
//   .set(pageObj)
//   .then(() => {
//     console.log('Document successfully written!');
//   });
// db.collection('cities').doc('paris').delete();
// db.collection('about').doc('content')
//   .set(pageObj)
//   .then(() => {
//     console.log('Document successfully written!');
//   });
/* unused harmony default export */ var _unused_webpack_default_export = (db);

/***/ }),
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  SET_CURRENTCITY: function SET_CURRENTCITY(state, payload) {
    state.currentCity = payload;
  },
  SET_CITIES: function SET_CITIES(state, payload) {
    state.cities = payload.cities;
  },
  SET_ABOUT: function SET_ABOUT(state, payload) {
    state.pageAbout = payload;
  },
  ADD_DATACITY: function ADD_DATACITY(state, payload) {
    state.dataPageCities.push({ id: payload.dataCity.id, data: payload.dataCity.doc });
  },
  ADD_BUTTONS: function ADD_BUTTONS(state, payload) {
    state.ctxButtons = payload;
  },
  SET_STATEVIDEO: function SET_STATEVIDEO(state, payload) {
    state.videoIsPlaying = payload;
  },
  SET_STATEAUDIO: function SET_STATEAUDIO(state, payload) {
    state.userStopAudio = payload;
  }
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  cities: [],
  currentCity: '',
  dataPageCities: [],
  ctxButtons: null,
  pageAbout: [],
  videoIsPlaying: false,
  userStopAudio: false
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hero_vue__ = __webpack_require__(234);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25f22874_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hero_vue__ = __webpack_require__(552);
function injectStyle (ssrContext) {
  __webpack_require__(549)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25f22874"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hero_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25f22874_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hero_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports = "// basic.vert\nprecision highp float;\nattribute vec3 positions;\nuniform float aspectRatio;\nattribute vec2 aUV;\n\nvarying vec2 vUv;\nvarying vec2 vUv2;\n\nfloat when_fgt(float x, float y) {\n  return max(sign(x - y), 0.0);\n}\n\n\nvoid main() {\n\n    gl_Position = vec4(positions, 1.0);\n\n    vUv = aUV;\n\n\n\tvUv2 = mix(\n\t\tvec2(\n\n\t\tvUv.x,\n\t\tvUv.y * 1.0 / aspectRatio + .5 * ( 1. - 1.0 / aspectRatio )\n\t),\n\tvec2(\n\n\t\tvUv.x * aspectRatio / 1.0 + .5 * ( 1. - aspectRatio / 1.0),\n\t\tvUv.y\n\t)\n    ,when_fgt(1.0, aspectRatio));\n\n}"

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports = "precision highp float;\n\nvarying vec2 vUv;\nvarying vec2 vUv2;\nvarying vec2 vUv3;\nuniform sampler2D video;\nuniform float phase;\nuniform float time;\n\nvec3 mod289(vec3 x) {\n  return x - floor(x * (1.0 / 289.0)) * 289.0;\n}\n\nvec4 mod289(vec4 x) {\n  return x - floor(x * (1.0 / 289.0)) * 289.0;\n}\n\nvec4 permute(vec4 x) {\n  return mod289(((x*34.0)+1.0)*x);\n}\n\nvec4 taylorInvSqrt(vec4 r)\n{\n    return 1.79284291400159 - 0.85373472095314 * r;\n}\n                                  \nfloat snoise(vec3 v)\n{\n    const vec2  C = vec2(1.0/6.0, 1.0/3.0) ;\n    const vec4  D = vec4(0.0, 0.5, 1.0, 2.0);\n    \n    // First corner\n    vec3 i  = floor(v + dot(v, C.yyy) );\n    vec3 x0 =   v - i + dot(i, C.xxx) ;\n    \n    // Other corners\n    vec3 g = step(x0.yzx, x0.xyz);\n    vec3 l = 1.0 - g;\n    vec3 i1 = min( g.xyz, l.zxy );\n    vec3 i2 = max( g.xyz, l.zxy );\n    \n    //   x0 = x0 - 0.0 + 0.0 * C.xxx;\n    //   x1 = x0 - i1  + 1.0 * C.xxx;\n    //   x2 = x0 - i2  + 2.0 * C.xxx;\n    //   x3 = x0 - 1.0 + 3.0 * C.xxx;\n    vec3 x1 = x0 - i1 + C.xxx;\n    vec3 x2 = x0 - i2 + C.yyy; // 2.0*C.x = 1/3 = C.y\n    vec3 x3 = x0 - D.yyy;      // -1.0+3.0*C.x = -0.5 = -D.y\n    \n    // Permutations\n    i = mod289(i);\n    vec4 p = permute( permute( permute(\n                                        i.z + vec4(0.0, i1.z, i2.z, 1.0 ))\n                              + i.y + vec4(0.0, i1.y, i2.y, 1.0 ))\n                      + i.x + vec4(0.0, i1.x, i2.x, 1.0 ));\n    \n    // Gradients: 7x7 points over a square, mapped onto an octahedron.\n    // The ring size 17*17 = 289 is close to a multiple of 49 (49*6 = 294)\n    float n_ = 0.142857142857; // 1.0/7.0\n    vec3  ns = n_ * D.wyz - D.xzx;\n    \n    vec4 j = p - 49.0 * floor(p * ns.z * ns.z);  //  mod(p,7*7)\n    \n    vec4 x_ = floor(j * ns.z);\n    vec4 y_ = floor(j - 7.0 * x_ );    // mod(j,N)\n    \n    vec4 x = x_ *ns.x + ns.yyyy;\n    vec4 y = y_ *ns.x + ns.yyyy;\n    vec4 h = 1.0 - abs(x) - abs(y);\n    \n    vec4 b0 = vec4( x.xy, y.xy );\n    vec4 b1 = vec4( x.zw, y.zw );\n    \n    //vec4 s0 = vec4(lessThan(b0,0.0))*2.0 - 1.0;\n    //vec4 s1 = vec4(lessThan(b1,0.0))*2.0 - 1.0;\n    vec4 s0 = floor(b0)*2.0 + 1.0;\n    vec4 s1 = floor(b1)*2.0 + 1.0;\n    vec4 sh = -step(h, vec4(0.0));\n    \n    vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy ;\n    vec4 a1 = b1.xzyw + s1.xzyw*sh.zzww ;\n    \n    vec3 p0 = vec3(a0.xy,h.x);\n    vec3 p1 = vec3(a0.zw,h.y);\n    vec3 p2 = vec3(a1.xy,h.z);\n    vec3 p3 = vec3(a1.zw,h.w);\n    \n    //Normalise gradients\n    vec4 norm = taylorInvSqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2, p2), dot(p3,p3)));\n    p0 *= norm.x;\n    p1 *= norm.y;\n    p2 *= norm.z;\n    p3 *= norm.w;\n    \n    // Mix final noise value\n    vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);\n    m = m * m;\n    return 42.0 * dot( m*m, vec4( dot(p0,x0), dot(p1,x1), \n                                  dot(p2,x2), dot(p3,x3) ) );\n}\n\n\nfloat when_gt(float x, float y) {\n  return max(sign(x - y), 0.0);\n}\n\n\nvec3 getBurn(vec3 color, float prog){\n\n  return color * (1.0 - color) * prog;\n}\n\nconst vec3 SEPIA = vec3(1.3, 1.0, 0.8);\n\nvoid main() {\n    // vec2 sampleUV = vUv2;\n    // vec2 offset;\n\n    float ll = phase;\n\n      float distance = length(vUv2 - 0.5) * 2.0;\n\n      float frequency = 2.0 * ll * distance;\n      float speed = 0.05;\n      float time = time;\n      float amplitude = 0.2 * (ll) * distance;\n\n\n\n    vec2 texCoords = vUv + vec2(\n        amplitude * (snoise(vec3(frequency * vUv.x, frequency * vUv.y, speed * time))),\n        amplitude * (snoise(vec3(frequency * vUv.x + 17.0, frequency * vUv.y, speed * time)))\n    ) * (1.0 - phase);\n\n    vec4 imgColor = texture2D(video, vUv);\n\n    vec4 overlay = texture2D(video, texCoords);\n\n    float limit = min(dot(overlay.rgb, vec3(0.299, 0.587, 0.114)) + ll, 1.0);\n\n    float isAbove = phase;\n\n    vec4 tempColor = mix( vec4(0.0), overlay * smoothstep(0.0, 0.5,phase), smoothstep(0.5, 1.0,limit));\n\n    float gray = dot(tempColor.rgb, vec3(0.299, 0.587, 0.114));\n\n    gl_FragColor = vec4(mix(vec3(gray), imgColor.rgb, phase), tempColor.a);\n\n    // vec4 color = texture2D( tInput, vUv );\n\n    // vec2 center = resolution * 0.5;\n    // float vignette = distance( center, gl_FragCoord.xy ) / resolution.x;\n    float vignette = ( 1.0 + (1.0 - phase) * 3.0 ) - (distance + (1.0 - phase)) * (2.0 - phase * 2.0);\n\n    // boost - vignette * reduction\n\n    // distance\n\n    gl_FragColor.rgb *= vignette;\n    gl_FragColor.a *= vignette;\n    // gl_FragColor = color;\n  \n}"

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero"},[_c('figure',{staticClass:"hero__figure",attrs:{"data-parallax":"-0.3"}},[_c('img',{attrs:{"src":_vm.switchImg,"alt":_vm.hero.alt}})]),_vm._v(" "),_c('div',{staticClass:"hero__wrapper"},[_c('h2',{staticClass:"hero__title"},[_vm._v("\n      "+_vm._s(_vm.hero.title)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar__wrapper"},[_c('div',{staticClass:"progress-bar",style:({transform: ("scaleX(" + _vm.lengthBar + ")") })},[_c('div',{staticClass:"progress-bar__skew",style:({transform: ("skewX(" + _vm.skewBar + "deg)")})})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intro_vue__ = __webpack_require__(238);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71e3d839_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Intro_vue__ = __webpack_require__(557);
function injectStyle (ssrContext) {
  __webpack_require__(556)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71e3d839"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71e3d839_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Intro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 556 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"introduction"},[_c('section',{staticClass:"introduction__header"},[_c('div',{staticClass:"introduction__cont"},[_c('h3',{staticClass:"intro__title"},[_vm._v(_vm._s(_vm.intro.title))]),_vm._v(" "),_c('p',{attrs:{"data-anim":"text"},domProps:{"innerHTML":_vm._s(_vm.intro.description)}},[_vm._v(_vm._s(_vm.intro.description))])])]),_vm._v(" "),(_vm.intro.content.length > 0)?_c('section',{staticClass:"introduction__content"},_vm._l((_vm.intro.content),function(content){return _c('div',{key:content.order,staticClass:"content__item"},[_c('h4',{attrs:{"data-anim":"title"}},[_vm._v(_vm._s(content.title))]),_vm._v(" "),_vm._l((content.description),function(text){return _c('p',{key:text,attrs:{"data-anim":"text"},domProps:{"innerHTML":_vm._s(text)}},[_vm._v("\n        "+_vm._s(text)+"\n      ")])})],2)})):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 558 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"quote",attrs:{"data-theme":_vm.$store.state.route.name === 'about' ? 'inverted' : 'normal'}},[_c('section',{staticClass:"quote__cont"},[_c('q',{staticClass:"quote__text",attrs:{"data-anim":"title"},domProps:{"innerHTML":_vm._s(_vm.quote.content)}},[_vm._v("\n      "+_vm._s(_vm.quote.content)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"quote__description"},[_c('h3',{attrs:{"data-anim":"title"}},[_vm._v(_vm._s(_vm.quote.title))]),_vm._v(" "),_c('p',{attrs:{"data-anim":"text"}},[_vm._v(_vm._s(_vm.quote.description))])])]),_vm._v(" "),_c('figure',{staticClass:"quote__image-cont",attrs:{"data-parallax":"0.3"}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.switchImg),expression:"switchImg"}],attrs:{"alt":_vm.quote.alt}}),_vm._v(" "),_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.switchImg),expression:"switchImg",arg:"background-image"}],staticClass:"quote__image"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Description_vue__ = __webpack_require__(241);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_091291e8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Description_vue__ = __webpack_require__(565);
function injectStyle (ssrContext) {
  __webpack_require__(561)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-091291e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Description_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_091291e8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Description_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 561 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DescriptionBox_vue__ = __webpack_require__(242);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0edc0ebe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DescriptionBox_vue__ = __webpack_require__(564);
function injectStyle (ssrContext) {
  __webpack_require__(563)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0edc0ebe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DescriptionBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0edc0ebe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DescriptionBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 563 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"description-box"},[_c('figure',{staticClass:"description-box__image",attrs:{"data-parallax":_vm.getRandomInt}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.switchImg),expression:"switchImg"}],attrs:{"alt":_vm.data.alt}}),_vm._v(" "),_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.switchImg),expression:"switchImg",arg:"background-image"}]})]),_vm._v(" "),_c('div',{staticClass:"description-box__text"},[_c('h4',{staticClass:"description-box__title",attrs:{"data-anim":"title"}},[_vm._v("\n      "+_vm._s(_vm.data.title)+"\n    ")]),_vm._v(" "),_vm._l((_vm.data.description),function(text){return _c('p',{key:text,staticClass:"description-box__content",attrs:{"data-anim":"text"},domProps:{"innerHTML":_vm._s(text)}},[_vm._v("\n      "+_vm._s(text)+"\n    ")])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"description"},[_c('section',{staticClass:"description__intro"},[_c('h3',{staticClass:"description__title",attrs:{"data-anim":"title"}},[_vm._v("\n      "+_vm._s(_vm.description.title)+"\n    ")]),_vm._v(" "),_c('p',{staticClass:"description__content",attrs:{"data-anim":"text"},domProps:{"innerHTML":_vm._s(_vm.description.description)}},[_vm._v("\n      "+_vm._s(_vm.description.description)+"\n    ")])]),_vm._v(" "),_c('section',{staticClass:"description__boxes"},_vm._l((_vm.description.list),function(item){return _c('DescriptionBox',{key:item.order,staticClass:"description__box",attrs:{"data":item}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__ = __webpack_require__(243);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54079b2b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__(571);
function injectStyle (ssrContext) {
  __webpack_require__(567)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54079b2b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54079b2b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapContainer_vue__ = __webpack_require__(244);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fa897fe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapContainer_vue__ = __webpack_require__(570);
function injectStyle (ssrContext) {
  __webpack_require__(569)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fa897fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fa897fe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"map-container"},[_c('a',{attrs:{"href":_vm.image.urlMap,"rel":"noopener","target":"_blank"}},[_c('figure',{attrs:{"data-parallax":"0.1"}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.switchImg),expression:"switchImg"}],attrs:{"alt":_vm.image.alt}}),_vm._v(" "),_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.switchImg),expression:"switchImg",arg:"background-image"}]}),_vm._v(" "),_c('span',{attrs:{"data-mouse":"","data-mouse-attractionState":"active","data-mouse-attractionVal":"30","data-mouse-magnetism":"5","data-hover-type":"fadeout","data-anim":"fade"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 62"}},[_c('path',{staticClass:"pin",attrs:{"d":"M25 1.7C12.2 1.7 1.7 12.1 1.7 24.8 1.7 36.7 22.4 58.3 25 61c2.6-2.6 23.3-24.2 23.3-36.2C48.3 12.1 37.8 1.7 25 1.7z","fill":"#1217ff","stroke":"#1217ff"}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map"},[_c('section',{staticClass:"map__spec"},[_c('div',[_c('h4',{staticClass:"map__title",attrs:{"data-anim":"title"}},[_vm._v("Location")]),_vm._v(" "),_c('div',_vm._l((_vm.map.location),function(text){return _c('p',{key:text,attrs:{"data-anim":"text"},domProps:{"innerHTML":_vm._s(text)}},[_vm._v("\n          "+_vm._s(text)+"\n        ")])}))]),_vm._v(" "),_c('div',[_c('h4',{staticClass:"map__title",attrs:{"data-anim":"title"}},[_vm._v("Gps")]),_vm._v(" "),_c('p',{attrs:{"data-anim":"text"}},[_vm._v("\n        "+_vm._s(_vm.map.gps.lat)),_c('br'),_vm._v("\n        "+_vm._s(_vm.map.gps.lng)+"\n      ")])]),_vm._v(" "),_c('div',[_c('h4',{staticClass:"map__title",attrs:{"data-anim":"title"}},[_vm._v("Schedule")]),_vm._v(" "),_c('div',_vm._l((_vm.map.schedule),function(text){return _c('p',{key:text,attrs:{"data-anim":"text"},domProps:{"innerHTML":_vm._s(text)}},[_vm._v("\n          "+_vm._s(text)+"\n        ")])}))])]),_vm._v(" "),_c('MapContainer',{attrs:{"image":_vm.map.image}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CityFace_vue__ = __webpack_require__(245);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cfccb44_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CityFace_vue__ = __webpack_require__(574);
function injectStyle (ssrContext) {
  __webpack_require__(573)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1cfccb44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CityFace_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cfccb44_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CityFace_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 573 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cityface"},[_c('div',{attrs:{"id":"canvas"}}),_vm._v(" "),(_vm.$store.state.route.path === '/copenhagen')?_c('div',{staticClass:"cityface__loader"}):_c('div',{staticClass:"cityface__sticker"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Diary_vue__ = __webpack_require__(246);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7af403c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Diary_vue__ = __webpack_require__(577);
function injectStyle (ssrContext) {
  __webpack_require__(576)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c7af403c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Diary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7af403c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Diary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 576 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"diary",attrs:{"data-margin":_vm.$route.path === '/tokyo' || _vm.$route.path === '/berlin' ? 100 : 0}},[_c('section',{staticClass:"diary__col diary__col--white"},[_c('h3',{staticClass:"diary__title",attrs:{"data-anim":"title"}},[_vm._v(_vm._s(_vm.colLeft.title))]),_vm._v(" "),_c('p',{staticClass:"diary__subtitle"},[_c('b',{attrs:{"data-anim":"title"},domProps:{"innerHTML":_vm._s(_vm.colLeft.subtitle)}},[_vm._v("\n        "+_vm._s(_vm.colLeft.subtitle)+"\n      ")])]),_vm._v(" "),_vm._l((_vm.colLeft.content),function(text){return _c('p',{key:text,attrs:{"data-anim":"text"},domProps:{"innerHTML":_vm._s(text)}},[_vm._v("\n      "+_vm._s(text)+"\n    ")])})],2),_vm._v(" "),_c('section',{staticClass:"diary__col diary__col--black",attrs:{"data-parallax":"-0.1"}},[_c('p',{staticClass:"diary__text-italic"},[_c('span',{attrs:{"data-anim":"title"}},[_vm._v("\n        "+_vm._s(_vm.colRight.date)+"\n      ")]),_vm._v(" "),_c('span',{staticClass:"line",attrs:{"data-anim":"line"}}),_vm._v(" "),_c('span',{attrs:{"data-anim":"title"}},[_vm._v("\n        "+_vm._s(_vm.colRight.year)+"\n      ")])]),_vm._v(" "),_c('figure',[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.switchImg),expression:"switchImg"}],attrs:{"alt":_vm.colRight.alt}}),_vm._v(" "),_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.switchImg),expression:"switchImg",arg:"background-image"}]})]),_vm._v(" "),_c('p',{staticClass:"figure__text"},[_c('b',{attrs:{"data-anim":"title"},domProps:{"innerHTML":_vm._s(_vm.colRight.caption)}},[_vm._v("\n        "+_vm._s(_vm.colRight.caption)+"\n      ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.colRight.content),function(text){return _c('p',{key:text,staticClass:"figure__content",attrs:{"data-anim":"text"},domProps:{"innerHTML":_vm._s(text)}},[_vm._v("\n      "+_vm._s(text)+"\n    ")])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PhotoSlider_vue__ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bd0041c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PhotoSlider_vue__ = __webpack_require__(580);
function injectStyle (ssrContext) {
  __webpack_require__(579)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bd0041c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PhotoSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bd0041c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PhotoSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 579 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photoslider"},[_c('div',{staticClass:"slider"},[_c('transition',{on:{"enter":_vm.enter,"leave":_vm.leave}},_vm._l(([_vm.currentNumber]),function(number){return _c('figure',{key:number,staticClass:"slide__cont"},[(_vm.isFirst)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.images[Math.abs(_vm.currentNumber) % _vm.images.length].url),expression:"images[Math.abs(currentNumber) % images.length].url"}]}):_vm._e(),_vm._v(" "),(_vm.isFirst)?_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(("" + (_vm.images[Math.abs(_vm.currentNumber) % _vm.images.length].url) + _vm.extension)),expression:"`${images[Math.abs(currentNumber) % images.length].url}${extension}`",arg:"background-image"}],staticClass:"slider__image"}):_vm._e(),_vm._v(" "),(!_vm.isFirst)?_c('img',{attrs:{"src":("" + (_vm.images[Math.abs(_vm.currentNumber) % _vm.images.length].url) + _vm.extension)}}):_vm._e(),_vm._v(" "),(!_vm.isFirst)?_c('div',{staticClass:"slider__image",style:({ backgroundImage: ("url(" + (_vm.images[Math.abs(_vm.currentNumber) % _vm.images.length].url) + _vm.extension + ")") })}):_vm._e()])}))],1),_vm._v(" "),_c('div',{staticClass:"slider-navigator"},[_c('button',{staticClass:"slider-navigator__button slider-navigator__button--prev",attrs:{"data-mouse":"","data-mouse-attractionState":"disactive","data-hover-type":"fadeout"},on:{"click":_vm.prev}},[_vm._v("\n      prev\n    ")]),_c('button',{staticClass:"slider-navigator__button slider-navigator__button--next",attrs:{"data-mouse":"","data-mouse-attractionState":"disactive","data-hover-type":"fadeout"},on:{"click":_vm.next}},[_vm._v("\n        next\n    ")]),_vm._v(" "),_c('span',{staticClass:"slider-navigator__line"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Closing_vue__ = __webpack_require__(248);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_380d94e0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Closing_vue__ = __webpack_require__(583);
function injectStyle (ssrContext) {
  __webpack_require__(582)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-380d94e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Closing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_380d94e0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Closing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 582 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"closing"},[_c('section',{staticClass:"closing__title"},[_c('h3',{attrs:{"data-anim":"title"},domProps:{"innerHTML":_vm._s(_vm.closing.title)}},[_vm._v("\n      "+_vm._s(_vm.closing.title)+"\n    ")])]),_vm._v(" "),_c('section',{staticClass:"closing__content"},_vm._l((_vm.closing.content),function(text){return _c('p',{key:text,attrs:{"data-anim":"text"},domProps:{"innerHTML":_vm._s(text)}},[_vm._v("\n      "+_vm._s(text)+"\n    ")])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Video_vue__ = __webpack_require__(249);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35fe7ff0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Video_vue__ = __webpack_require__(589);
function injectStyle (ssrContext) {
  __webpack_require__(585)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35fe7ff0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Video_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35fe7ff0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Video_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Videoplayer_vue__ = __webpack_require__(250);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_456a7788_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Videoplayer_vue__ = __webpack_require__(588);
function injectStyle (ssrContext) {
  __webpack_require__(587)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-456a7788"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Videoplayer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_456a7788_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Videoplayer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 587 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-player"},[_c('video',{ref:"videoplayer",attrs:{"crossorigin":"*","preload":"metadata","playsinline":""},on:{"click":function($event){$event.preventDefault();return _vm.toggleVideo($event)}}},[_c('source',{attrs:{"src":_vm.dataVideo.urlVideo,"type":"video/mp4"}})]),_vm._v(" "),(_vm.dataEnter)?_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress__line",style:({ transform: ("scaleX(" + _vm.progress + ")")})})]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dataEnter),expression:"dataEnter"}],staticClass:"pause",attrs:{"data-mouse":"","data-mouse-attractionState":"active","data-mouse-attractionVal":"10","data-mouse-magnetism":"2","data-hover-type":"fadeout"},on:{"click":_vm.pausedVideo}},[_c('span',{staticClass:"pause__item"}),_vm._v(" "),_c('span',{staticClass:"pause__item"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"video-cont"},[_c('div',{staticClass:"video"},[_c('Videoplayer',{ref:"video",attrs:{"playVideo":_vm.playVideo,"stopVideo":_vm.stopVideo,"dataVideo":_vm.dataVideo,"dataEnter":_vm.enter}}),_vm._v(" "),(_vm.enter)?_c('span',{staticClass:"black-cover",attrs:{"data-videoEls":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"canvas-cont",attrs:{"data-videoEls":""}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.enter),expression:"enter"}],ref:"play",staticClass:"play"},[_c('div',{staticClass:"play-cont",attrs:{"data-state":_vm.isVideoPlaying ? 'hidden' : 'visible'}},[_c('div',{staticClass:"play-dimension"},[_vm._v("Play")]),_vm._v(" "),_c('div',{staticClass:"play__item",attrs:{"data-delay":"0"}},[_vm._v("Play")]),_vm._v(" "),_c('div',{staticClass:"play__item item--opacity",attrs:{"data-delay":"1"}},[_vm._v("Play")])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CityFooter_vue__ = __webpack_require__(251);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fdfa876_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CityFooter_vue__ = __webpack_require__(595);
function injectStyle (ssrContext) {
  __webpack_require__(591)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0fdfa876"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CityFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fdfa876_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CityFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CityFooterImage_vue__ = __webpack_require__(252);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72cd1fb4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CityFooterImage_vue__ = __webpack_require__(594);
function injectStyle (ssrContext) {
  __webpack_require__(593)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72cd1fb4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CityFooterImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72cd1fb4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CityFooterImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 593 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image",attrs:{"data-state":"waiting"}},[_c('figure',[_c('div',{staticClass:"image__cut image__cut--left"},[_c('img',{staticClass:"image__img",attrs:{"src":_vm.switchImg,"alt":_vm.data.alt}})]),_vm._v(" "),_c('div',{staticClass:"image__cut image__cut--right"},[_c('img',{staticClass:"image__img",attrs:{"src":_vm.switchImg,"alt":_vm.data.alt}})])]),_vm._v(" "),_c('h3',{staticClass:"city-footer__title",attrs:{"data-mouse":"","data-mouse-attractionState":"disactive","data-hover-type":"fadeout","data-hover":_vm.data.nameNext}},[_vm._v(_vm._s(_vm.data.nameNext))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"city-footer"},[_c('h4',{attrs:{"data-anim":"title"}},[_vm._v("next stop")]),_vm._v(" "),_c('router-link',{attrs:{"to":_vm.cityfooter.urlNext}},[_c('CityFooterImage',{attrs:{"data":_vm.cityfooter}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"city-cont"},[_c('ProgressBar',{attrs:{"lengthBar":_vm.lengthBar,"skewBar":_vm.skewBar}}),_vm._v(" "),_c('div',{staticClass:"scrollbar"},[_c('Hero',{attrs:{"heroEntered":_vm.heroEntered}}),_vm._v(" "),_c('main',{staticClass:"page-city__cont"},_vm._l((_vm.reorderComponent),function(component){return _c(component.name,{key:component.order,tag:"component"})}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__(253);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98b0659a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__(624);
function injectStyle (ssrContext) {
  __webpack_require__(598)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-98b0659a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98b0659a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoIntro_vue__ = __webpack_require__(254);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2feb6921_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoIntro_vue__ = __webpack_require__(603);
function injectStyle (ssrContext) {
  __webpack_require__(600)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2feb6921"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoIntro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2feb6921_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoIntro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"social"},[_c('p',[_vm._v("Follow us")]),_vm._v(" "),_c('ul',{staticClass:"social-list"},_vm._l((_vm.socials),function(social){return _c('li',{key:social.name,staticClass:"social__item",attrs:{"data-mouse":"","data-mouse-attractionState":"active","data-mouse-attraction":"high","data-mouse-attractionVal":"50","data-mouse-magnetism":"10","data-hover-type":"fadeout"}},[_c('a',{attrs:{"href":social.url,"rel":"noopener","target":"_blank","data-text":""}},[_vm._v(_vm._s(social.abbr))])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info__intro"},[_c('section',{staticClass:"intro__item intro__item--padding"},[_c('p',{attrs:{"data-anim-in":"text"}},[_vm._v("#OWOF")]),_vm._v(" "),_c('h3',{staticClass:"intro__title",attrs:{"data-anim-in":"title"}},[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),_c('div',{staticClass:"intro__subtitle"},_vm._l((_vm.data.subtitle),function(paragraph){return _c('p',{key:paragraph,attrs:{"data-anim-in":"text"},domProps:{"innerHTML":_vm._s(paragraph)}},[_vm._v("\n        "+_vm._s(paragraph)+"\n      ")])})),_vm._v(" "),_c('div',{staticClass:"intro__content"},_vm._l((_vm.data.content),function(paragraph){return _c('p',{key:paragraph,attrs:{"data-anim":"text"},domProps:{"innerHTML":_vm._s(paragraph)}},[_vm._v("\n        "+_vm._s(paragraph)+"\n      ")])}))]),_vm._v(" "),_c('section',{staticClass:"intro__item intro__item--image",staticStyle:{"transform":"matrix(1, 0, 0, 1, 0, 53)"},attrs:{"data-parallaxin":"relative"}},[_c('figure',[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.switchImg),expression:"switchImg"}],attrs:{"alt":_vm.data.image.alt}}),_vm._v(" "),_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.switchImg),expression:"switchImg",arg:"background-image"}],staticClass:"intro__image"})]),_vm._v(" "),_c('Social',{staticClass:"social__wrapper--desktop"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoSteps_vue__ = __webpack_require__(257);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa74e24a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoSteps_vue__ = __webpack_require__(609);
function injectStyle (ssrContext) {
  __webpack_require__(605)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aa74e24a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoSteps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa74e24a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoSteps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 605 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoStepsList_vue__ = __webpack_require__(258);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60a589f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoStepsList_vue__ = __webpack_require__(608);
function injectStyle (ssrContext) {
  __webpack_require__(607)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60a589f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoStepsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60a589f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoStepsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 607 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"setps__list"},[_c('h4',{attrs:{"data-anim":"text"}},[_vm._v(_vm._s(_vm.dataList.title))]),_vm._v(" "),_c('ul',_vm._l((_vm.dataList.cities),function(city){return _c('li',{key:city,attrs:{"data-anim":"text"}},[(/^(tokyo|berlin|milan|porto|copenhagen)$/.test(city))?_c('router-link',{attrs:{"to":("/" + city)}},[_vm._v("\n        "+_vm._s(city)+"\n      ")]):_c('span',[_vm._v("\n        "+_vm._s(city)+"\n      ")])],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info__setps"},_vm._l((_vm.data),function(list,index){return _c('InfoStepsList',{key:index,attrs:{"dataList":list}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoHost_vue__ = __webpack_require__(259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_418581b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoHost_vue__ = __webpack_require__(612);
function injectStyle (ssrContext) {
  __webpack_require__(611)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-418581b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoHost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_418581b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoHost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 611 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"host-text"},[_c('a',{attrs:{"href":"mailto:hello@oneworldoneface.com"}},[_c('h3',{staticClass:"text__cont"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"text__line"},[_c('p',[_vm._v(_vm._s(item[0]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item[1]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item[2]))])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoDescription_vue__ = __webpack_require__(260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_359fd2a2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoDescription_vue__ = __webpack_require__(615);
function injectStyle (ssrContext) {
  __webpack_require__(614)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-359fd2a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoDescription_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_359fd2a2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoDescription_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 614 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info__description"},[_c('section',{staticClass:"description__item"},[_c('h3',{staticClass:"description__title",attrs:{"data-anim":"title"}},[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),_vm._l((_vm.data.content),function(paragraph){return _c('p',{key:paragraph,staticClass:"description__content",attrs:{"data-anim":"text"},domProps:{"innerHTML":_vm._s(paragraph)}},[_vm._v("\n      "+_vm._s(paragraph)+"\n    ")])})],2),_vm._v(" "),_c('section',{staticClass:"description__item u-hidden--until-sm"},[_c('figure',{attrs:{"data-parallax":"0.2"}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.switchImg),expression:"switchImg"}],attrs:{"alt":_vm.data.image.alt}}),_vm._v(" "),_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.switchImg),expression:"switchImg",arg:"background-image"}],staticClass:"description__image"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoTeam_vue__ = __webpack_require__(261);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e4fa379_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoTeam_vue__ = __webpack_require__(618);
function injectStyle (ssrContext) {
  __webpack_require__(617)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e4fa379"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoTeam_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e4fa379_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoTeam_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 617 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info__team"},[_c('section',{staticClass:"team__item team__item--padding"},[_c('div',{staticClass:"team__list-cont"},[_c('h3',{staticClass:"team__title",attrs:{"data-anim":"text"}},[_vm._v("TEAM")]),_vm._v(" "),_c('ul',{staticClass:"tema__list"},_vm._l((_vm.data.members),function(member){return _c('li',{key:member,staticClass:"list__item",attrs:{"data-anim":"text"}},[_vm._v("\n          "+_vm._s(member)+"\n        ")])}))])]),_vm._v(" "),_c('section',{staticClass:"team__item"},[_c('figure',{attrs:{"data-parallax":"0.2"}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.switchImg),expression:"switchImg"}],attrs:{"alt":_vm.data.image.alt}}),_vm._v(" "),_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.switchImg),expression:"switchImg",arg:"background-image"}],staticClass:"team__image"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoClosing_vue__ = __webpack_require__(262);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0bfb6e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoClosing_vue__ = __webpack_require__(623);
function injectStyle (ssrContext) {
  __webpack_require__(620)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b0bfb6e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoClosing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0bfb6e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoClosing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 620 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 621 */,
/* 622 */
/***/ (function(module, exports) {

module.exports = ["The project, right now, is just the dream ","and creative exercise of some no-ones. ","It is only through you and your collaboration ","that we can make this project real."]

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"closing"},[_c('p',{staticClass:"closing__text"},_vm._l((_vm.texts),function(text){return _c('span',{key:text.content,staticClass:"closing__content",style:({
        left: ((text.left) + "px"),
        transform: ("translate3d(" + (-_vm.scrollValue) + "px, 0, 0)")
      })},[_vm._v("\n      "+_vm._s(text.content)+"\n    ")])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('ProgressBar',{attrs:{"lengthBar":_vm.lengthBar,"skewBar":_vm.skewBar}}),_vm._v(" "),_c('div',{staticClass:"scrollbar"},[_c('main',[_c('InfoIntro',{attrs:{"data":_vm.dataPage.intro}}),_vm._v(" "),_c('InfoSteps',{attrs:{"data":_vm.dataPage.steps}}),_vm._v(" "),_c('InfoHost'),_vm._v(" "),_c('Quote',{attrs:{"data":_vm.dataPage.quote}}),_vm._v(" "),_c('InfoDescription',{attrs:{"data":_vm.dataPage.description}}),_vm._v(" "),_c('InfoClosing'),_vm._v(" "),_c('Social',{staticClass:"social__wrapper--mobile"})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__ = __webpack_require__(263);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_178ba2f4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__ = __webpack_require__(629);
function injectStyle (ssrContext) {
  __webpack_require__(626)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-178ba2f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_178ba2f4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 626 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_constants__);





var Error = function () {
  function Error(el) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Error);

    this.ctxEl = el;
    this.ctx = {
      el: el || window,
      width: el.getBoundingClientRect().width,
      height: el.getBoundingClientRect().height,
      d: Math.sqrt(Math.pow(el.getBoundingClientRect().width, 2) + Math.pow(el.getBoundingClientRect().height, 2))
    };

    var textBase = el.querySelector('[data-dimension]');
    this.text = {
      el: textBase,
      width: textBase.getBoundingClientRect().width,
      height: textBase.getBoundingClientRect().height - 20
    };

    this.paragraphs = [];
    this.handleResize = function () {
      return _this.resize();
    };

    __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.set(this.ctx, { autoAlpha: 0 });
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Error, [{
    key: 'init',
    value: function init() {
      this.setCalc();
      this.createNodes();
      this.animate('in');

      this.addEvents();
    }
  }, {
    key: 'addEvents',
    value: function addEvents() {
      window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: 'setCalc',
    value: function setCalc() {
      var totDim = this.ctx.width + this.ctx.height;
      this.pNumber = Math.ceil(totDim / this.text.height);
    }
  }, {
    key: 'createNodes',
    value: function createNodes() {
      for (var i = 0; i < this.pNumber + 1; i++) {
        var index = i;
        var p = document.createElement('p');
        p.className = 'error-text';

        this.positionNodes(p, i);
      }

      this.calcContent();
    }
  }, {
    key: 'positionNodes',
    value: function positionNodes(p, i) {
      var el = p;
      var index = i;
      var bottom = Math.ceil(index * this.text.height - 100);
      var condition = bottom < this.ctx.height;

      if (condition) {
        this.changeCateto = false;
        this.lastValid = { bottom: bottom, index: index };
      } else {
        this.changeCateto = true;
      }

      var bot = condition ? bottom : -100;
      el.style.bottom = bot + 'px';

      var offsetCateto = condition ? 0 : Math.ceil((index - this.lastValid.index) * this.text.height);
      el.style.left = offsetCateto + 'px';

      this.paragraphs.push({ elementHTML: el, index: i, bottom: bot, offset: offsetCateto });
    }
  }, {
    key: 'workArray',
    value: function workArray() {
      var arrayA = this.paragraphs.filter(function (el) {
        return el.bottom > 0;
      }).reverse();
      var arrayB = this.paragraphs.filter(function (el) {
        return el.bottom < 0;
      });

      this.paragraphs = arrayA.concat(arrayB);
    }
  }, {
    key: 'calcContent',
    value: function calcContent() {
      var _this2 = this;

      this.workArray();

      this.paragraphs.forEach(function (el) {
        var c = el.offset === 0 ? Math.ceil(_this2.ctx.height - el.bottom) : Math.ceil(_this2.ctx.width - el.offset);
        var cateto = Math.min(c, Math.ceil(_this2.ctx.height));
        var d = Math.ceil(cateto * Math.sqrt(2));
        var numbText = Math.ceil(d / _this2.text.width);

        var content = '';
        for (var i = 0; i < numbText; i++) {
          content += '404 ';
        }

        el.content = content;

        var node = document.createTextNode(content);

        el.elementHTML.appendChild(node);
        _this2.ctx.el.appendChild(el.elementHTML);
      });;
    }
  }, {
    key: 'animate',
    value: function animate(dir) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

      __WEBPACK_IMPORTED_MODULE_2_gsap___default.a.to(this.ctx, 0.4, {
        autoAlpha: 1,
        onComplete: callback
      });
    }
  }, {
    key: 'resize',
    value: function resize() {
      this.ctx.width = this.ctxEl.getBoundingClientRect().width;
      this.ctx.height = this.ctxEl.getBoundingClientRect().height;
      this.ctx.d = Math.sqrt(Math.pow(this.ctxEl.getBoundingClientRect().width, 2) + Math.pow(this.ctxEl.getBoundingClientRect().height, 2));

      this.paragraphs.forEach(function (el) {
        el.elementHTML.remove();
      });
      this.paragraphs = [];
      this.setCalc();
      this.createNodes();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      window.removeEventListener('resize', this.handleResize);
    }
  }]);

  return Error;
}();

/* harmony default export */ __webpack_exports__["a"] = (Error);

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports = {"O_RDONLY":0,"O_WRONLY":1,"O_RDWR":2,"S_IFMT":61440,"S_IFREG":32768,"S_IFDIR":16384,"S_IFCHR":8192,"S_IFBLK":24576,"S_IFIFO":4096,"S_IFLNK":40960,"S_IFSOCK":49152,"O_CREAT":512,"O_EXCL":2048,"O_NOCTTY":131072,"O_TRUNC":1024,"O_APPEND":8,"O_DIRECTORY":1048576,"O_NOFOLLOW":256,"O_SYNC":128,"O_SYMLINK":2097152,"O_NONBLOCK":4,"S_IRWXU":448,"S_IRUSR":256,"S_IWUSR":128,"S_IXUSR":64,"S_IRWXG":56,"S_IRGRP":32,"S_IWGRP":16,"S_IXGRP":8,"S_IRWXO":7,"S_IROTH":4,"S_IWOTH":2,"S_IXOTH":1,"E2BIG":7,"EACCES":13,"EADDRINUSE":48,"EADDRNOTAVAIL":49,"EAFNOSUPPORT":47,"EAGAIN":35,"EALREADY":37,"EBADF":9,"EBADMSG":94,"EBUSY":16,"ECANCELED":89,"ECHILD":10,"ECONNABORTED":53,"ECONNREFUSED":61,"ECONNRESET":54,"EDEADLK":11,"EDESTADDRREQ":39,"EDOM":33,"EDQUOT":69,"EEXIST":17,"EFAULT":14,"EFBIG":27,"EHOSTUNREACH":65,"EIDRM":90,"EILSEQ":92,"EINPROGRESS":36,"EINTR":4,"EINVAL":22,"EIO":5,"EISCONN":56,"EISDIR":21,"ELOOP":62,"EMFILE":24,"EMLINK":31,"EMSGSIZE":40,"EMULTIHOP":95,"ENAMETOOLONG":63,"ENETDOWN":50,"ENETRESET":52,"ENETUNREACH":51,"ENFILE":23,"ENOBUFS":55,"ENODATA":96,"ENODEV":19,"ENOENT":2,"ENOEXEC":8,"ENOLCK":77,"ENOLINK":97,"ENOMEM":12,"ENOMSG":91,"ENOPROTOOPT":42,"ENOSPC":28,"ENOSR":98,"ENOSTR":99,"ENOSYS":78,"ENOTCONN":57,"ENOTDIR":20,"ENOTEMPTY":66,"ENOTSOCK":38,"ENOTSUP":45,"ENOTTY":25,"ENXIO":6,"EOPNOTSUPP":102,"EOVERFLOW":84,"EPERM":1,"EPIPE":32,"EPROTO":100,"EPROTONOSUPPORT":43,"EPROTOTYPE":41,"ERANGE":34,"EROFS":30,"ESPIPE":29,"ESRCH":3,"ESTALE":70,"ETIME":101,"ETIMEDOUT":60,"ETXTBSY":26,"EWOULDBLOCK":35,"EXDEV":18,"SIGHUP":1,"SIGINT":2,"SIGQUIT":3,"SIGILL":4,"SIGTRAP":5,"SIGABRT":6,"SIGIOT":6,"SIGBUS":10,"SIGFPE":8,"SIGKILL":9,"SIGUSR1":30,"SIGSEGV":11,"SIGUSR2":31,"SIGPIPE":13,"SIGALRM":14,"SIGTERM":15,"SIGCHLD":20,"SIGCONT":19,"SIGSTOP":17,"SIGTSTP":18,"SIGTTIN":21,"SIGTTOU":22,"SIGURG":16,"SIGXCPU":24,"SIGXFSZ":25,"SIGVTALRM":26,"SIGPROF":27,"SIGWINCH":28,"SIGIO":23,"SIGSYS":12,"SSL_OP_ALL":2147486719,"SSL_OP_ALLOW_UNSAFE_LEGACY_RENEGOTIATION":262144,"SSL_OP_CIPHER_SERVER_PREFERENCE":4194304,"SSL_OP_CISCO_ANYCONNECT":32768,"SSL_OP_COOKIE_EXCHANGE":8192,"SSL_OP_CRYPTOPRO_TLSEXT_BUG":2147483648,"SSL_OP_DONT_INSERT_EMPTY_FRAGMENTS":2048,"SSL_OP_EPHEMERAL_RSA":0,"SSL_OP_LEGACY_SERVER_CONNECT":4,"SSL_OP_MICROSOFT_BIG_SSLV3_BUFFER":32,"SSL_OP_MICROSOFT_SESS_ID_BUG":1,"SSL_OP_MSIE_SSLV2_RSA_PADDING":0,"SSL_OP_NETSCAPE_CA_DN_BUG":536870912,"SSL_OP_NETSCAPE_CHALLENGE_BUG":2,"SSL_OP_NETSCAPE_DEMO_CIPHER_CHANGE_BUG":1073741824,"SSL_OP_NETSCAPE_REUSE_CIPHER_CHANGE_BUG":8,"SSL_OP_NO_COMPRESSION":131072,"SSL_OP_NO_QUERY_MTU":4096,"SSL_OP_NO_SESSION_RESUMPTION_ON_RENEGOTIATION":65536,"SSL_OP_NO_SSLv2":16777216,"SSL_OP_NO_SSLv3":33554432,"SSL_OP_NO_TICKET":16384,"SSL_OP_NO_TLSv1":67108864,"SSL_OP_NO_TLSv1_1":268435456,"SSL_OP_NO_TLSv1_2":134217728,"SSL_OP_PKCS1_CHECK_1":0,"SSL_OP_PKCS1_CHECK_2":0,"SSL_OP_SINGLE_DH_USE":1048576,"SSL_OP_SINGLE_ECDH_USE":524288,"SSL_OP_SSLEAY_080_CLIENT_DH_BUG":128,"SSL_OP_SSLREF2_REUSE_CERT_TYPE_BUG":0,"SSL_OP_TLS_BLOCK_PADDING_BUG":512,"SSL_OP_TLS_D5_BUG":256,"SSL_OP_TLS_ROLLBACK_BUG":8388608,"ENGINE_METHOD_DSA":2,"ENGINE_METHOD_DH":4,"ENGINE_METHOD_RAND":8,"ENGINE_METHOD_ECDH":16,"ENGINE_METHOD_ECDSA":32,"ENGINE_METHOD_CIPHERS":64,"ENGINE_METHOD_DIGESTS":128,"ENGINE_METHOD_STORE":256,"ENGINE_METHOD_PKEY_METHS":512,"ENGINE_METHOD_PKEY_ASN1_METHS":1024,"ENGINE_METHOD_ALL":65535,"ENGINE_METHOD_NONE":0,"DH_CHECK_P_NOT_SAFE_PRIME":2,"DH_CHECK_P_NOT_PRIME":1,"DH_UNABLE_TO_CHECK_GENERATOR":4,"DH_NOT_SUITABLE_GENERATOR":8,"NPN_ENABLED":1,"RSA_PKCS1_PADDING":1,"RSA_SSLV23_PADDING":2,"RSA_NO_PADDING":3,"RSA_PKCS1_OAEP_PADDING":4,"RSA_X931_PADDING":5,"RSA_PKCS1_PSS_PADDING":6,"POINT_CONVERSION_COMPRESSED":2,"POINT_CONVERSION_UNCOMPRESSED":4,"POINT_CONVERSION_HYBRID":6,"F_OK":0,"R_OK":4,"W_OK":2,"X_OK":1,"UV_UDP_REUSEADDR":4}

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('div',{ref:"contBg",staticClass:"error-bg"},[_c('div',{attrs:{"data-dimension":""}},[_vm._v("404 ")])]),_vm._v(" "),_c('div',{staticClass:"link-cont"},[_c('p',[_vm._v("Fly to another city:")]),_vm._v(" "),_c('h3',[_c('router-link',{attrs:{"data-mouse":"","data-mouse-attractionState":"disactive","data-hover-type":"fadeout","to":("/" + _vm.city)}},[_vm._v("\n        "+_vm._s(_vm.city)+"\n      ")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddFace_vue__ = __webpack_require__(264);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8661adc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddFace_vue__ = __webpack_require__(632);
function injectStyle (ssrContext) {
  __webpack_require__(631)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e8661adc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddFace_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8661adc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddFace_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"src":"/addyourface/index.html","frameborder":"0","allow":"camera"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingError_vue__ = __webpack_require__(265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e61b1b6c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingError_vue__ = __webpack_require__(635);
function injectStyle (ssrContext) {
  __webpack_require__(634)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e61b1b6c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingError_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e61b1b6c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingError_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"loadingError"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',{attrs:{"data-anim":"text"}},[_c('span',[_vm._v("Blow on the cartridge and "),_c('b',{staticClass:"reload",on:{"click":_vm.reload}},[_vm._v("reload")]),_vm._v(", it always works.")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"adorasmile",attrs:{"data-anim":"text"}},[_c('span',[_vm._v("\n      :\\\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{attrs:{"data-anim":"text"}},[_c('span',[_vm._v("Owopss! Something went wrong loading the page.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[268]);


// WEBPACK FOOTER //
// static/js/app.b3209033270955941c24.js